/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/**
 * @popperjs/core v2.11.8 - MIT License
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).Popper={})}(this,(function(e){"use strict";function t(e){if(null==e)return window;if("[object Window]"!==e.toString()){var t=e.ownerDocument;return t&&t.defaultView||window}return e}function n(e){return e instanceof t(e).Element||e instanceof Element}function r(e){return e instanceof t(e).HTMLElement||e instanceof HTMLElement}function o(e){return"undefined"!=typeof ShadowRoot&&(e instanceof t(e).ShadowRoot||e instanceof ShadowRoot)}var i=Math.max,a=Math.min,s=Math.round;function f(){var e=navigator.userAgentData;return null!=e&&e.brands&&Array.isArray(e.brands)?e.brands.map((function(e){return e.brand+"/"+e.version})).join(" "):navigator.userAgent}function c(){return!/^((?!chrome|android).)*safari/i.test(f())}function p(e,o,i){void 0===o&&(o=!1),void 0===i&&(i=!1);var a=e.getBoundingClientRect(),f=1,p=1;o&&r(e)&&(f=e.offsetWidth>0&&s(a.width)/e.offsetWidth||1,p=e.offsetHeight>0&&s(a.height)/e.offsetHeight||1);var u=(n(e)?t(e):window).visualViewport,l=!c()&&i,d=(a.left+(l&&u?u.offsetLeft:0))/f,h=(a.top+(l&&u?u.offsetTop:0))/p,m=a.width/f,v=a.height/p;return{width:m,height:v,top:h,right:d+m,bottom:h+v,left:d,x:d,y:h}}function u(e){var n=t(e);return{scrollLeft:n.pageXOffset,scrollTop:n.pageYOffset}}function l(e){return e?(e.nodeName||"").toLowerCase():null}function d(e){return((n(e)?e.ownerDocument:e.document)||window.document).documentElement}function h(e){return p(d(e)).left+u(e).scrollLeft}function m(e){return t(e).getComputedStyle(e)}function v(e){var t=m(e),n=t.overflow,r=t.overflowX,o=t.overflowY;return/auto|scroll|overlay|hidden/.test(n+o+r)}function y(e,n,o){void 0===o&&(o=!1);var i,a,f=r(n),c=r(n)&&function(e){var t=e.getBoundingClientRect(),n=s(t.width)/e.offsetWidth||1,r=s(t.height)/e.offsetHeight||1;return 1!==n||1!==r}(n),m=d(n),y=p(e,c,o),g={scrollLeft:0,scrollTop:0},b={x:0,y:0};return(f||!f&&!o)&&(("body"!==l(n)||v(m))&&(g=(i=n)!==t(i)&&r(i)?{scrollLeft:(a=i).scrollLeft,scrollTop:a.scrollTop}:u(i)),r(n)?((b=p(n,!0)).x+=n.clientLeft,b.y+=n.clientTop):m&&(b.x=h(m))),{x:y.left+g.scrollLeft-b.x,y:y.top+g.scrollTop-b.y,width:y.width,height:y.height}}function g(e){var t=p(e),n=e.offsetWidth,r=e.offsetHeight;return Math.abs(t.width-n)<=1&&(n=t.width),Math.abs(t.height-r)<=1&&(r=t.height),{x:e.offsetLeft,y:e.offsetTop,width:n,height:r}}function b(e){return"html"===l(e)?e:e.assignedSlot||e.parentNode||(o(e)?e.host:null)||d(e)}function x(e){return["html","body","#document"].indexOf(l(e))>=0?e.ownerDocument.body:r(e)&&v(e)?e:x(b(e))}function w(e,n){var r;void 0===n&&(n=[]);var o=x(e),i=o===(null==(r=e.ownerDocument)?void 0:r.body),a=t(o),s=i?[a].concat(a.visualViewport||[],v(o)?o:[]):o,f=n.concat(s);return i?f:f.concat(w(b(s)))}function O(e){return["table","td","th"].indexOf(l(e))>=0}function j(e){return r(e)&&"fixed"!==m(e).position?e.offsetParent:null}function E(e){for(var n=t(e),i=j(e);i&&O(i)&&"static"===m(i).position;)i=j(i);return i&&("html"===l(i)||"body"===l(i)&&"static"===m(i).position)?n:i||function(e){var t=/firefox/i.test(f());if(/Trident/i.test(f())&&r(e)&&"fixed"===m(e).position)return null;var n=b(e);for(o(n)&&(n=n.host);r(n)&&["html","body"].indexOf(l(n))<0;){var i=m(n);if("none"!==i.transform||"none"!==i.perspective||"paint"===i.contain||-1!==["transform","perspective"].indexOf(i.willChange)||t&&"filter"===i.willChange||t&&i.filter&&"none"!==i.filter)return n;n=n.parentNode}return null}(e)||n}var D="top",A="bottom",L="right",P="left",M="auto",k=[D,A,L,P],W="start",B="end",H="viewport",T="popper",R=k.reduce((function(e,t){return e.concat([t+"-"+W,t+"-"+B])}),[]),S=[].concat(k,[M]).reduce((function(e,t){return e.concat([t,t+"-"+W,t+"-"+B])}),[]),V=["beforeRead","read","afterRead","beforeMain","main","afterMain","beforeWrite","write","afterWrite"];function q(e){var t=new Map,n=new Set,r=[];function o(e){n.add(e.name),[].concat(e.requires||[],e.requiresIfExists||[]).forEach((function(e){if(!n.has(e)){var r=t.get(e);r&&o(r)}})),r.push(e)}return e.forEach((function(e){t.set(e.name,e)})),e.forEach((function(e){n.has(e.name)||o(e)})),r}function C(e,t){var n=t.getRootNode&&t.getRootNode();if(e.contains(t))return!0;if(n&&o(n)){var r=t;do{if(r&&e.isSameNode(r))return!0;r=r.parentNode||r.host}while(r)}return!1}function N(e){return Object.assign({},e,{left:e.x,top:e.y,right:e.x+e.width,bottom:e.y+e.height})}function I(e,r,o){return r===H?N(function(e,n){var r=t(e),o=d(e),i=r.visualViewport,a=o.clientWidth,s=o.clientHeight,f=0,p=0;if(i){a=i.width,s=i.height;var u=c();(u||!u&&"fixed"===n)&&(f=i.offsetLeft,p=i.offsetTop)}return{width:a,height:s,x:f+h(e),y:p}}(e,o)):n(r)?function(e,t){var n=p(e,!1,"fixed"===t);return n.top=n.top+e.clientTop,n.left=n.left+e.clientLeft,n.bottom=n.top+e.clientHeight,n.right=n.left+e.clientWidth,n.width=e.clientWidth,n.height=e.clientHeight,n.x=n.left,n.y=n.top,n}(r,o):N(function(e){var t,n=d(e),r=u(e),o=null==(t=e.ownerDocument)?void 0:t.body,a=i(n.scrollWidth,n.clientWidth,o?o.scrollWidth:0,o?o.clientWidth:0),s=i(n.scrollHeight,n.clientHeight,o?o.scrollHeight:0,o?o.clientHeight:0),f=-r.scrollLeft+h(e),c=-r.scrollTop;return"rtl"===m(o||n).direction&&(f+=i(n.clientWidth,o?o.clientWidth:0)-a),{width:a,height:s,x:f,y:c}}(d(e)))}function _(e,t,o,s){var f="clippingParents"===t?function(e){var t=w(b(e)),o=["absolute","fixed"].indexOf(m(e).position)>=0&&r(e)?E(e):e;return n(o)?t.filter((function(e){return n(e)&&C(e,o)&&"body"!==l(e)})):[]}(e):[].concat(t),c=[].concat(f,[o]),p=c[0],u=c.reduce((function(t,n){var r=I(e,n,s);return t.top=i(r.top,t.top),t.right=a(r.right,t.right),t.bottom=a(r.bottom,t.bottom),t.left=i(r.left,t.left),t}),I(e,p,s));return u.width=u.right-u.left,u.height=u.bottom-u.top,u.x=u.left,u.y=u.top,u}function F(e){return e.split("-")[0]}function U(e){return e.split("-")[1]}function z(e){return["top","bottom"].indexOf(e)>=0?"x":"y"}function X(e){var t,n=e.reference,r=e.element,o=e.placement,i=o?F(o):null,a=o?U(o):null,s=n.x+n.width/2-r.width/2,f=n.y+n.height/2-r.height/2;switch(i){case D:t={x:s,y:n.y-r.height};break;case A:t={x:s,y:n.y+n.height};break;case L:t={x:n.x+n.width,y:f};break;case P:t={x:n.x-r.width,y:f};break;default:t={x:n.x,y:n.y}}var c=i?z(i):null;if(null!=c){var p="y"===c?"height":"width";switch(a){case W:t[c]=t[c]-(n[p]/2-r[p]/2);break;case B:t[c]=t[c]+(n[p]/2-r[p]/2)}}return t}function Y(e){return Object.assign({},{top:0,right:0,bottom:0,left:0},e)}function G(e,t){return t.reduce((function(t,n){return t[n]=e,t}),{})}function J(e,t){void 0===t&&(t={});var r=t,o=r.placement,i=void 0===o?e.placement:o,a=r.strategy,s=void 0===a?e.strategy:a,f=r.boundary,c=void 0===f?"clippingParents":f,u=r.rootBoundary,l=void 0===u?H:u,h=r.elementContext,m=void 0===h?T:h,v=r.altBoundary,y=void 0!==v&&v,g=r.padding,b=void 0===g?0:g,x=Y("number"!=typeof b?b:G(b,k)),w=m===T?"reference":T,O=e.rects.popper,j=e.elements[y?w:m],E=_(n(j)?j:j.contextElement||d(e.elements.popper),c,l,s),P=p(e.elements.reference),M=X({reference:P,element:O,strategy:"absolute",placement:i}),W=N(Object.assign({},O,M)),B=m===T?W:P,R={top:E.top-B.top+x.top,bottom:B.bottom-E.bottom+x.bottom,left:E.left-B.left+x.left,right:B.right-E.right+x.right},S=e.modifiersData.offset;if(m===T&&S){var V=S[i];Object.keys(R).forEach((function(e){var t=[L,A].indexOf(e)>=0?1:-1,n=[D,A].indexOf(e)>=0?"y":"x";R[e]+=V[n]*t}))}return R}var K={placement:"bottom",modifiers:[],strategy:"absolute"};function Q(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return!t.some((function(e){return!(e&&"function"==typeof e.getBoundingClientRect)}))}function Z(e){void 0===e&&(e={});var t=e,r=t.defaultModifiers,o=void 0===r?[]:r,i=t.defaultOptions,a=void 0===i?K:i;return function(e,t,r){void 0===r&&(r=a);var i,s,f={placement:"bottom",orderedModifiers:[],options:Object.assign({},K,a),modifiersData:{},elements:{reference:e,popper:t},attributes:{},styles:{}},c=[],p=!1,u={state:f,setOptions:function(r){var i="function"==typeof r?r(f.options):r;l(),f.options=Object.assign({},a,f.options,i),f.scrollParents={reference:n(e)?w(e):e.contextElement?w(e.contextElement):[],popper:w(t)};var s,p,d=function(e){var t=q(e);return V.reduce((function(e,n){return e.concat(t.filter((function(e){return e.phase===n})))}),[])}((s=[].concat(o,f.options.modifiers),p=s.reduce((function(e,t){var n=e[t.name];return e[t.name]=n?Object.assign({},n,t,{options:Object.assign({},n.options,t.options),data:Object.assign({},n.data,t.data)}):t,e}),{}),Object.keys(p).map((function(e){return p[e]}))));return f.orderedModifiers=d.filter((function(e){return e.enabled})),f.orderedModifiers.forEach((function(e){var t=e.name,n=e.options,r=void 0===n?{}:n,o=e.effect;if("function"==typeof o){var i=o({state:f,name:t,instance:u,options:r}),a=function(){};c.push(i||a)}})),u.update()},forceUpdate:function(){if(!p){var e=f.elements,t=e.reference,n=e.popper;if(Q(t,n)){f.rects={reference:y(t,E(n),"fixed"===f.options.strategy),popper:g(n)},f.reset=!1,f.placement=f.options.placement,f.orderedModifiers.forEach((function(e){return f.modifiersData[e.name]=Object.assign({},e.data)}));for(var r=0;r<f.orderedModifiers.length;r++)if(!0!==f.reset){var o=f.orderedModifiers[r],i=o.fn,a=o.options,s=void 0===a?{}:a,c=o.name;"function"==typeof i&&(f=i({state:f,options:s,name:c,instance:u})||f)}else f.reset=!1,r=-1}}},update:(i=function(){return new Promise((function(e){u.forceUpdate(),e(f)}))},function(){return s||(s=new Promise((function(e){Promise.resolve().then((function(){s=void 0,e(i())}))}))),s}),destroy:function(){l(),p=!0}};if(!Q(e,t))return u;function l(){c.forEach((function(e){return e()})),c=[]}return u.setOptions(r).then((function(e){!p&&r.onFirstUpdate&&r.onFirstUpdate(e)})),u}}var $={passive:!0};var ee={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(e){var n=e.state,r=e.instance,o=e.options,i=o.scroll,a=void 0===i||i,s=o.resize,f=void 0===s||s,c=t(n.elements.popper),p=[].concat(n.scrollParents.reference,n.scrollParents.popper);return a&&p.forEach((function(e){e.addEventListener("scroll",r.update,$)})),f&&c.addEventListener("resize",r.update,$),function(){a&&p.forEach((function(e){e.removeEventListener("scroll",r.update,$)})),f&&c.removeEventListener("resize",r.update,$)}},data:{}};var te={name:"popperOffsets",enabled:!0,phase:"read",fn:function(e){var t=e.state,n=e.name;t.modifiersData[n]=X({reference:t.rects.reference,element:t.rects.popper,strategy:"absolute",placement:t.placement})},data:{}},ne={top:"auto",right:"auto",bottom:"auto",left:"auto"};function re(e){var n,r=e.popper,o=e.popperRect,i=e.placement,a=e.variation,f=e.offsets,c=e.position,p=e.gpuAcceleration,u=e.adaptive,l=e.roundOffsets,h=e.isFixed,v=f.x,y=void 0===v?0:v,g=f.y,b=void 0===g?0:g,x="function"==typeof l?l({x:y,y:b}):{x:y,y:b};y=x.x,b=x.y;var w=f.hasOwnProperty("x"),O=f.hasOwnProperty("y"),j=P,M=D,k=window;if(u){var W=E(r),H="clientHeight",T="clientWidth";if(W===t(r)&&"static"!==m(W=d(r)).position&&"absolute"===c&&(H="scrollHeight",T="scrollWidth"),W=W,i===D||(i===P||i===L)&&a===B)M=A,b-=(h&&W===k&&k.visualViewport?k.visualViewport.height:W[H])-o.height,b*=p?1:-1;if(i===P||(i===D||i===A)&&a===B)j=L,y-=(h&&W===k&&k.visualViewport?k.visualViewport.width:W[T])-o.width,y*=p?1:-1}var R,S=Object.assign({position:c},u&&ne),V=!0===l?function(e,t){var n=e.x,r=e.y,o=t.devicePixelRatio||1;return{x:s(n*o)/o||0,y:s(r*o)/o||0}}({x:y,y:b},t(r)):{x:y,y:b};return y=V.x,b=V.y,p?Object.assign({},S,((R={})[M]=O?"0":"",R[j]=w?"0":"",R.transform=(k.devicePixelRatio||1)<=1?"translate("+y+"px, "+b+"px)":"translate3d("+y+"px, "+b+"px, 0)",R)):Object.assign({},S,((n={})[M]=O?b+"px":"",n[j]=w?y+"px":"",n.transform="",n))}var oe={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(e){var t=e.state,n=e.options,r=n.gpuAcceleration,o=void 0===r||r,i=n.adaptive,a=void 0===i||i,s=n.roundOffsets,f=void 0===s||s,c={placement:F(t.placement),variation:U(t.placement),popper:t.elements.popper,popperRect:t.rects.popper,gpuAcceleration:o,isFixed:"fixed"===t.options.strategy};null!=t.modifiersData.popperOffsets&&(t.styles.popper=Object.assign({},t.styles.popper,re(Object.assign({},c,{offsets:t.modifiersData.popperOffsets,position:t.options.strategy,adaptive:a,roundOffsets:f})))),null!=t.modifiersData.arrow&&(t.styles.arrow=Object.assign({},t.styles.arrow,re(Object.assign({},c,{offsets:t.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:f})))),t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-placement":t.placement})},data:{}};var ie={name:"applyStyles",enabled:!0,phase:"write",fn:function(e){var t=e.state;Object.keys(t.elements).forEach((function(e){var n=t.styles[e]||{},o=t.attributes[e]||{},i=t.elements[e];r(i)&&l(i)&&(Object.assign(i.style,n),Object.keys(o).forEach((function(e){var t=o[e];!1===t?i.removeAttribute(e):i.setAttribute(e,!0===t?"":t)})))}))},effect:function(e){var t=e.state,n={popper:{position:t.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(t.elements.popper.style,n.popper),t.styles=n,t.elements.arrow&&Object.assign(t.elements.arrow.style,n.arrow),function(){Object.keys(t.elements).forEach((function(e){var o=t.elements[e],i=t.attributes[e]||{},a=Object.keys(t.styles.hasOwnProperty(e)?t.styles[e]:n[e]).reduce((function(e,t){return e[t]="",e}),{});r(o)&&l(o)&&(Object.assign(o.style,a),Object.keys(i).forEach((function(e){o.removeAttribute(e)})))}))}},requires:["computeStyles"]};var ae={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.offset,i=void 0===o?[0,0]:o,a=S.reduce((function(e,n){return e[n]=function(e,t,n){var r=F(e),o=[P,D].indexOf(r)>=0?-1:1,i="function"==typeof n?n(Object.assign({},t,{placement:e})):n,a=i[0],s=i[1];return a=a||0,s=(s||0)*o,[P,L].indexOf(r)>=0?{x:s,y:a}:{x:a,y:s}}(n,t.rects,i),e}),{}),s=a[t.placement],f=s.x,c=s.y;null!=t.modifiersData.popperOffsets&&(t.modifiersData.popperOffsets.x+=f,t.modifiersData.popperOffsets.y+=c),t.modifiersData[r]=a}},se={left:"right",right:"left",bottom:"top",top:"bottom"};function fe(e){return e.replace(/left|right|bottom|top/g,(function(e){return se[e]}))}var ce={start:"end",end:"start"};function pe(e){return e.replace(/start|end/g,(function(e){return ce[e]}))}function ue(e,t){void 0===t&&(t={});var n=t,r=n.placement,o=n.boundary,i=n.rootBoundary,a=n.padding,s=n.flipVariations,f=n.allowedAutoPlacements,c=void 0===f?S:f,p=U(r),u=p?s?R:R.filter((function(e){return U(e)===p})):k,l=u.filter((function(e){return c.indexOf(e)>=0}));0===l.length&&(l=u);var d=l.reduce((function(t,n){return t[n]=J(e,{placement:n,boundary:o,rootBoundary:i,padding:a})[F(n)],t}),{});return Object.keys(d).sort((function(e,t){return d[e]-d[t]}))}var le={name:"flip",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name;if(!t.modifiersData[r]._skip){for(var o=n.mainAxis,i=void 0===o||o,a=n.altAxis,s=void 0===a||a,f=n.fallbackPlacements,c=n.padding,p=n.boundary,u=n.rootBoundary,l=n.altBoundary,d=n.flipVariations,h=void 0===d||d,m=n.allowedAutoPlacements,v=t.options.placement,y=F(v),g=f||(y===v||!h?[fe(v)]:function(e){if(F(e)===M)return[];var t=fe(e);return[pe(e),t,pe(t)]}(v)),b=[v].concat(g).reduce((function(e,n){return e.concat(F(n)===M?ue(t,{placement:n,boundary:p,rootBoundary:u,padding:c,flipVariations:h,allowedAutoPlacements:m}):n)}),[]),x=t.rects.reference,w=t.rects.popper,O=new Map,j=!0,E=b[0],k=0;k<b.length;k++){var B=b[k],H=F(B),T=U(B)===W,R=[D,A].indexOf(H)>=0,S=R?"width":"height",V=J(t,{placement:B,boundary:p,rootBoundary:u,altBoundary:l,padding:c}),q=R?T?L:P:T?A:D;x[S]>w[S]&&(q=fe(q));var C=fe(q),N=[];if(i&&N.push(V[H]<=0),s&&N.push(V[q]<=0,V[C]<=0),N.every((function(e){return e}))){E=B,j=!1;break}O.set(B,N)}if(j)for(var I=function(e){var t=b.find((function(t){var n=O.get(t);if(n)return n.slice(0,e).every((function(e){return e}))}));if(t)return E=t,"break"},_=h?3:1;_>0;_--){if("break"===I(_))break}t.placement!==E&&(t.modifiersData[r]._skip=!0,t.placement=E,t.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}};function de(e,t,n){return i(e,a(t,n))}var he={name:"preventOverflow",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.mainAxis,s=void 0===o||o,f=n.altAxis,c=void 0!==f&&f,p=n.boundary,u=n.rootBoundary,l=n.altBoundary,d=n.padding,h=n.tether,m=void 0===h||h,v=n.tetherOffset,y=void 0===v?0:v,b=J(t,{boundary:p,rootBoundary:u,padding:d,altBoundary:l}),x=F(t.placement),w=U(t.placement),O=!w,j=z(x),M="x"===j?"y":"x",k=t.modifiersData.popperOffsets,B=t.rects.reference,H=t.rects.popper,T="function"==typeof y?y(Object.assign({},t.rects,{placement:t.placement})):y,R="number"==typeof T?{mainAxis:T,altAxis:T}:Object.assign({mainAxis:0,altAxis:0},T),S=t.modifiersData.offset?t.modifiersData.offset[t.placement]:null,V={x:0,y:0};if(k){if(s){var q,C="y"===j?D:P,N="y"===j?A:L,I="y"===j?"height":"width",_=k[j],X=_+b[C],Y=_-b[N],G=m?-H[I]/2:0,K=w===W?B[I]:H[I],Q=w===W?-H[I]:-B[I],Z=t.elements.arrow,$=m&&Z?g(Z):{width:0,height:0},ee=t.modifiersData["arrow#persistent"]?t.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0},te=ee[C],ne=ee[N],re=de(0,B[I],$[I]),oe=O?B[I]/2-G-re-te-R.mainAxis:K-re-te-R.mainAxis,ie=O?-B[I]/2+G+re+ne+R.mainAxis:Q+re+ne+R.mainAxis,ae=t.elements.arrow&&E(t.elements.arrow),se=ae?"y"===j?ae.clientTop||0:ae.clientLeft||0:0,fe=null!=(q=null==S?void 0:S[j])?q:0,ce=_+ie-fe,pe=de(m?a(X,_+oe-fe-se):X,_,m?i(Y,ce):Y);k[j]=pe,V[j]=pe-_}if(c){var ue,le="x"===j?D:P,he="x"===j?A:L,me=k[M],ve="y"===M?"height":"width",ye=me+b[le],ge=me-b[he],be=-1!==[D,P].indexOf(x),xe=null!=(ue=null==S?void 0:S[M])?ue:0,we=be?ye:me-B[ve]-H[ve]-xe+R.altAxis,Oe=be?me+B[ve]+H[ve]-xe-R.altAxis:ge,je=m&&be?function(e,t,n){var r=de(e,t,n);return r>n?n:r}(we,me,Oe):de(m?we:ye,me,m?Oe:ge);k[M]=je,V[M]=je-me}t.modifiersData[r]=V}},requiresIfExists:["offset"]};var me={name:"arrow",enabled:!0,phase:"main",fn:function(e){var t,n=e.state,r=e.name,o=e.options,i=n.elements.arrow,a=n.modifiersData.popperOffsets,s=F(n.placement),f=z(s),c=[P,L].indexOf(s)>=0?"height":"width";if(i&&a){var p=function(e,t){return Y("number"!=typeof(e="function"==typeof e?e(Object.assign({},t.rects,{placement:t.placement})):e)?e:G(e,k))}(o.padding,n),u=g(i),l="y"===f?D:P,d="y"===f?A:L,h=n.rects.reference[c]+n.rects.reference[f]-a[f]-n.rects.popper[c],m=a[f]-n.rects.reference[f],v=E(i),y=v?"y"===f?v.clientHeight||0:v.clientWidth||0:0,b=h/2-m/2,x=p[l],w=y-u[c]-p[d],O=y/2-u[c]/2+b,j=de(x,O,w),M=f;n.modifiersData[r]=((t={})[M]=j,t.centerOffset=j-O,t)}},effect:function(e){var t=e.state,n=e.options.element,r=void 0===n?"[data-popper-arrow]":n;null!=r&&("string"!=typeof r||(r=t.elements.popper.querySelector(r)))&&C(t.elements.popper,r)&&(t.elements.arrow=r)},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function ve(e,t,n){return void 0===n&&(n={x:0,y:0}),{top:e.top-t.height-n.y,right:e.right-t.width+n.x,bottom:e.bottom-t.height+n.y,left:e.left-t.width-n.x}}function ye(e){return[D,L,A,P].some((function(t){return e[t]>=0}))}var ge={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(e){var t=e.state,n=e.name,r=t.rects.reference,o=t.rects.popper,i=t.modifiersData.preventOverflow,a=J(t,{elementContext:"reference"}),s=J(t,{altBoundary:!0}),f=ve(a,r),c=ve(s,o,i),p=ye(f),u=ye(c);t.modifiersData[n]={referenceClippingOffsets:f,popperEscapeOffsets:c,isReferenceHidden:p,hasPopperEscaped:u},t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-reference-hidden":p,"data-popper-escaped":u})}},be=Z({defaultModifiers:[ee,te,oe,ie]}),xe=[ee,te,oe,ie,ae,le,he,me,ge],we=Z({defaultModifiers:xe});e.applyStyles=ie,e.arrow=me,e.computeStyles=oe,e.createPopper=we,e.createPopperLite=be,e.defaultModifiers=xe,e.detectOverflow=J,e.eventListeners=ee,e.flip=le,e.hide=ge,e.offset=ae,e.popperGenerator=Z,e.popperOffsets=te,e.preventOverflow=he,Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=popper.min.js.map

/*!
  * Bootstrap v5.3.6 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap=e()}(this,(function(){"use strict";const t=new Map,e={set(e,i,n){t.has(e)||t.set(e,new Map);const s=t.get(e);s.has(i)||0===s.size?s.set(i,n):console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(s.keys())[0]}.`)},get:(e,i)=>t.has(e)&&t.get(e).get(i)||null,remove(e,i){if(!t.has(e))return;const n=t.get(e);n.delete(i),0===n.size&&t.delete(e)}},i="transitionend",n=t=>(t&&window.CSS&&window.CSS.escape&&(t=t.replace(/#([^\s"#']+)/g,((t,e)=>`#${CSS.escape(e)}`))),t),s=t=>{t.dispatchEvent(new Event(i))},o=t=>!(!t||"object"!=typeof t)&&(void 0!==t.jquery&&(t=t[0]),void 0!==t.nodeType),r=t=>o(t)?t.jquery?t[0]:t:"string"==typeof t&&t.length>0?document.querySelector(n(t)):null,a=t=>{if(!o(t)||0===t.getClientRects().length)return!1;const e="visible"===getComputedStyle(t).getPropertyValue("visibility"),i=t.closest("details:not([open])");if(!i)return e;if(i!==t){const e=t.closest("summary");if(e&&e.parentNode!==i)return!1;if(null===e)return!1}return e},l=t=>!t||t.nodeType!==Node.ELEMENT_NODE||!!t.classList.contains("disabled")||(void 0!==t.disabled?t.disabled:t.hasAttribute("disabled")&&"false"!==t.getAttribute("disabled")),c=t=>{if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){const e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?c(t.parentNode):null},h=()=>{},d=t=>{t.offsetHeight},u=()=>window.jQuery&&!document.body.hasAttribute("data-bs-no-jquery")?window.jQuery:null,f=[],p=()=>"rtl"===document.documentElement.dir,m=t=>{var e;e=()=>{const e=u();if(e){const i=t.NAME,n=e.fn[i];e.fn[i]=t.jQueryInterface,e.fn[i].Constructor=t,e.fn[i].noConflict=()=>(e.fn[i]=n,t.jQueryInterface)}},"loading"===document.readyState?(f.length||document.addEventListener("DOMContentLoaded",(()=>{for(const t of f)t()})),f.push(e)):e()},g=(t,e=[],i=t)=>"function"==typeof t?t.call(...e):i,_=(t,e,n=!0)=>{if(!n)return void g(t);const o=(t=>{if(!t)return 0;let{transitionDuration:e,transitionDelay:i}=window.getComputedStyle(t);const n=Number.parseFloat(e),s=Number.parseFloat(i);return n||s?(e=e.split(",")[0],i=i.split(",")[0],1e3*(Number.parseFloat(e)+Number.parseFloat(i))):0})(e)+5;let r=!1;const a=({target:n})=>{n===e&&(r=!0,e.removeEventListener(i,a),g(t))};e.addEventListener(i,a),setTimeout((()=>{r||s(e)}),o)},b=(t,e,i,n)=>{const s=t.length;let o=t.indexOf(e);return-1===o?!i&&n?t[s-1]:t[0]:(o+=i?1:-1,n&&(o=(o+s)%s),t[Math.max(0,Math.min(o,s-1))])},v=/[^.]*(?=\..*)\.|.*/,y=/\..*/,w=/::\d+$/,A={};let E=1;const T={mouseenter:"mouseover",mouseleave:"mouseout"},C=new Set(["click","dblclick","mouseup","mousedown","contextmenu","mousewheel","DOMMouseScroll","mouseover","mouseout","mousemove","selectstart","selectend","keydown","keypress","keyup","orientationchange","touchstart","touchmove","touchend","touchcancel","pointerdown","pointermove","pointerup","pointerleave","pointercancel","gesturestart","gesturechange","gestureend","focus","blur","change","reset","select","submit","focusin","focusout","load","unload","beforeunload","resize","move","DOMContentLoaded","readystatechange","error","abort","scroll"]);function O(t,e){return e&&`${e}::${E++}`||t.uidEvent||E++}function x(t){const e=O(t);return t.uidEvent=e,A[e]=A[e]||{},A[e]}function k(t,e,i=null){return Object.values(t).find((t=>t.callable===e&&t.delegationSelector===i))}function L(t,e,i){const n="string"==typeof e,s=n?i:e||i;let o=I(t);return C.has(o)||(o=t),[n,s,o]}function S(t,e,i,n,s){if("string"!=typeof e||!t)return;let[o,r,a]=L(e,i,n);if(e in T){const t=t=>function(e){if(!e.relatedTarget||e.relatedTarget!==e.delegateTarget&&!e.delegateTarget.contains(e.relatedTarget))return t.call(this,e)};r=t(r)}const l=x(t),c=l[a]||(l[a]={}),h=k(c,r,o?i:null);if(h)return void(h.oneOff=h.oneOff&&s);const d=O(r,e.replace(v,"")),u=o?function(t,e,i){return function n(s){const o=t.querySelectorAll(e);for(let{target:r}=s;r&&r!==this;r=r.parentNode)for(const a of o)if(a===r)return P(s,{delegateTarget:r}),n.oneOff&&N.off(t,s.type,e,i),i.apply(r,[s])}}(t,i,r):function(t,e){return function i(n){return P(n,{delegateTarget:t}),i.oneOff&&N.off(t,n.type,e),e.apply(t,[n])}}(t,r);u.delegationSelector=o?i:null,u.callable=r,u.oneOff=s,u.uidEvent=d,c[d]=u,t.addEventListener(a,u,o)}function D(t,e,i,n,s){const o=k(e[i],n,s);o&&(t.removeEventListener(i,o,Boolean(s)),delete e[i][o.uidEvent])}function $(t,e,i,n){const s=e[i]||{};for(const[o,r]of Object.entries(s))o.includes(n)&&D(t,e,i,r.callable,r.delegationSelector)}function I(t){return t=t.replace(y,""),T[t]||t}const N={on(t,e,i,n){S(t,e,i,n,!1)},one(t,e,i,n){S(t,e,i,n,!0)},off(t,e,i,n){if("string"!=typeof e||!t)return;const[s,o,r]=L(e,i,n),a=r!==e,l=x(t),c=l[r]||{},h=e.startsWith(".");if(void 0===o){if(h)for(const i of Object.keys(l))$(t,l,i,e.slice(1));for(const[i,n]of Object.entries(c)){const s=i.replace(w,"");a&&!e.includes(s)||D(t,l,r,n.callable,n.delegationSelector)}}else{if(!Object.keys(c).length)return;D(t,l,r,o,s?i:null)}},trigger(t,e,i){if("string"!=typeof e||!t)return null;const n=u();let s=null,o=!0,r=!0,a=!1;e!==I(e)&&n&&(s=n.Event(e,i),n(t).trigger(s),o=!s.isPropagationStopped(),r=!s.isImmediatePropagationStopped(),a=s.isDefaultPrevented());const l=P(new Event(e,{bubbles:o,cancelable:!0}),i);return a&&l.preventDefault(),r&&t.dispatchEvent(l),l.defaultPrevented&&s&&s.preventDefault(),l}};function P(t,e={}){for(const[i,n]of Object.entries(e))try{t[i]=n}catch(e){Object.defineProperty(t,i,{configurable:!0,get:()=>n})}return t}function j(t){if("true"===t)return!0;if("false"===t)return!1;if(t===Number(t).toString())return Number(t);if(""===t||"null"===t)return null;if("string"!=typeof t)return t;try{return JSON.parse(decodeURIComponent(t))}catch(e){return t}}function M(t){return t.replace(/[A-Z]/g,(t=>`-${t.toLowerCase()}`))}const F={setDataAttribute(t,e,i){t.setAttribute(`data-bs-${M(e)}`,i)},removeDataAttribute(t,e){t.removeAttribute(`data-bs-${M(e)}`)},getDataAttributes(t){if(!t)return{};const e={},i=Object.keys(t.dataset).filter((t=>t.startsWith("bs")&&!t.startsWith("bsConfig")));for(const n of i){let i=n.replace(/^bs/,"");i=i.charAt(0).toLowerCase()+i.slice(1),e[i]=j(t.dataset[n])}return e},getDataAttribute:(t,e)=>j(t.getAttribute(`data-bs-${M(e)}`))};class H{static get Default(){return{}}static get DefaultType(){return{}}static get NAME(){throw new Error('You have to implement the static method "NAME", for each component!')}_getConfig(t){return t=this._mergeConfigObj(t),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}_configAfterMerge(t){return t}_mergeConfigObj(t,e){const i=o(e)?F.getDataAttribute(e,"config"):{};return{...this.constructor.Default,..."object"==typeof i?i:{},...o(e)?F.getDataAttributes(e):{},..."object"==typeof t?t:{}}}_typeCheckConfig(t,e=this.constructor.DefaultType){for(const[n,s]of Object.entries(e)){const e=t[n],r=o(e)?"element":null==(i=e)?`${i}`:Object.prototype.toString.call(i).match(/\s([a-z]+)/i)[1].toLowerCase();if(!new RegExp(s).test(r))throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${r}" but expected type "${s}".`)}var i}}class W extends H{constructor(t,i){super(),(t=r(t))&&(this._element=t,this._config=this._getConfig(i),e.set(this._element,this.constructor.DATA_KEY,this))}dispose(){e.remove(this._element,this.constructor.DATA_KEY),N.off(this._element,this.constructor.EVENT_KEY);for(const t of Object.getOwnPropertyNames(this))this[t]=null}_queueCallback(t,e,i=!0){_(t,e,i)}_getConfig(t){return t=this._mergeConfigObj(t,this._element),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}static getInstance(t){return e.get(r(t),this.DATA_KEY)}static getOrCreateInstance(t,e={}){return this.getInstance(t)||new this(t,"object"==typeof e?e:null)}static get VERSION(){return"5.3.6"}static get DATA_KEY(){return`bs.${this.NAME}`}static get EVENT_KEY(){return`.${this.DATA_KEY}`}static eventName(t){return`${t}${this.EVENT_KEY}`}}const B=t=>{let e=t.getAttribute("data-bs-target");if(!e||"#"===e){let i=t.getAttribute("href");if(!i||!i.includes("#")&&!i.startsWith("."))return null;i.includes("#")&&!i.startsWith("#")&&(i=`#${i.split("#")[1]}`),e=i&&"#"!==i?i.trim():null}return e?e.split(",").map((t=>n(t))).join(","):null},z={find:(t,e=document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e,t)),findOne:(t,e=document.documentElement)=>Element.prototype.querySelector.call(e,t),children:(t,e)=>[].concat(...t.children).filter((t=>t.matches(e))),parents(t,e){const i=[];let n=t.parentNode.closest(e);for(;n;)i.push(n),n=n.parentNode.closest(e);return i},prev(t,e){let i=t.previousElementSibling;for(;i;){if(i.matches(e))return[i];i=i.previousElementSibling}return[]},next(t,e){let i=t.nextElementSibling;for(;i;){if(i.matches(e))return[i];i=i.nextElementSibling}return[]},focusableChildren(t){const e=["a","button","input","textarea","select","details","[tabindex]",'[contenteditable="true"]'].map((t=>`${t}:not([tabindex^="-"])`)).join(",");return this.find(e,t).filter((t=>!l(t)&&a(t)))},getSelectorFromElement(t){const e=B(t);return e&&z.findOne(e)?e:null},getElementFromSelector(t){const e=B(t);return e?z.findOne(e):null},getMultipleElementsFromSelector(t){const e=B(t);return e?z.find(e):[]}},R=(t,e="hide")=>{const i=`click.dismiss${t.EVENT_KEY}`,n=t.NAME;N.on(document,i,`[data-bs-dismiss="${n}"]`,(function(i){if(["A","AREA"].includes(this.tagName)&&i.preventDefault(),l(this))return;const s=z.getElementFromSelector(this)||this.closest(`.${n}`);t.getOrCreateInstance(s)[e]()}))},q=".bs.alert",V=`close${q}`,K=`closed${q}`;class Q extends W{static get NAME(){return"alert"}close(){if(N.trigger(this._element,V).defaultPrevented)return;this._element.classList.remove("show");const t=this._element.classList.contains("fade");this._queueCallback((()=>this._destroyElement()),this._element,t)}_destroyElement(){this._element.remove(),N.trigger(this._element,K),this.dispose()}static jQueryInterface(t){return this.each((function(){const e=Q.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}R(Q,"close"),m(Q);const X='[data-bs-toggle="button"]';class Y extends W{static get NAME(){return"button"}toggle(){this._element.setAttribute("aria-pressed",this._element.classList.toggle("active"))}static jQueryInterface(t){return this.each((function(){const e=Y.getOrCreateInstance(this);"toggle"===t&&e[t]()}))}}N.on(document,"click.bs.button.data-api",X,(t=>{t.preventDefault();const e=t.target.closest(X);Y.getOrCreateInstance(e).toggle()})),m(Y);const U=".bs.swipe",G=`touchstart${U}`,J=`touchmove${U}`,Z=`touchend${U}`,tt=`pointerdown${U}`,et=`pointerup${U}`,it={endCallback:null,leftCallback:null,rightCallback:null},nt={endCallback:"(function|null)",leftCallback:"(function|null)",rightCallback:"(function|null)"};class st extends H{constructor(t,e){super(),this._element=t,t&&st.isSupported()&&(this._config=this._getConfig(e),this._deltaX=0,this._supportPointerEvents=Boolean(window.PointerEvent),this._initEvents())}static get Default(){return it}static get DefaultType(){return nt}static get NAME(){return"swipe"}dispose(){N.off(this._element,U)}_start(t){this._supportPointerEvents?this._eventIsPointerPenTouch(t)&&(this._deltaX=t.clientX):this._deltaX=t.touches[0].clientX}_end(t){this._eventIsPointerPenTouch(t)&&(this._deltaX=t.clientX-this._deltaX),this._handleSwipe(),g(this._config.endCallback)}_move(t){this._deltaX=t.touches&&t.touches.length>1?0:t.touches[0].clientX-this._deltaX}_handleSwipe(){const t=Math.abs(this._deltaX);if(t<=40)return;const e=t/this._deltaX;this._deltaX=0,e&&g(e>0?this._config.rightCallback:this._config.leftCallback)}_initEvents(){this._supportPointerEvents?(N.on(this._element,tt,(t=>this._start(t))),N.on(this._element,et,(t=>this._end(t))),this._element.classList.add("pointer-event")):(N.on(this._element,G,(t=>this._start(t))),N.on(this._element,J,(t=>this._move(t))),N.on(this._element,Z,(t=>this._end(t))))}_eventIsPointerPenTouch(t){return this._supportPointerEvents&&("pen"===t.pointerType||"touch"===t.pointerType)}static isSupported(){return"ontouchstart"in document.documentElement||navigator.maxTouchPoints>0}}const ot=".bs.carousel",rt=".data-api",at="ArrowLeft",lt="ArrowRight",ct="next",ht="prev",dt="left",ut="right",ft=`slide${ot}`,pt=`slid${ot}`,mt=`keydown${ot}`,gt=`mouseenter${ot}`,_t=`mouseleave${ot}`,bt=`dragstart${ot}`,vt=`load${ot}${rt}`,yt=`click${ot}${rt}`,wt="carousel",At="active",Et=".active",Tt=".carousel-item",Ct=Et+Tt,Ot={[at]:ut,[lt]:dt},xt={interval:5e3,keyboard:!0,pause:"hover",ride:!1,touch:!0,wrap:!0},kt={interval:"(number|boolean)",keyboard:"boolean",pause:"(string|boolean)",ride:"(boolean|string)",touch:"boolean",wrap:"boolean"};class Lt extends W{constructor(t,e){super(t,e),this._interval=null,this._activeElement=null,this._isSliding=!1,this.touchTimeout=null,this._swipeHelper=null,this._indicatorsElement=z.findOne(".carousel-indicators",this._element),this._addEventListeners(),this._config.ride===wt&&this.cycle()}static get Default(){return xt}static get DefaultType(){return kt}static get NAME(){return"carousel"}next(){this._slide(ct)}nextWhenVisible(){!document.hidden&&a(this._element)&&this.next()}prev(){this._slide(ht)}pause(){this._isSliding&&s(this._element),this._clearInterval()}cycle(){this._clearInterval(),this._updateInterval(),this._interval=setInterval((()=>this.nextWhenVisible()),this._config.interval)}_maybeEnableCycle(){this._config.ride&&(this._isSliding?N.one(this._element,pt,(()=>this.cycle())):this.cycle())}to(t){const e=this._getItems();if(t>e.length-1||t<0)return;if(this._isSliding)return void N.one(this._element,pt,(()=>this.to(t)));const i=this._getItemIndex(this._getActive());if(i===t)return;const n=t>i?ct:ht;this._slide(n,e[t])}dispose(){this._swipeHelper&&this._swipeHelper.dispose(),super.dispose()}_configAfterMerge(t){return t.defaultInterval=t.interval,t}_addEventListeners(){this._config.keyboard&&N.on(this._element,mt,(t=>this._keydown(t))),"hover"===this._config.pause&&(N.on(this._element,gt,(()=>this.pause())),N.on(this._element,_t,(()=>this._maybeEnableCycle()))),this._config.touch&&st.isSupported()&&this._addTouchEventListeners()}_addTouchEventListeners(){for(const t of z.find(".carousel-item img",this._element))N.on(t,bt,(t=>t.preventDefault()));const t={leftCallback:()=>this._slide(this._directionToOrder(dt)),rightCallback:()=>this._slide(this._directionToOrder(ut)),endCallback:()=>{"hover"===this._config.pause&&(this.pause(),this.touchTimeout&&clearTimeout(this.touchTimeout),this.touchTimeout=setTimeout((()=>this._maybeEnableCycle()),500+this._config.interval))}};this._swipeHelper=new st(this._element,t)}_keydown(t){if(/input|textarea/i.test(t.target.tagName))return;const e=Ot[t.key];e&&(t.preventDefault(),this._slide(this._directionToOrder(e)))}_getItemIndex(t){return this._getItems().indexOf(t)}_setActiveIndicatorElement(t){if(!this._indicatorsElement)return;const e=z.findOne(Et,this._indicatorsElement);e.classList.remove(At),e.removeAttribute("aria-current");const i=z.findOne(`[data-bs-slide-to="${t}"]`,this._indicatorsElement);i&&(i.classList.add(At),i.setAttribute("aria-current","true"))}_updateInterval(){const t=this._activeElement||this._getActive();if(!t)return;const e=Number.parseInt(t.getAttribute("data-bs-interval"),10);this._config.interval=e||this._config.defaultInterval}_slide(t,e=null){if(this._isSliding)return;const i=this._getActive(),n=t===ct,s=e||b(this._getItems(),i,n,this._config.wrap);if(s===i)return;const o=this._getItemIndex(s),r=e=>N.trigger(this._element,e,{relatedTarget:s,direction:this._orderToDirection(t),from:this._getItemIndex(i),to:o});if(r(ft).defaultPrevented)return;if(!i||!s)return;const a=Boolean(this._interval);this.pause(),this._isSliding=!0,this._setActiveIndicatorElement(o),this._activeElement=s;const l=n?"carousel-item-start":"carousel-item-end",c=n?"carousel-item-next":"carousel-item-prev";s.classList.add(c),d(s),i.classList.add(l),s.classList.add(l),this._queueCallback((()=>{s.classList.remove(l,c),s.classList.add(At),i.classList.remove(At,c,l),this._isSliding=!1,r(pt)}),i,this._isAnimated()),a&&this.cycle()}_isAnimated(){return this._element.classList.contains("slide")}_getActive(){return z.findOne(Ct,this._element)}_getItems(){return z.find(Tt,this._element)}_clearInterval(){this._interval&&(clearInterval(this._interval),this._interval=null)}_directionToOrder(t){return p()?t===dt?ht:ct:t===dt?ct:ht}_orderToDirection(t){return p()?t===ht?dt:ut:t===ht?ut:dt}static jQueryInterface(t){return this.each((function(){const e=Lt.getOrCreateInstance(this,t);if("number"!=typeof t){if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}else e.to(t)}))}}N.on(document,yt,"[data-bs-slide], [data-bs-slide-to]",(function(t){const e=z.getElementFromSelector(this);if(!e||!e.classList.contains(wt))return;t.preventDefault();const i=Lt.getOrCreateInstance(e),n=this.getAttribute("data-bs-slide-to");return n?(i.to(n),void i._maybeEnableCycle()):"next"===F.getDataAttribute(this,"slide")?(i.next(),void i._maybeEnableCycle()):(i.prev(),void i._maybeEnableCycle())})),N.on(window,vt,(()=>{const t=z.find('[data-bs-ride="carousel"]');for(const e of t)Lt.getOrCreateInstance(e)})),m(Lt);const St=".bs.collapse",Dt=`show${St}`,$t=`shown${St}`,It=`hide${St}`,Nt=`hidden${St}`,Pt=`click${St}.data-api`,jt="show",Mt="collapse",Ft="collapsing",Ht=`:scope .${Mt} .${Mt}`,Wt='[data-bs-toggle="collapse"]',Bt={parent:null,toggle:!0},zt={parent:"(null|element)",toggle:"boolean"};class Rt extends W{constructor(t,e){super(t,e),this._isTransitioning=!1,this._triggerArray=[];const i=z.find(Wt);for(const t of i){const e=z.getSelectorFromElement(t),i=z.find(e).filter((t=>t===this._element));null!==e&&i.length&&this._triggerArray.push(t)}this._initializeChildren(),this._config.parent||this._addAriaAndCollapsedClass(this._triggerArray,this._isShown()),this._config.toggle&&this.toggle()}static get Default(){return Bt}static get DefaultType(){return zt}static get NAME(){return"collapse"}toggle(){this._isShown()?this.hide():this.show()}show(){if(this._isTransitioning||this._isShown())return;let t=[];if(this._config.parent&&(t=this._getFirstLevelChildren(".collapse.show, .collapse.collapsing").filter((t=>t!==this._element)).map((t=>Rt.getOrCreateInstance(t,{toggle:!1})))),t.length&&t[0]._isTransitioning)return;if(N.trigger(this._element,Dt).defaultPrevented)return;for(const e of t)e.hide();const e=this._getDimension();this._element.classList.remove(Mt),this._element.classList.add(Ft),this._element.style[e]=0,this._addAriaAndCollapsedClass(this._triggerArray,!0),this._isTransitioning=!0;const i=`scroll${e[0].toUpperCase()+e.slice(1)}`;this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(Ft),this._element.classList.add(Mt,jt),this._element.style[e]="",N.trigger(this._element,$t)}),this._element,!0),this._element.style[e]=`${this._element[i]}px`}hide(){if(this._isTransitioning||!this._isShown())return;if(N.trigger(this._element,It).defaultPrevented)return;const t=this._getDimension();this._element.style[t]=`${this._element.getBoundingClientRect()[t]}px`,d(this._element),this._element.classList.add(Ft),this._element.classList.remove(Mt,jt);for(const t of this._triggerArray){const e=z.getElementFromSelector(t);e&&!this._isShown(e)&&this._addAriaAndCollapsedClass([t],!1)}this._isTransitioning=!0,this._element.style[t]="",this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(Ft),this._element.classList.add(Mt),N.trigger(this._element,Nt)}),this._element,!0)}_isShown(t=this._element){return t.classList.contains(jt)}_configAfterMerge(t){return t.toggle=Boolean(t.toggle),t.parent=r(t.parent),t}_getDimension(){return this._element.classList.contains("collapse-horizontal")?"width":"height"}_initializeChildren(){if(!this._config.parent)return;const t=this._getFirstLevelChildren(Wt);for(const e of t){const t=z.getElementFromSelector(e);t&&this._addAriaAndCollapsedClass([e],this._isShown(t))}}_getFirstLevelChildren(t){const e=z.find(Ht,this._config.parent);return z.find(t,this._config.parent).filter((t=>!e.includes(t)))}_addAriaAndCollapsedClass(t,e){if(t.length)for(const i of t)i.classList.toggle("collapsed",!e),i.setAttribute("aria-expanded",e)}static jQueryInterface(t){const e={};return"string"==typeof t&&/show|hide/.test(t)&&(e.toggle=!1),this.each((function(){const i=Rt.getOrCreateInstance(this,e);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t]()}}))}}N.on(document,Pt,Wt,(function(t){("A"===t.target.tagName||t.delegateTarget&&"A"===t.delegateTarget.tagName)&&t.preventDefault();for(const t of z.getMultipleElementsFromSelector(this))Rt.getOrCreateInstance(t,{toggle:!1}).toggle()})),m(Rt);var qt="top",Vt="bottom",Kt="right",Qt="left",Xt="auto",Yt=[qt,Vt,Kt,Qt],Ut="start",Gt="end",Jt="clippingParents",Zt="viewport",te="popper",ee="reference",ie=Yt.reduce((function(t,e){return t.concat([e+"-"+Ut,e+"-"+Gt])}),[]),ne=[].concat(Yt,[Xt]).reduce((function(t,e){return t.concat([e,e+"-"+Ut,e+"-"+Gt])}),[]),se="beforeRead",oe="read",re="afterRead",ae="beforeMain",le="main",ce="afterMain",he="beforeWrite",de="write",ue="afterWrite",fe=[se,oe,re,ae,le,ce,he,de,ue];function pe(t){return t?(t.nodeName||"").toLowerCase():null}function me(t){if(null==t)return window;if("[object Window]"!==t.toString()){var e=t.ownerDocument;return e&&e.defaultView||window}return t}function ge(t){return t instanceof me(t).Element||t instanceof Element}function _e(t){return t instanceof me(t).HTMLElement||t instanceof HTMLElement}function be(t){return"undefined"!=typeof ShadowRoot&&(t instanceof me(t).ShadowRoot||t instanceof ShadowRoot)}const ve={name:"applyStyles",enabled:!0,phase:"write",fn:function(t){var e=t.state;Object.keys(e.elements).forEach((function(t){var i=e.styles[t]||{},n=e.attributes[t]||{},s=e.elements[t];_e(s)&&pe(s)&&(Object.assign(s.style,i),Object.keys(n).forEach((function(t){var e=n[t];!1===e?s.removeAttribute(t):s.setAttribute(t,!0===e?"":e)})))}))},effect:function(t){var e=t.state,i={popper:{position:e.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(e.elements.popper.style,i.popper),e.styles=i,e.elements.arrow&&Object.assign(e.elements.arrow.style,i.arrow),function(){Object.keys(e.elements).forEach((function(t){var n=e.elements[t],s=e.attributes[t]||{},o=Object.keys(e.styles.hasOwnProperty(t)?e.styles[t]:i[t]).reduce((function(t,e){return t[e]="",t}),{});_e(n)&&pe(n)&&(Object.assign(n.style,o),Object.keys(s).forEach((function(t){n.removeAttribute(t)})))}))}},requires:["computeStyles"]};function ye(t){return t.split("-")[0]}var we=Math.max,Ae=Math.min,Ee=Math.round;function Te(){var t=navigator.userAgentData;return null!=t&&t.brands&&Array.isArray(t.brands)?t.brands.map((function(t){return t.brand+"/"+t.version})).join(" "):navigator.userAgent}function Ce(){return!/^((?!chrome|android).)*safari/i.test(Te())}function Oe(t,e,i){void 0===e&&(e=!1),void 0===i&&(i=!1);var n=t.getBoundingClientRect(),s=1,o=1;e&&_e(t)&&(s=t.offsetWidth>0&&Ee(n.width)/t.offsetWidth||1,o=t.offsetHeight>0&&Ee(n.height)/t.offsetHeight||1);var r=(ge(t)?me(t):window).visualViewport,a=!Ce()&&i,l=(n.left+(a&&r?r.offsetLeft:0))/s,c=(n.top+(a&&r?r.offsetTop:0))/o,h=n.width/s,d=n.height/o;return{width:h,height:d,top:c,right:l+h,bottom:c+d,left:l,x:l,y:c}}function xe(t){var e=Oe(t),i=t.offsetWidth,n=t.offsetHeight;return Math.abs(e.width-i)<=1&&(i=e.width),Math.abs(e.height-n)<=1&&(n=e.height),{x:t.offsetLeft,y:t.offsetTop,width:i,height:n}}function ke(t,e){var i=e.getRootNode&&e.getRootNode();if(t.contains(e))return!0;if(i&&be(i)){var n=e;do{if(n&&t.isSameNode(n))return!0;n=n.parentNode||n.host}while(n)}return!1}function Le(t){return me(t).getComputedStyle(t)}function Se(t){return["table","td","th"].indexOf(pe(t))>=0}function De(t){return((ge(t)?t.ownerDocument:t.document)||window.document).documentElement}function $e(t){return"html"===pe(t)?t:t.assignedSlot||t.parentNode||(be(t)?t.host:null)||De(t)}function Ie(t){return _e(t)&&"fixed"!==Le(t).position?t.offsetParent:null}function Ne(t){for(var e=me(t),i=Ie(t);i&&Se(i)&&"static"===Le(i).position;)i=Ie(i);return i&&("html"===pe(i)||"body"===pe(i)&&"static"===Le(i).position)?e:i||function(t){var e=/firefox/i.test(Te());if(/Trident/i.test(Te())&&_e(t)&&"fixed"===Le(t).position)return null;var i=$e(t);for(be(i)&&(i=i.host);_e(i)&&["html","body"].indexOf(pe(i))<0;){var n=Le(i);if("none"!==n.transform||"none"!==n.perspective||"paint"===n.contain||-1!==["transform","perspective"].indexOf(n.willChange)||e&&"filter"===n.willChange||e&&n.filter&&"none"!==n.filter)return i;i=i.parentNode}return null}(t)||e}function Pe(t){return["top","bottom"].indexOf(t)>=0?"x":"y"}function je(t,e,i){return we(t,Ae(e,i))}function Me(t){return Object.assign({},{top:0,right:0,bottom:0,left:0},t)}function Fe(t,e){return e.reduce((function(e,i){return e[i]=t,e}),{})}const He={name:"arrow",enabled:!0,phase:"main",fn:function(t){var e,i=t.state,n=t.name,s=t.options,o=i.elements.arrow,r=i.modifiersData.popperOffsets,a=ye(i.placement),l=Pe(a),c=[Qt,Kt].indexOf(a)>=0?"height":"width";if(o&&r){var h=function(t,e){return Me("number"!=typeof(t="function"==typeof t?t(Object.assign({},e.rects,{placement:e.placement})):t)?t:Fe(t,Yt))}(s.padding,i),d=xe(o),u="y"===l?qt:Qt,f="y"===l?Vt:Kt,p=i.rects.reference[c]+i.rects.reference[l]-r[l]-i.rects.popper[c],m=r[l]-i.rects.reference[l],g=Ne(o),_=g?"y"===l?g.clientHeight||0:g.clientWidth||0:0,b=p/2-m/2,v=h[u],y=_-d[c]-h[f],w=_/2-d[c]/2+b,A=je(v,w,y),E=l;i.modifiersData[n]=((e={})[E]=A,e.centerOffset=A-w,e)}},effect:function(t){var e=t.state,i=t.options.element,n=void 0===i?"[data-popper-arrow]":i;null!=n&&("string"!=typeof n||(n=e.elements.popper.querySelector(n)))&&ke(e.elements.popper,n)&&(e.elements.arrow=n)},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function We(t){return t.split("-")[1]}var Be={top:"auto",right:"auto",bottom:"auto",left:"auto"};function ze(t){var e,i=t.popper,n=t.popperRect,s=t.placement,o=t.variation,r=t.offsets,a=t.position,l=t.gpuAcceleration,c=t.adaptive,h=t.roundOffsets,d=t.isFixed,u=r.x,f=void 0===u?0:u,p=r.y,m=void 0===p?0:p,g="function"==typeof h?h({x:f,y:m}):{x:f,y:m};f=g.x,m=g.y;var _=r.hasOwnProperty("x"),b=r.hasOwnProperty("y"),v=Qt,y=qt,w=window;if(c){var A=Ne(i),E="clientHeight",T="clientWidth";A===me(i)&&"static"!==Le(A=De(i)).position&&"absolute"===a&&(E="scrollHeight",T="scrollWidth"),(s===qt||(s===Qt||s===Kt)&&o===Gt)&&(y=Vt,m-=(d&&A===w&&w.visualViewport?w.visualViewport.height:A[E])-n.height,m*=l?1:-1),s!==Qt&&(s!==qt&&s!==Vt||o!==Gt)||(v=Kt,f-=(d&&A===w&&w.visualViewport?w.visualViewport.width:A[T])-n.width,f*=l?1:-1)}var C,O=Object.assign({position:a},c&&Be),x=!0===h?function(t,e){var i=t.x,n=t.y,s=e.devicePixelRatio||1;return{x:Ee(i*s)/s||0,y:Ee(n*s)/s||0}}({x:f,y:m},me(i)):{x:f,y:m};return f=x.x,m=x.y,l?Object.assign({},O,((C={})[y]=b?"0":"",C[v]=_?"0":"",C.transform=(w.devicePixelRatio||1)<=1?"translate("+f+"px, "+m+"px)":"translate3d("+f+"px, "+m+"px, 0)",C)):Object.assign({},O,((e={})[y]=b?m+"px":"",e[v]=_?f+"px":"",e.transform="",e))}const Re={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(t){var e=t.state,i=t.options,n=i.gpuAcceleration,s=void 0===n||n,o=i.adaptive,r=void 0===o||o,a=i.roundOffsets,l=void 0===a||a,c={placement:ye(e.placement),variation:We(e.placement),popper:e.elements.popper,popperRect:e.rects.popper,gpuAcceleration:s,isFixed:"fixed"===e.options.strategy};null!=e.modifiersData.popperOffsets&&(e.styles.popper=Object.assign({},e.styles.popper,ze(Object.assign({},c,{offsets:e.modifiersData.popperOffsets,position:e.options.strategy,adaptive:r,roundOffsets:l})))),null!=e.modifiersData.arrow&&(e.styles.arrow=Object.assign({},e.styles.arrow,ze(Object.assign({},c,{offsets:e.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:l})))),e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-placement":e.placement})},data:{}};var qe={passive:!0};const Ve={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(t){var e=t.state,i=t.instance,n=t.options,s=n.scroll,o=void 0===s||s,r=n.resize,a=void 0===r||r,l=me(e.elements.popper),c=[].concat(e.scrollParents.reference,e.scrollParents.popper);return o&&c.forEach((function(t){t.addEventListener("scroll",i.update,qe)})),a&&l.addEventListener("resize",i.update,qe),function(){o&&c.forEach((function(t){t.removeEventListener("scroll",i.update,qe)})),a&&l.removeEventListener("resize",i.update,qe)}},data:{}};var Ke={left:"right",right:"left",bottom:"top",top:"bottom"};function Qe(t){return t.replace(/left|right|bottom|top/g,(function(t){return Ke[t]}))}var Xe={start:"end",end:"start"};function Ye(t){return t.replace(/start|end/g,(function(t){return Xe[t]}))}function Ue(t){var e=me(t);return{scrollLeft:e.pageXOffset,scrollTop:e.pageYOffset}}function Ge(t){return Oe(De(t)).left+Ue(t).scrollLeft}function Je(t){var e=Le(t),i=e.overflow,n=e.overflowX,s=e.overflowY;return/auto|scroll|overlay|hidden/.test(i+s+n)}function Ze(t){return["html","body","#document"].indexOf(pe(t))>=0?t.ownerDocument.body:_e(t)&&Je(t)?t:Ze($e(t))}function ti(t,e){var i;void 0===e&&(e=[]);var n=Ze(t),s=n===(null==(i=t.ownerDocument)?void 0:i.body),o=me(n),r=s?[o].concat(o.visualViewport||[],Je(n)?n:[]):n,a=e.concat(r);return s?a:a.concat(ti($e(r)))}function ei(t){return Object.assign({},t,{left:t.x,top:t.y,right:t.x+t.width,bottom:t.y+t.height})}function ii(t,e,i){return e===Zt?ei(function(t,e){var i=me(t),n=De(t),s=i.visualViewport,o=n.clientWidth,r=n.clientHeight,a=0,l=0;if(s){o=s.width,r=s.height;var c=Ce();(c||!c&&"fixed"===e)&&(a=s.offsetLeft,l=s.offsetTop)}return{width:o,height:r,x:a+Ge(t),y:l}}(t,i)):ge(e)?function(t,e){var i=Oe(t,!1,"fixed"===e);return i.top=i.top+t.clientTop,i.left=i.left+t.clientLeft,i.bottom=i.top+t.clientHeight,i.right=i.left+t.clientWidth,i.width=t.clientWidth,i.height=t.clientHeight,i.x=i.left,i.y=i.top,i}(e,i):ei(function(t){var e,i=De(t),n=Ue(t),s=null==(e=t.ownerDocument)?void 0:e.body,o=we(i.scrollWidth,i.clientWidth,s?s.scrollWidth:0,s?s.clientWidth:0),r=we(i.scrollHeight,i.clientHeight,s?s.scrollHeight:0,s?s.clientHeight:0),a=-n.scrollLeft+Ge(t),l=-n.scrollTop;return"rtl"===Le(s||i).direction&&(a+=we(i.clientWidth,s?s.clientWidth:0)-o),{width:o,height:r,x:a,y:l}}(De(t)))}function ni(t){var e,i=t.reference,n=t.element,s=t.placement,o=s?ye(s):null,r=s?We(s):null,a=i.x+i.width/2-n.width/2,l=i.y+i.height/2-n.height/2;switch(o){case qt:e={x:a,y:i.y-n.height};break;case Vt:e={x:a,y:i.y+i.height};break;case Kt:e={x:i.x+i.width,y:l};break;case Qt:e={x:i.x-n.width,y:l};break;default:e={x:i.x,y:i.y}}var c=o?Pe(o):null;if(null!=c){var h="y"===c?"height":"width";switch(r){case Ut:e[c]=e[c]-(i[h]/2-n[h]/2);break;case Gt:e[c]=e[c]+(i[h]/2-n[h]/2)}}return e}function si(t,e){void 0===e&&(e={});var i=e,n=i.placement,s=void 0===n?t.placement:n,o=i.strategy,r=void 0===o?t.strategy:o,a=i.boundary,l=void 0===a?Jt:a,c=i.rootBoundary,h=void 0===c?Zt:c,d=i.elementContext,u=void 0===d?te:d,f=i.altBoundary,p=void 0!==f&&f,m=i.padding,g=void 0===m?0:m,_=Me("number"!=typeof g?g:Fe(g,Yt)),b=u===te?ee:te,v=t.rects.popper,y=t.elements[p?b:u],w=function(t,e,i,n){var s="clippingParents"===e?function(t){var e=ti($e(t)),i=["absolute","fixed"].indexOf(Le(t).position)>=0&&_e(t)?Ne(t):t;return ge(i)?e.filter((function(t){return ge(t)&&ke(t,i)&&"body"!==pe(t)})):[]}(t):[].concat(e),o=[].concat(s,[i]),r=o[0],a=o.reduce((function(e,i){var s=ii(t,i,n);return e.top=we(s.top,e.top),e.right=Ae(s.right,e.right),e.bottom=Ae(s.bottom,e.bottom),e.left=we(s.left,e.left),e}),ii(t,r,n));return a.width=a.right-a.left,a.height=a.bottom-a.top,a.x=a.left,a.y=a.top,a}(ge(y)?y:y.contextElement||De(t.elements.popper),l,h,r),A=Oe(t.elements.reference),E=ni({reference:A,element:v,placement:s}),T=ei(Object.assign({},v,E)),C=u===te?T:A,O={top:w.top-C.top+_.top,bottom:C.bottom-w.bottom+_.bottom,left:w.left-C.left+_.left,right:C.right-w.right+_.right},x=t.modifiersData.offset;if(u===te&&x){var k=x[s];Object.keys(O).forEach((function(t){var e=[Kt,Vt].indexOf(t)>=0?1:-1,i=[qt,Vt].indexOf(t)>=0?"y":"x";O[t]+=k[i]*e}))}return O}function oi(t,e){void 0===e&&(e={});var i=e,n=i.placement,s=i.boundary,o=i.rootBoundary,r=i.padding,a=i.flipVariations,l=i.allowedAutoPlacements,c=void 0===l?ne:l,h=We(n),d=h?a?ie:ie.filter((function(t){return We(t)===h})):Yt,u=d.filter((function(t){return c.indexOf(t)>=0}));0===u.length&&(u=d);var f=u.reduce((function(e,i){return e[i]=si(t,{placement:i,boundary:s,rootBoundary:o,padding:r})[ye(i)],e}),{});return Object.keys(f).sort((function(t,e){return f[t]-f[e]}))}const ri={name:"flip",enabled:!0,phase:"main",fn:function(t){var e=t.state,i=t.options,n=t.name;if(!e.modifiersData[n]._skip){for(var s=i.mainAxis,o=void 0===s||s,r=i.altAxis,a=void 0===r||r,l=i.fallbackPlacements,c=i.padding,h=i.boundary,d=i.rootBoundary,u=i.altBoundary,f=i.flipVariations,p=void 0===f||f,m=i.allowedAutoPlacements,g=e.options.placement,_=ye(g),b=l||(_!==g&&p?function(t){if(ye(t)===Xt)return[];var e=Qe(t);return[Ye(t),e,Ye(e)]}(g):[Qe(g)]),v=[g].concat(b).reduce((function(t,i){return t.concat(ye(i)===Xt?oi(e,{placement:i,boundary:h,rootBoundary:d,padding:c,flipVariations:p,allowedAutoPlacements:m}):i)}),[]),y=e.rects.reference,w=e.rects.popper,A=new Map,E=!0,T=v[0],C=0;C<v.length;C++){var O=v[C],x=ye(O),k=We(O)===Ut,L=[qt,Vt].indexOf(x)>=0,S=L?"width":"height",D=si(e,{placement:O,boundary:h,rootBoundary:d,altBoundary:u,padding:c}),$=L?k?Kt:Qt:k?Vt:qt;y[S]>w[S]&&($=Qe($));var I=Qe($),N=[];if(o&&N.push(D[x]<=0),a&&N.push(D[$]<=0,D[I]<=0),N.every((function(t){return t}))){T=O,E=!1;break}A.set(O,N)}if(E)for(var P=function(t){var e=v.find((function(e){var i=A.get(e);if(i)return i.slice(0,t).every((function(t){return t}))}));if(e)return T=e,"break"},j=p?3:1;j>0&&"break"!==P(j);j--);e.placement!==T&&(e.modifiersData[n]._skip=!0,e.placement=T,e.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}};function ai(t,e,i){return void 0===i&&(i={x:0,y:0}),{top:t.top-e.height-i.y,right:t.right-e.width+i.x,bottom:t.bottom-e.height+i.y,left:t.left-e.width-i.x}}function li(t){return[qt,Kt,Vt,Qt].some((function(e){return t[e]>=0}))}const ci={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(t){var e=t.state,i=t.name,n=e.rects.reference,s=e.rects.popper,o=e.modifiersData.preventOverflow,r=si(e,{elementContext:"reference"}),a=si(e,{altBoundary:!0}),l=ai(r,n),c=ai(a,s,o),h=li(l),d=li(c);e.modifiersData[i]={referenceClippingOffsets:l,popperEscapeOffsets:c,isReferenceHidden:h,hasPopperEscaped:d},e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-reference-hidden":h,"data-popper-escaped":d})}},hi={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(t){var e=t.state,i=t.options,n=t.name,s=i.offset,o=void 0===s?[0,0]:s,r=ne.reduce((function(t,i){return t[i]=function(t,e,i){var n=ye(t),s=[Qt,qt].indexOf(n)>=0?-1:1,o="function"==typeof i?i(Object.assign({},e,{placement:t})):i,r=o[0],a=o[1];return r=r||0,a=(a||0)*s,[Qt,Kt].indexOf(n)>=0?{x:a,y:r}:{x:r,y:a}}(i,e.rects,o),t}),{}),a=r[e.placement],l=a.x,c=a.y;null!=e.modifiersData.popperOffsets&&(e.modifiersData.popperOffsets.x+=l,e.modifiersData.popperOffsets.y+=c),e.modifiersData[n]=r}},di={name:"popperOffsets",enabled:!0,phase:"read",fn:function(t){var e=t.state,i=t.name;e.modifiersData[i]=ni({reference:e.rects.reference,element:e.rects.popper,placement:e.placement})},data:{}},ui={name:"preventOverflow",enabled:!0,phase:"main",fn:function(t){var e=t.state,i=t.options,n=t.name,s=i.mainAxis,o=void 0===s||s,r=i.altAxis,a=void 0!==r&&r,l=i.boundary,c=i.rootBoundary,h=i.altBoundary,d=i.padding,u=i.tether,f=void 0===u||u,p=i.tetherOffset,m=void 0===p?0:p,g=si(e,{boundary:l,rootBoundary:c,padding:d,altBoundary:h}),_=ye(e.placement),b=We(e.placement),v=!b,y=Pe(_),w="x"===y?"y":"x",A=e.modifiersData.popperOffsets,E=e.rects.reference,T=e.rects.popper,C="function"==typeof m?m(Object.assign({},e.rects,{placement:e.placement})):m,O="number"==typeof C?{mainAxis:C,altAxis:C}:Object.assign({mainAxis:0,altAxis:0},C),x=e.modifiersData.offset?e.modifiersData.offset[e.placement]:null,k={x:0,y:0};if(A){if(o){var L,S="y"===y?qt:Qt,D="y"===y?Vt:Kt,$="y"===y?"height":"width",I=A[y],N=I+g[S],P=I-g[D],j=f?-T[$]/2:0,M=b===Ut?E[$]:T[$],F=b===Ut?-T[$]:-E[$],H=e.elements.arrow,W=f&&H?xe(H):{width:0,height:0},B=e.modifiersData["arrow#persistent"]?e.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0},z=B[S],R=B[D],q=je(0,E[$],W[$]),V=v?E[$]/2-j-q-z-O.mainAxis:M-q-z-O.mainAxis,K=v?-E[$]/2+j+q+R+O.mainAxis:F+q+R+O.mainAxis,Q=e.elements.arrow&&Ne(e.elements.arrow),X=Q?"y"===y?Q.clientTop||0:Q.clientLeft||0:0,Y=null!=(L=null==x?void 0:x[y])?L:0,U=I+K-Y,G=je(f?Ae(N,I+V-Y-X):N,I,f?we(P,U):P);A[y]=G,k[y]=G-I}if(a){var J,Z="x"===y?qt:Qt,tt="x"===y?Vt:Kt,et=A[w],it="y"===w?"height":"width",nt=et+g[Z],st=et-g[tt],ot=-1!==[qt,Qt].indexOf(_),rt=null!=(J=null==x?void 0:x[w])?J:0,at=ot?nt:et-E[it]-T[it]-rt+O.altAxis,lt=ot?et+E[it]+T[it]-rt-O.altAxis:st,ct=f&&ot?function(t,e,i){var n=je(t,e,i);return n>i?i:n}(at,et,lt):je(f?at:nt,et,f?lt:st);A[w]=ct,k[w]=ct-et}e.modifiersData[n]=k}},requiresIfExists:["offset"]};function fi(t,e,i){void 0===i&&(i=!1);var n,s,o=_e(e),r=_e(e)&&function(t){var e=t.getBoundingClientRect(),i=Ee(e.width)/t.offsetWidth||1,n=Ee(e.height)/t.offsetHeight||1;return 1!==i||1!==n}(e),a=De(e),l=Oe(t,r,i),c={scrollLeft:0,scrollTop:0},h={x:0,y:0};return(o||!o&&!i)&&(("body"!==pe(e)||Je(a))&&(c=(n=e)!==me(n)&&_e(n)?{scrollLeft:(s=n).scrollLeft,scrollTop:s.scrollTop}:Ue(n)),_e(e)?((h=Oe(e,!0)).x+=e.clientLeft,h.y+=e.clientTop):a&&(h.x=Ge(a))),{x:l.left+c.scrollLeft-h.x,y:l.top+c.scrollTop-h.y,width:l.width,height:l.height}}function pi(t){var e=new Map,i=new Set,n=[];function s(t){i.add(t.name),[].concat(t.requires||[],t.requiresIfExists||[]).forEach((function(t){if(!i.has(t)){var n=e.get(t);n&&s(n)}})),n.push(t)}return t.forEach((function(t){e.set(t.name,t)})),t.forEach((function(t){i.has(t.name)||s(t)})),n}var mi={placement:"bottom",modifiers:[],strategy:"absolute"};function gi(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];return!e.some((function(t){return!(t&&"function"==typeof t.getBoundingClientRect)}))}function _i(t){void 0===t&&(t={});var e=t,i=e.defaultModifiers,n=void 0===i?[]:i,s=e.defaultOptions,o=void 0===s?mi:s;return function(t,e,i){void 0===i&&(i=o);var s,r,a={placement:"bottom",orderedModifiers:[],options:Object.assign({},mi,o),modifiersData:{},elements:{reference:t,popper:e},attributes:{},styles:{}},l=[],c=!1,h={state:a,setOptions:function(i){var s="function"==typeof i?i(a.options):i;d(),a.options=Object.assign({},o,a.options,s),a.scrollParents={reference:ge(t)?ti(t):t.contextElement?ti(t.contextElement):[],popper:ti(e)};var r,c,u=function(t){var e=pi(t);return fe.reduce((function(t,i){return t.concat(e.filter((function(t){return t.phase===i})))}),[])}((r=[].concat(n,a.options.modifiers),c=r.reduce((function(t,e){var i=t[e.name];return t[e.name]=i?Object.assign({},i,e,{options:Object.assign({},i.options,e.options),data:Object.assign({},i.data,e.data)}):e,t}),{}),Object.keys(c).map((function(t){return c[t]}))));return a.orderedModifiers=u.filter((function(t){return t.enabled})),a.orderedModifiers.forEach((function(t){var e=t.name,i=t.options,n=void 0===i?{}:i,s=t.effect;if("function"==typeof s){var o=s({state:a,name:e,instance:h,options:n});l.push(o||function(){})}})),h.update()},forceUpdate:function(){if(!c){var t=a.elements,e=t.reference,i=t.popper;if(gi(e,i)){a.rects={reference:fi(e,Ne(i),"fixed"===a.options.strategy),popper:xe(i)},a.reset=!1,a.placement=a.options.placement,a.orderedModifiers.forEach((function(t){return a.modifiersData[t.name]=Object.assign({},t.data)}));for(var n=0;n<a.orderedModifiers.length;n++)if(!0!==a.reset){var s=a.orderedModifiers[n],o=s.fn,r=s.options,l=void 0===r?{}:r,d=s.name;"function"==typeof o&&(a=o({state:a,options:l,name:d,instance:h})||a)}else a.reset=!1,n=-1}}},update:(s=function(){return new Promise((function(t){h.forceUpdate(),t(a)}))},function(){return r||(r=new Promise((function(t){Promise.resolve().then((function(){r=void 0,t(s())}))}))),r}),destroy:function(){d(),c=!0}};if(!gi(t,e))return h;function d(){l.forEach((function(t){return t()})),l=[]}return h.setOptions(i).then((function(t){!c&&i.onFirstUpdate&&i.onFirstUpdate(t)})),h}}var bi=_i(),vi=_i({defaultModifiers:[Ve,di,Re,ve]}),yi=_i({defaultModifiers:[Ve,di,Re,ve,hi,ri,ui,He,ci]});const wi=Object.freeze(Object.defineProperty({__proto__:null,afterMain:ce,afterRead:re,afterWrite:ue,applyStyles:ve,arrow:He,auto:Xt,basePlacements:Yt,beforeMain:ae,beforeRead:se,beforeWrite:he,bottom:Vt,clippingParents:Jt,computeStyles:Re,createPopper:yi,createPopperBase:bi,createPopperLite:vi,detectOverflow:si,end:Gt,eventListeners:Ve,flip:ri,hide:ci,left:Qt,main:le,modifierPhases:fe,offset:hi,placements:ne,popper:te,popperGenerator:_i,popperOffsets:di,preventOverflow:ui,read:oe,reference:ee,right:Kt,start:Ut,top:qt,variationPlacements:ie,viewport:Zt,write:de},Symbol.toStringTag,{value:"Module"})),Ai="dropdown",Ei=".bs.dropdown",Ti=".data-api",Ci="ArrowUp",Oi="ArrowDown",xi=`hide${Ei}`,ki=`hidden${Ei}`,Li=`show${Ei}`,Si=`shown${Ei}`,Di=`click${Ei}${Ti}`,$i=`keydown${Ei}${Ti}`,Ii=`keyup${Ei}${Ti}`,Ni="show",Pi='[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)',ji=`${Pi}.${Ni}`,Mi=".dropdown-menu",Fi=p()?"top-end":"top-start",Hi=p()?"top-start":"top-end",Wi=p()?"bottom-end":"bottom-start",Bi=p()?"bottom-start":"bottom-end",zi=p()?"left-start":"right-start",Ri=p()?"right-start":"left-start",qi={autoClose:!0,boundary:"clippingParents",display:"dynamic",offset:[0,2],popperConfig:null,reference:"toggle"},Vi={autoClose:"(boolean|string)",boundary:"(string|element)",display:"string",offset:"(array|string|function)",popperConfig:"(null|object|function)",reference:"(string|element|object)"};class Ki extends W{constructor(t,e){super(t,e),this._popper=null,this._parent=this._element.parentNode,this._menu=z.next(this._element,Mi)[0]||z.prev(this._element,Mi)[0]||z.findOne(Mi,this._parent),this._inNavbar=this._detectNavbar()}static get Default(){return qi}static get DefaultType(){return Vi}static get NAME(){return Ai}toggle(){return this._isShown()?this.hide():this.show()}show(){if(l(this._element)||this._isShown())return;const t={relatedTarget:this._element};if(!N.trigger(this._element,Li,t).defaultPrevented){if(this._createPopper(),"ontouchstart"in document.documentElement&&!this._parent.closest(".navbar-nav"))for(const t of[].concat(...document.body.children))N.on(t,"mouseover",h);this._element.focus(),this._element.setAttribute("aria-expanded",!0),this._menu.classList.add(Ni),this._element.classList.add(Ni),N.trigger(this._element,Si,t)}}hide(){if(l(this._element)||!this._isShown())return;const t={relatedTarget:this._element};this._completeHide(t)}dispose(){this._popper&&this._popper.destroy(),super.dispose()}update(){this._inNavbar=this._detectNavbar(),this._popper&&this._popper.update()}_completeHide(t){if(!N.trigger(this._element,xi,t).defaultPrevented){if("ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))N.off(t,"mouseover",h);this._popper&&this._popper.destroy(),this._menu.classList.remove(Ni),this._element.classList.remove(Ni),this._element.setAttribute("aria-expanded","false"),F.removeDataAttribute(this._menu,"popper"),N.trigger(this._element,ki,t),this._element.focus()}}_getConfig(t){if("object"==typeof(t=super._getConfig(t)).reference&&!o(t.reference)&&"function"!=typeof t.reference.getBoundingClientRect)throw new TypeError(`${Ai.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);return t}_createPopper(){if(void 0===wi)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");let t=this._element;"parent"===this._config.reference?t=this._parent:o(this._config.reference)?t=r(this._config.reference):"object"==typeof this._config.reference&&(t=this._config.reference);const e=this._getPopperConfig();this._popper=yi(t,this._menu,e)}_isShown(){return this._menu.classList.contains(Ni)}_getPlacement(){const t=this._parent;if(t.classList.contains("dropend"))return zi;if(t.classList.contains("dropstart"))return Ri;if(t.classList.contains("dropup-center"))return"top";if(t.classList.contains("dropdown-center"))return"bottom";const e="end"===getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();return t.classList.contains("dropup")?e?Hi:Fi:e?Bi:Wi}_detectNavbar(){return null!==this._element.closest(".navbar")}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_getPopperConfig(){const t={placement:this._getPlacement(),modifiers:[{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"offset",options:{offset:this._getOffset()}}]};return(this._inNavbar||"static"===this._config.display)&&(F.setDataAttribute(this._menu,"popper","static"),t.modifiers=[{name:"applyStyles",enabled:!1}]),{...t,...g(this._config.popperConfig,[void 0,t])}}_selectMenuItem({key:t,target:e}){const i=z.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",this._menu).filter((t=>a(t)));i.length&&b(i,e,t===Oi,!i.includes(e)).focus()}static jQueryInterface(t){return this.each((function(){const e=Ki.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}static clearMenus(t){if(2===t.button||"keyup"===t.type&&"Tab"!==t.key)return;const e=z.find(ji);for(const i of e){const e=Ki.getInstance(i);if(!e||!1===e._config.autoClose)continue;const n=t.composedPath(),s=n.includes(e._menu);if(n.includes(e._element)||"inside"===e._config.autoClose&&!s||"outside"===e._config.autoClose&&s)continue;if(e._menu.contains(t.target)&&("keyup"===t.type&&"Tab"===t.key||/input|select|option|textarea|form/i.test(t.target.tagName)))continue;const o={relatedTarget:e._element};"click"===t.type&&(o.clickEvent=t),e._completeHide(o)}}static dataApiKeydownHandler(t){const e=/input|textarea/i.test(t.target.tagName),i="Escape"===t.key,n=[Ci,Oi].includes(t.key);if(!n&&!i)return;if(e&&!i)return;t.preventDefault();const s=this.matches(Pi)?this:z.prev(this,Pi)[0]||z.next(this,Pi)[0]||z.findOne(Pi,t.delegateTarget.parentNode),o=Ki.getOrCreateInstance(s);if(n)return t.stopPropagation(),o.show(),void o._selectMenuItem(t);o._isShown()&&(t.stopPropagation(),o.hide(),s.focus())}}N.on(document,$i,Pi,Ki.dataApiKeydownHandler),N.on(document,$i,Mi,Ki.dataApiKeydownHandler),N.on(document,Di,Ki.clearMenus),N.on(document,Ii,Ki.clearMenus),N.on(document,Di,Pi,(function(t){t.preventDefault(),Ki.getOrCreateInstance(this).toggle()})),m(Ki);const Qi="backdrop",Xi="show",Yi=`mousedown.bs.${Qi}`,Ui={className:"modal-backdrop",clickCallback:null,isAnimated:!1,isVisible:!0,rootElement:"body"},Gi={className:"string",clickCallback:"(function|null)",isAnimated:"boolean",isVisible:"boolean",rootElement:"(element|string)"};class Ji extends H{constructor(t){super(),this._config=this._getConfig(t),this._isAppended=!1,this._element=null}static get Default(){return Ui}static get DefaultType(){return Gi}static get NAME(){return Qi}show(t){if(!this._config.isVisible)return void g(t);this._append();const e=this._getElement();this._config.isAnimated&&d(e),e.classList.add(Xi),this._emulateAnimation((()=>{g(t)}))}hide(t){this._config.isVisible?(this._getElement().classList.remove(Xi),this._emulateAnimation((()=>{this.dispose(),g(t)}))):g(t)}dispose(){this._isAppended&&(N.off(this._element,Yi),this._element.remove(),this._isAppended=!1)}_getElement(){if(!this._element){const t=document.createElement("div");t.className=this._config.className,this._config.isAnimated&&t.classList.add("fade"),this._element=t}return this._element}_configAfterMerge(t){return t.rootElement=r(t.rootElement),t}_append(){if(this._isAppended)return;const t=this._getElement();this._config.rootElement.append(t),N.on(t,Yi,(()=>{g(this._config.clickCallback)})),this._isAppended=!0}_emulateAnimation(t){_(t,this._getElement(),this._config.isAnimated)}}const Zi=".bs.focustrap",tn=`focusin${Zi}`,en=`keydown.tab${Zi}`,nn="backward",sn={autofocus:!0,trapElement:null},on={autofocus:"boolean",trapElement:"element"};class rn extends H{constructor(t){super(),this._config=this._getConfig(t),this._isActive=!1,this._lastTabNavDirection=null}static get Default(){return sn}static get DefaultType(){return on}static get NAME(){return"focustrap"}activate(){this._isActive||(this._config.autofocus&&this._config.trapElement.focus(),N.off(document,Zi),N.on(document,tn,(t=>this._handleFocusin(t))),N.on(document,en,(t=>this._handleKeydown(t))),this._isActive=!0)}deactivate(){this._isActive&&(this._isActive=!1,N.off(document,Zi))}_handleFocusin(t){const{trapElement:e}=this._config;if(t.target===document||t.target===e||e.contains(t.target))return;const i=z.focusableChildren(e);0===i.length?e.focus():this._lastTabNavDirection===nn?i[i.length-1].focus():i[0].focus()}_handleKeydown(t){"Tab"===t.key&&(this._lastTabNavDirection=t.shiftKey?nn:"forward")}}const an=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",ln=".sticky-top",cn="padding-right",hn="margin-right";class dn{constructor(){this._element=document.body}getWidth(){const t=document.documentElement.clientWidth;return Math.abs(window.innerWidth-t)}hide(){const t=this.getWidth();this._disableOverFlow(),this._setElementAttributes(this._element,cn,(e=>e+t)),this._setElementAttributes(an,cn,(e=>e+t)),this._setElementAttributes(ln,hn,(e=>e-t))}reset(){this._resetElementAttributes(this._element,"overflow"),this._resetElementAttributes(this._element,cn),this._resetElementAttributes(an,cn),this._resetElementAttributes(ln,hn)}isOverflowing(){return this.getWidth()>0}_disableOverFlow(){this._saveInitialAttribute(this._element,"overflow"),this._element.style.overflow="hidden"}_setElementAttributes(t,e,i){const n=this.getWidth();this._applyManipulationCallback(t,(t=>{if(t!==this._element&&window.innerWidth>t.clientWidth+n)return;this._saveInitialAttribute(t,e);const s=window.getComputedStyle(t).getPropertyValue(e);t.style.setProperty(e,`${i(Number.parseFloat(s))}px`)}))}_saveInitialAttribute(t,e){const i=t.style.getPropertyValue(e);i&&F.setDataAttribute(t,e,i)}_resetElementAttributes(t,e){this._applyManipulationCallback(t,(t=>{const i=F.getDataAttribute(t,e);null!==i?(F.removeDataAttribute(t,e),t.style.setProperty(e,i)):t.style.removeProperty(e)}))}_applyManipulationCallback(t,e){if(o(t))e(t);else for(const i of z.find(t,this._element))e(i)}}const un=".bs.modal",fn=`hide${un}`,pn=`hidePrevented${un}`,mn=`hidden${un}`,gn=`show${un}`,_n=`shown${un}`,bn=`resize${un}`,vn=`click.dismiss${un}`,yn=`mousedown.dismiss${un}`,wn=`keydown.dismiss${un}`,An=`click${un}.data-api`,En="modal-open",Tn="show",Cn="modal-static",On={backdrop:!0,focus:!0,keyboard:!0},xn={backdrop:"(boolean|string)",focus:"boolean",keyboard:"boolean"};class kn extends W{constructor(t,e){super(t,e),this._dialog=z.findOne(".modal-dialog",this._element),this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._isShown=!1,this._isTransitioning=!1,this._scrollBar=new dn,this._addEventListeners()}static get Default(){return On}static get DefaultType(){return xn}static get NAME(){return"modal"}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||this._isTransitioning||N.trigger(this._element,gn,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._isTransitioning=!0,this._scrollBar.hide(),document.body.classList.add(En),this._adjustDialog(),this._backdrop.show((()=>this._showElement(t))))}hide(){this._isShown&&!this._isTransitioning&&(N.trigger(this._element,fn).defaultPrevented||(this._isShown=!1,this._isTransitioning=!0,this._focustrap.deactivate(),this._element.classList.remove(Tn),this._queueCallback((()=>this._hideModal()),this._element,this._isAnimated())))}dispose(){N.off(window,un),N.off(this._dialog,un),this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}handleUpdate(){this._adjustDialog()}_initializeBackDrop(){return new Ji({isVisible:Boolean(this._config.backdrop),isAnimated:this._isAnimated()})}_initializeFocusTrap(){return new rn({trapElement:this._element})}_showElement(t){document.body.contains(this._element)||document.body.append(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.scrollTop=0;const e=z.findOne(".modal-body",this._dialog);e&&(e.scrollTop=0),d(this._element),this._element.classList.add(Tn),this._queueCallback((()=>{this._config.focus&&this._focustrap.activate(),this._isTransitioning=!1,N.trigger(this._element,_n,{relatedTarget:t})}),this._dialog,this._isAnimated())}_addEventListeners(){N.on(this._element,wn,(t=>{"Escape"===t.key&&(this._config.keyboard?this.hide():this._triggerBackdropTransition())})),N.on(window,bn,(()=>{this._isShown&&!this._isTransitioning&&this._adjustDialog()})),N.on(this._element,yn,(t=>{N.one(this._element,vn,(e=>{this._element===t.target&&this._element===e.target&&("static"!==this._config.backdrop?this._config.backdrop&&this.hide():this._triggerBackdropTransition())}))}))}_hideModal(){this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._backdrop.hide((()=>{document.body.classList.remove(En),this._resetAdjustments(),this._scrollBar.reset(),N.trigger(this._element,mn)}))}_isAnimated(){return this._element.classList.contains("fade")}_triggerBackdropTransition(){if(N.trigger(this._element,pn).defaultPrevented)return;const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._element.style.overflowY;"hidden"===e||this._element.classList.contains(Cn)||(t||(this._element.style.overflowY="hidden"),this._element.classList.add(Cn),this._queueCallback((()=>{this._element.classList.remove(Cn),this._queueCallback((()=>{this._element.style.overflowY=e}),this._dialog)}),this._dialog),this._element.focus())}_adjustDialog(){const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._scrollBar.getWidth(),i=e>0;if(i&&!t){const t=p()?"paddingLeft":"paddingRight";this._element.style[t]=`${e}px`}if(!i&&t){const t=p()?"paddingRight":"paddingLeft";this._element.style[t]=`${e}px`}}_resetAdjustments(){this._element.style.paddingLeft="",this._element.style.paddingRight=""}static jQueryInterface(t,e){return this.each((function(){const i=kn.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t](e)}}))}}N.on(document,An,'[data-bs-toggle="modal"]',(function(t){const e=z.getElementFromSelector(this);["A","AREA"].includes(this.tagName)&&t.preventDefault(),N.one(e,gn,(t=>{t.defaultPrevented||N.one(e,mn,(()=>{a(this)&&this.focus()}))}));const i=z.findOne(".modal.show");i&&kn.getInstance(i).hide(),kn.getOrCreateInstance(e).toggle(this)})),R(kn),m(kn);const Ln=".bs.offcanvas",Sn=".data-api",Dn=`load${Ln}${Sn}`,$n="show",In="showing",Nn="hiding",Pn=".offcanvas.show",jn=`show${Ln}`,Mn=`shown${Ln}`,Fn=`hide${Ln}`,Hn=`hidePrevented${Ln}`,Wn=`hidden${Ln}`,Bn=`resize${Ln}`,zn=`click${Ln}${Sn}`,Rn=`keydown.dismiss${Ln}`,qn={backdrop:!0,keyboard:!0,scroll:!1},Vn={backdrop:"(boolean|string)",keyboard:"boolean",scroll:"boolean"};class Kn extends W{constructor(t,e){super(t,e),this._isShown=!1,this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._addEventListeners()}static get Default(){return qn}static get DefaultType(){return Vn}static get NAME(){return"offcanvas"}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||N.trigger(this._element,jn,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._backdrop.show(),this._config.scroll||(new dn).hide(),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.classList.add(In),this._queueCallback((()=>{this._config.scroll&&!this._config.backdrop||this._focustrap.activate(),this._element.classList.add($n),this._element.classList.remove(In),N.trigger(this._element,Mn,{relatedTarget:t})}),this._element,!0))}hide(){this._isShown&&(N.trigger(this._element,Fn).defaultPrevented||(this._focustrap.deactivate(),this._element.blur(),this._isShown=!1,this._element.classList.add(Nn),this._backdrop.hide(),this._queueCallback((()=>{this._element.classList.remove($n,Nn),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._config.scroll||(new dn).reset(),N.trigger(this._element,Wn)}),this._element,!0)))}dispose(){this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}_initializeBackDrop(){const t=Boolean(this._config.backdrop);return new Ji({className:"offcanvas-backdrop",isVisible:t,isAnimated:!0,rootElement:this._element.parentNode,clickCallback:t?()=>{"static"!==this._config.backdrop?this.hide():N.trigger(this._element,Hn)}:null})}_initializeFocusTrap(){return new rn({trapElement:this._element})}_addEventListeners(){N.on(this._element,Rn,(t=>{"Escape"===t.key&&(this._config.keyboard?this.hide():N.trigger(this._element,Hn))}))}static jQueryInterface(t){return this.each((function(){const e=Kn.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}N.on(document,zn,'[data-bs-toggle="offcanvas"]',(function(t){const e=z.getElementFromSelector(this);if(["A","AREA"].includes(this.tagName)&&t.preventDefault(),l(this))return;N.one(e,Wn,(()=>{a(this)&&this.focus()}));const i=z.findOne(Pn);i&&i!==e&&Kn.getInstance(i).hide(),Kn.getOrCreateInstance(e).toggle(this)})),N.on(window,Dn,(()=>{for(const t of z.find(Pn))Kn.getOrCreateInstance(t).show()})),N.on(window,Bn,(()=>{for(const t of z.find("[aria-modal][class*=show][class*=offcanvas-]"))"fixed"!==getComputedStyle(t).position&&Kn.getOrCreateInstance(t).hide()})),R(Kn),m(Kn);const Qn={"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],dd:[],div:[],dl:[],dt:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},Xn=new Set(["background","cite","href","itemtype","longdesc","poster","src","xlink:href"]),Yn=/^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i,Un=(t,e)=>{const i=t.nodeName.toLowerCase();return e.includes(i)?!Xn.has(i)||Boolean(Yn.test(t.nodeValue)):e.filter((t=>t instanceof RegExp)).some((t=>t.test(i)))},Gn={allowList:Qn,content:{},extraClass:"",html:!1,sanitize:!0,sanitizeFn:null,template:"<div></div>"},Jn={allowList:"object",content:"object",extraClass:"(string|function)",html:"boolean",sanitize:"boolean",sanitizeFn:"(null|function)",template:"string"},Zn={entry:"(string|element|function|null)",selector:"(string|element)"};class ts extends H{constructor(t){super(),this._config=this._getConfig(t)}static get Default(){return Gn}static get DefaultType(){return Jn}static get NAME(){return"TemplateFactory"}getContent(){return Object.values(this._config.content).map((t=>this._resolvePossibleFunction(t))).filter(Boolean)}hasContent(){return this.getContent().length>0}changeContent(t){return this._checkContent(t),this._config.content={...this._config.content,...t},this}toHtml(){const t=document.createElement("div");t.innerHTML=this._maybeSanitize(this._config.template);for(const[e,i]of Object.entries(this._config.content))this._setContent(t,i,e);const e=t.children[0],i=this._resolvePossibleFunction(this._config.extraClass);return i&&e.classList.add(...i.split(" ")),e}_typeCheckConfig(t){super._typeCheckConfig(t),this._checkContent(t.content)}_checkContent(t){for(const[e,i]of Object.entries(t))super._typeCheckConfig({selector:e,entry:i},Zn)}_setContent(t,e,i){const n=z.findOne(i,t);n&&((e=this._resolvePossibleFunction(e))?o(e)?this._putElementInTemplate(r(e),n):this._config.html?n.innerHTML=this._maybeSanitize(e):n.textContent=e:n.remove())}_maybeSanitize(t){return this._config.sanitize?function(t,e,i){if(!t.length)return t;if(i&&"function"==typeof i)return i(t);const n=(new window.DOMParser).parseFromString(t,"text/html"),s=[].concat(...n.body.querySelectorAll("*"));for(const t of s){const i=t.nodeName.toLowerCase();if(!Object.keys(e).includes(i)){t.remove();continue}const n=[].concat(...t.attributes),s=[].concat(e["*"]||[],e[i]||[]);for(const e of n)Un(e,s)||t.removeAttribute(e.nodeName)}return n.body.innerHTML}(t,this._config.allowList,this._config.sanitizeFn):t}_resolvePossibleFunction(t){return g(t,[void 0,this])}_putElementInTemplate(t,e){if(this._config.html)return e.innerHTML="",void e.append(t);e.textContent=t.textContent}}const es=new Set(["sanitize","allowList","sanitizeFn"]),is="fade",ns="show",ss=".tooltip-inner",os=".modal",rs="hide.bs.modal",as="hover",ls="focus",cs={AUTO:"auto",TOP:"top",RIGHT:p()?"left":"right",BOTTOM:"bottom",LEFT:p()?"right":"left"},hs={allowList:Qn,animation:!0,boundary:"clippingParents",container:!1,customClass:"",delay:0,fallbackPlacements:["top","right","bottom","left"],html:!1,offset:[0,6],placement:"top",popperConfig:null,sanitize:!0,sanitizeFn:null,selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',title:"",trigger:"hover focus"},ds={allowList:"object",animation:"boolean",boundary:"(string|element)",container:"(string|element|boolean)",customClass:"(string|function)",delay:"(number|object)",fallbackPlacements:"array",html:"boolean",offset:"(array|string|function)",placement:"(string|function)",popperConfig:"(null|object|function)",sanitize:"boolean",sanitizeFn:"(null|function)",selector:"(string|boolean)",template:"string",title:"(string|element|function)",trigger:"string"};class us extends W{constructor(t,e){if(void 0===wi)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");super(t,e),this._isEnabled=!0,this._timeout=0,this._isHovered=null,this._activeTrigger={},this._popper=null,this._templateFactory=null,this._newContent=null,this.tip=null,this._setListeners(),this._config.selector||this._fixTitle()}static get Default(){return hs}static get DefaultType(){return ds}static get NAME(){return"tooltip"}enable(){this._isEnabled=!0}disable(){this._isEnabled=!1}toggleEnabled(){this._isEnabled=!this._isEnabled}toggle(){this._isEnabled&&(this._isShown()?this._leave():this._enter())}dispose(){clearTimeout(this._timeout),N.off(this._element.closest(os),rs,this._hideModalHandler),this._element.getAttribute("data-bs-original-title")&&this._element.setAttribute("title",this._element.getAttribute("data-bs-original-title")),this._disposePopper(),super.dispose()}show(){if("none"===this._element.style.display)throw new Error("Please use show on visible elements");if(!this._isWithContent()||!this._isEnabled)return;const t=N.trigger(this._element,this.constructor.eventName("show")),e=(c(this._element)||this._element.ownerDocument.documentElement).contains(this._element);if(t.defaultPrevented||!e)return;this._disposePopper();const i=this._getTipElement();this._element.setAttribute("aria-describedby",i.getAttribute("id"));const{container:n}=this._config;if(this._element.ownerDocument.documentElement.contains(this.tip)||(n.append(i),N.trigger(this._element,this.constructor.eventName("inserted"))),this._popper=this._createPopper(i),i.classList.add(ns),"ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))N.on(t,"mouseover",h);this._queueCallback((()=>{N.trigger(this._element,this.constructor.eventName("shown")),!1===this._isHovered&&this._leave(),this._isHovered=!1}),this.tip,this._isAnimated())}hide(){if(this._isShown()&&!N.trigger(this._element,this.constructor.eventName("hide")).defaultPrevented){if(this._getTipElement().classList.remove(ns),"ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))N.off(t,"mouseover",h);this._activeTrigger.click=!1,this._activeTrigger[ls]=!1,this._activeTrigger[as]=!1,this._isHovered=null,this._queueCallback((()=>{this._isWithActiveTrigger()||(this._isHovered||this._disposePopper(),this._element.removeAttribute("aria-describedby"),N.trigger(this._element,this.constructor.eventName("hidden")))}),this.tip,this._isAnimated())}}update(){this._popper&&this._popper.update()}_isWithContent(){return Boolean(this._getTitle())}_getTipElement(){return this.tip||(this.tip=this._createTipElement(this._newContent||this._getContentForTemplate())),this.tip}_createTipElement(t){const e=this._getTemplateFactory(t).toHtml();if(!e)return null;e.classList.remove(is,ns),e.classList.add(`bs-${this.constructor.NAME}-auto`);const i=(t=>{do{t+=Math.floor(1e6*Math.random())}while(document.getElementById(t));return t})(this.constructor.NAME).toString();return e.setAttribute("id",i),this._isAnimated()&&e.classList.add(is),e}setContent(t){this._newContent=t,this._isShown()&&(this._disposePopper(),this.show())}_getTemplateFactory(t){return this._templateFactory?this._templateFactory.changeContent(t):this._templateFactory=new ts({...this._config,content:t,extraClass:this._resolvePossibleFunction(this._config.customClass)}),this._templateFactory}_getContentForTemplate(){return{[ss]:this._getTitle()}}_getTitle(){return this._resolvePossibleFunction(this._config.title)||this._element.getAttribute("data-bs-original-title")}_initializeOnDelegatedTarget(t){return this.constructor.getOrCreateInstance(t.delegateTarget,this._getDelegateConfig())}_isAnimated(){return this._config.animation||this.tip&&this.tip.classList.contains(is)}_isShown(){return this.tip&&this.tip.classList.contains(ns)}_createPopper(t){const e=g(this._config.placement,[this,t,this._element]),i=cs[e.toUpperCase()];return yi(this._element,t,this._getPopperConfig(i))}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_resolvePossibleFunction(t){return g(t,[this._element,this._element])}_getPopperConfig(t){const e={placement:t,modifiers:[{name:"flip",options:{fallbackPlacements:this._config.fallbackPlacements}},{name:"offset",options:{offset:this._getOffset()}},{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"arrow",options:{element:`.${this.constructor.NAME}-arrow`}},{name:"preSetPlacement",enabled:!0,phase:"beforeMain",fn:t=>{this._getTipElement().setAttribute("data-popper-placement",t.state.placement)}}]};return{...e,...g(this._config.popperConfig,[void 0,e])}}_setListeners(){const t=this._config.trigger.split(" ");for(const e of t)if("click"===e)N.on(this._element,this.constructor.eventName("click"),this._config.selector,(t=>{this._initializeOnDelegatedTarget(t).toggle()}));else if("manual"!==e){const t=e===as?this.constructor.eventName("mouseenter"):this.constructor.eventName("focusin"),i=e===as?this.constructor.eventName("mouseleave"):this.constructor.eventName("focusout");N.on(this._element,t,this._config.selector,(t=>{const e=this._initializeOnDelegatedTarget(t);e._activeTrigger["focusin"===t.type?ls:as]=!0,e._enter()})),N.on(this._element,i,this._config.selector,(t=>{const e=this._initializeOnDelegatedTarget(t);e._activeTrigger["focusout"===t.type?ls:as]=e._element.contains(t.relatedTarget),e._leave()}))}this._hideModalHandler=()=>{this._element&&this.hide()},N.on(this._element.closest(os),rs,this._hideModalHandler)}_fixTitle(){const t=this._element.getAttribute("title");t&&(this._element.getAttribute("aria-label")||this._element.textContent.trim()||this._element.setAttribute("aria-label",t),this._element.setAttribute("data-bs-original-title",t),this._element.removeAttribute("title"))}_enter(){this._isShown()||this._isHovered?this._isHovered=!0:(this._isHovered=!0,this._setTimeout((()=>{this._isHovered&&this.show()}),this._config.delay.show))}_leave(){this._isWithActiveTrigger()||(this._isHovered=!1,this._setTimeout((()=>{this._isHovered||this.hide()}),this._config.delay.hide))}_setTimeout(t,e){clearTimeout(this._timeout),this._timeout=setTimeout(t,e)}_isWithActiveTrigger(){return Object.values(this._activeTrigger).includes(!0)}_getConfig(t){const e=F.getDataAttributes(this._element);for(const t of Object.keys(e))es.has(t)&&delete e[t];return t={...e,..."object"==typeof t&&t?t:{}},t=this._mergeConfigObj(t),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}_configAfterMerge(t){return t.container=!1===t.container?document.body:r(t.container),"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),t}_getDelegateConfig(){const t={};for(const[e,i]of Object.entries(this._config))this.constructor.Default[e]!==i&&(t[e]=i);return t.selector=!1,t.trigger="manual",t}_disposePopper(){this._popper&&(this._popper.destroy(),this._popper=null),this.tip&&(this.tip.remove(),this.tip=null)}static jQueryInterface(t){return this.each((function(){const e=us.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}m(us);const fs=".popover-header",ps=".popover-body",ms={...us.Default,content:"",offset:[0,8],placement:"right",template:'<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',trigger:"click"},gs={...us.DefaultType,content:"(null|string|element|function)"};class _s extends us{static get Default(){return ms}static get DefaultType(){return gs}static get NAME(){return"popover"}_isWithContent(){return this._getTitle()||this._getContent()}_getContentForTemplate(){return{[fs]:this._getTitle(),[ps]:this._getContent()}}_getContent(){return this._resolvePossibleFunction(this._config.content)}static jQueryInterface(t){return this.each((function(){const e=_s.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}m(_s);const bs=".bs.scrollspy",vs=`activate${bs}`,ys=`click${bs}`,ws=`load${bs}.data-api`,As="active",Es="[href]",Ts=".nav-link",Cs=`${Ts}, .nav-item > ${Ts}, .list-group-item`,Os={offset:null,rootMargin:"0px 0px -25%",smoothScroll:!1,target:null,threshold:[.1,.5,1]},xs={offset:"(number|null)",rootMargin:"string",smoothScroll:"boolean",target:"element",threshold:"array"};class ks extends W{constructor(t,e){super(t,e),this._targetLinks=new Map,this._observableSections=new Map,this._rootElement="visible"===getComputedStyle(this._element).overflowY?null:this._element,this._activeTarget=null,this._observer=null,this._previousScrollData={visibleEntryTop:0,parentScrollTop:0},this.refresh()}static get Default(){return Os}static get DefaultType(){return xs}static get NAME(){return"scrollspy"}refresh(){this._initializeTargetsAndObservables(),this._maybeEnableSmoothScroll(),this._observer?this._observer.disconnect():this._observer=this._getNewObserver();for(const t of this._observableSections.values())this._observer.observe(t)}dispose(){this._observer.disconnect(),super.dispose()}_configAfterMerge(t){return t.target=r(t.target)||document.body,t.rootMargin=t.offset?`${t.offset}px 0px -30%`:t.rootMargin,"string"==typeof t.threshold&&(t.threshold=t.threshold.split(",").map((t=>Number.parseFloat(t)))),t}_maybeEnableSmoothScroll(){this._config.smoothScroll&&(N.off(this._config.target,ys),N.on(this._config.target,ys,Es,(t=>{const e=this._observableSections.get(t.target.hash);if(e){t.preventDefault();const i=this._rootElement||window,n=e.offsetTop-this._element.offsetTop;if(i.scrollTo)return void i.scrollTo({top:n,behavior:"smooth"});i.scrollTop=n}})))}_getNewObserver(){const t={root:this._rootElement,threshold:this._config.threshold,rootMargin:this._config.rootMargin};return new IntersectionObserver((t=>this._observerCallback(t)),t)}_observerCallback(t){const e=t=>this._targetLinks.get(`#${t.target.id}`),i=t=>{this._previousScrollData.visibleEntryTop=t.target.offsetTop,this._process(e(t))},n=(this._rootElement||document.documentElement).scrollTop,s=n>=this._previousScrollData.parentScrollTop;this._previousScrollData.parentScrollTop=n;for(const o of t){if(!o.isIntersecting){this._activeTarget=null,this._clearActiveClass(e(o));continue}const t=o.target.offsetTop>=this._previousScrollData.visibleEntryTop;if(s&&t){if(i(o),!n)return}else s||t||i(o)}}_initializeTargetsAndObservables(){this._targetLinks=new Map,this._observableSections=new Map;const t=z.find(Es,this._config.target);for(const e of t){if(!e.hash||l(e))continue;const t=z.findOne(decodeURI(e.hash),this._element);a(t)&&(this._targetLinks.set(decodeURI(e.hash),e),this._observableSections.set(e.hash,t))}}_process(t){this._activeTarget!==t&&(this._clearActiveClass(this._config.target),this._activeTarget=t,t.classList.add(As),this._activateParents(t),N.trigger(this._element,vs,{relatedTarget:t}))}_activateParents(t){if(t.classList.contains("dropdown-item"))z.findOne(".dropdown-toggle",t.closest(".dropdown")).classList.add(As);else for(const e of z.parents(t,".nav, .list-group"))for(const t of z.prev(e,Cs))t.classList.add(As)}_clearActiveClass(t){t.classList.remove(As);const e=z.find(`${Es}.${As}`,t);for(const t of e)t.classList.remove(As)}static jQueryInterface(t){return this.each((function(){const e=ks.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}))}}N.on(window,ws,(()=>{for(const t of z.find('[data-bs-spy="scroll"]'))ks.getOrCreateInstance(t)})),m(ks);const Ls=".bs.tab",Ss=`hide${Ls}`,Ds=`hidden${Ls}`,$s=`show${Ls}`,Is=`shown${Ls}`,Ns=`click${Ls}`,Ps=`keydown${Ls}`,js=`load${Ls}`,Ms="ArrowLeft",Fs="ArrowRight",Hs="ArrowUp",Ws="ArrowDown",Bs="Home",zs="End",Rs="active",qs="fade",Vs="show",Ks=".dropdown-toggle",Qs=`:not(${Ks})`,Xs='[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',Ys=`.nav-link${Qs}, .list-group-item${Qs}, [role="tab"]${Qs}, ${Xs}`,Us=`.${Rs}[data-bs-toggle="tab"], .${Rs}[data-bs-toggle="pill"], .${Rs}[data-bs-toggle="list"]`;class Gs extends W{constructor(t){super(t),this._parent=this._element.closest('.list-group, .nav, [role="tablist"]'),this._parent&&(this._setInitialAttributes(this._parent,this._getChildren()),N.on(this._element,Ps,(t=>this._keydown(t))))}static get NAME(){return"tab"}show(){const t=this._element;if(this._elemIsActive(t))return;const e=this._getActiveElem(),i=e?N.trigger(e,Ss,{relatedTarget:t}):null;N.trigger(t,$s,{relatedTarget:e}).defaultPrevented||i&&i.defaultPrevented||(this._deactivate(e,t),this._activate(t,e))}_activate(t,e){t&&(t.classList.add(Rs),this._activate(z.getElementFromSelector(t)),this._queueCallback((()=>{"tab"===t.getAttribute("role")?(t.removeAttribute("tabindex"),t.setAttribute("aria-selected",!0),this._toggleDropDown(t,!0),N.trigger(t,Is,{relatedTarget:e})):t.classList.add(Vs)}),t,t.classList.contains(qs)))}_deactivate(t,e){t&&(t.classList.remove(Rs),t.blur(),this._deactivate(z.getElementFromSelector(t)),this._queueCallback((()=>{"tab"===t.getAttribute("role")?(t.setAttribute("aria-selected",!1),t.setAttribute("tabindex","-1"),this._toggleDropDown(t,!1),N.trigger(t,Ds,{relatedTarget:e})):t.classList.remove(Vs)}),t,t.classList.contains(qs)))}_keydown(t){if(![Ms,Fs,Hs,Ws,Bs,zs].includes(t.key))return;t.stopPropagation(),t.preventDefault();const e=this._getChildren().filter((t=>!l(t)));let i;if([Bs,zs].includes(t.key))i=e[t.key===Bs?0:e.length-1];else{const n=[Fs,Ws].includes(t.key);i=b(e,t.target,n,!0)}i&&(i.focus({preventScroll:!0}),Gs.getOrCreateInstance(i).show())}_getChildren(){return z.find(Ys,this._parent)}_getActiveElem(){return this._getChildren().find((t=>this._elemIsActive(t)))||null}_setInitialAttributes(t,e){this._setAttributeIfNotExists(t,"role","tablist");for(const t of e)this._setInitialAttributesOnChild(t)}_setInitialAttributesOnChild(t){t=this._getInnerElement(t);const e=this._elemIsActive(t),i=this._getOuterElement(t);t.setAttribute("aria-selected",e),i!==t&&this._setAttributeIfNotExists(i,"role","presentation"),e||t.setAttribute("tabindex","-1"),this._setAttributeIfNotExists(t,"role","tab"),this._setInitialAttributesOnTargetPanel(t)}_setInitialAttributesOnTargetPanel(t){const e=z.getElementFromSelector(t);e&&(this._setAttributeIfNotExists(e,"role","tabpanel"),t.id&&this._setAttributeIfNotExists(e,"aria-labelledby",`${t.id}`))}_toggleDropDown(t,e){const i=this._getOuterElement(t);if(!i.classList.contains("dropdown"))return;const n=(t,n)=>{const s=z.findOne(t,i);s&&s.classList.toggle(n,e)};n(Ks,Rs),n(".dropdown-menu",Vs),i.setAttribute("aria-expanded",e)}_setAttributeIfNotExists(t,e,i){t.hasAttribute(e)||t.setAttribute(e,i)}_elemIsActive(t){return t.classList.contains(Rs)}_getInnerElement(t){return t.matches(Ys)?t:z.findOne(Ys,t)}_getOuterElement(t){return t.closest(".nav-item, .list-group-item")||t}static jQueryInterface(t){return this.each((function(){const e=Gs.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}))}}N.on(document,Ns,Xs,(function(t){["A","AREA"].includes(this.tagName)&&t.preventDefault(),l(this)||Gs.getOrCreateInstance(this).show()})),N.on(window,js,(()=>{for(const t of z.find(Us))Gs.getOrCreateInstance(t)})),m(Gs);const Js=".bs.toast",Zs=`mouseover${Js}`,to=`mouseout${Js}`,eo=`focusin${Js}`,io=`focusout${Js}`,no=`hide${Js}`,so=`hidden${Js}`,oo=`show${Js}`,ro=`shown${Js}`,ao="hide",lo="show",co="showing",ho={animation:"boolean",autohide:"boolean",delay:"number"},uo={animation:!0,autohide:!0,delay:5e3};class fo extends W{constructor(t,e){super(t,e),this._timeout=null,this._hasMouseInteraction=!1,this._hasKeyboardInteraction=!1,this._setListeners()}static get Default(){return uo}static get DefaultType(){return ho}static get NAME(){return"toast"}show(){N.trigger(this._element,oo).defaultPrevented||(this._clearTimeout(),this._config.animation&&this._element.classList.add("fade"),this._element.classList.remove(ao),d(this._element),this._element.classList.add(lo,co),this._queueCallback((()=>{this._element.classList.remove(co),N.trigger(this._element,ro),this._maybeScheduleHide()}),this._element,this._config.animation))}hide(){this.isShown()&&(N.trigger(this._element,no).defaultPrevented||(this._element.classList.add(co),this._queueCallback((()=>{this._element.classList.add(ao),this._element.classList.remove(co,lo),N.trigger(this._element,so)}),this._element,this._config.animation)))}dispose(){this._clearTimeout(),this.isShown()&&this._element.classList.remove(lo),super.dispose()}isShown(){return this._element.classList.contains(lo)}_maybeScheduleHide(){this._config.autohide&&(this._hasMouseInteraction||this._hasKeyboardInteraction||(this._timeout=setTimeout((()=>{this.hide()}),this._config.delay)))}_onInteraction(t,e){switch(t.type){case"mouseover":case"mouseout":this._hasMouseInteraction=e;break;case"focusin":case"focusout":this._hasKeyboardInteraction=e}if(e)return void this._clearTimeout();const i=t.relatedTarget;this._element===i||this._element.contains(i)||this._maybeScheduleHide()}_setListeners(){N.on(this._element,Zs,(t=>this._onInteraction(t,!0))),N.on(this._element,to,(t=>this._onInteraction(t,!1))),N.on(this._element,eo,(t=>this._onInteraction(t,!0))),N.on(this._element,io,(t=>this._onInteraction(t,!1)))}_clearTimeout(){clearTimeout(this._timeout),this._timeout=null}static jQueryInterface(t){return this.each((function(){const e=fo.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}return R(fo),m(fo),{Alert:Q,Button:Y,Carousel:Lt,Collapse:Rt,Dropdown:Ki,Modal:kn,Offcanvas:Kn,Popover:_s,ScrollSpy:ks,Tab:Gs,Toast:fo,Tooltip:us}}));
//# sourceMappingURL=bootstrap.bundle.min.js.map
//  * Gov.co (https://www.gov.co) - Gobierno de Colombia
//  *  - Componente: script
//  *  - Version: 4.0.0

function methodAssign(event, method, elements) {
	for (let i of elements) {
		i.addEventListener(event, method, false);
	}
}

function addEventHandler(el, evt, sel, handler) {
	for (const currEvt of evt.split(' ')) {
		el.addEventListener(currEvt, function (event) {
			let t = event.target;
			while (t && t !== this) {
				for (const currSel of sel.split(',')) {
					if (t.matches(currSel)) {
						handler.call(t, event);
					}
				}
				t = t.parentNode;
			}
		});
	}
}

function eventKeydownItem(e) {
	if (e.which == 13) {
		// Enter
		this.click();
	}
}

(function () {
	window.addEventListener('load', function () {
		initBackGoToUp();
		initAccessibilityBar();
		initDropDowns();
		initFileUpload();
     	textFields();
		initTables();
		initCarrusel();
		windowSizeCarrusel();
		initMenu();
		inicializarBuscador();
    initAdvanceLine();
	});

	window.addEventListener("resize", function () {
	  //responsiveTables();
	  resizeMenu();
	});
})();

/* ============================== Volver arriba ============================== */
function initBackGoToUp() {
	addEventsBackGoToUp();

	addEventHandler(
	  document.body,
	  'click keydown',
	  '.volver-arriba-govco',
	  function(event) {
		addEventsBackGoToUp(event);
	  }
	);
}

function addEventsBackGoToUp(event = null) {
	const backGoToUpElements = document.querySelectorAll(".volver-arriba-govco:not(.actived-events-govco)");

	if (backGoToUpElements.length > 0) {
	  backGoToUpElements.forEach((element) => element.classList.add('actived-events-govco'));
	  methodAssign("click", backGoToUp, backGoToUpElements);
	}

	  if (event == null || backGoToUpElements.length == 0) {
		  return false;
	  }

	  let element = '';
	  if (event.target.classList.contains('button.volver-arriba-govco')) {
		  element = event.target;
	  } else if (event.target.closest('button.volver-arriba-govco')) {
		  element = event.target.closest('button');
	  }

	  if (element) {
		  element.click();
	}
}

function backGoToUp() {
	document.body.scrollTop = document.documentElement.scrollTop = 0;
}

/* ============================== Barra de accesibilidad ============================== */
function initAccessibilityBar() {
	addEventHandler(
	  document.body,
	  'click keydown',
	  '.barra-accesibilidad-govco',
	  function(event) {
		addEventsAccessibilityBar(event);
	  }
	);
	addEventsAccessibilityBar();
}

  function addEventsAccessibilityBar(event = null) {
	const bars = document.querySelectorAll('.barra-accesibilidad-govco:not(.actived-events-govco)');
	for (const bar of bars) {
	  bar.classList.add('actived-events-govco');

	  const constrast = bar.querySelectorAll('button.contrast');
	  methodAssign("click", activeContrast, constrast);

	  const decrease = bar.querySelectorAll('button.decrease-font-size');
	  methodAssign("click", activeFontSize, decrease);

	  const increase = bar.querySelectorAll('button.increase-font-size');
	  methodAssign("click", activeFontSize, increase);
	}

	if (event == null || bars.length == 0) {
		return false;
	}

	let element = '';
	if (event.target.classList.contains('button.contrast', 'button.decrease-font-size', 'button.increase-font-size')) {
		element = event.target;
	} else if (event.target.closest('.barra-accesibilidad-govco')) {
		element = event.target.closest('button');
	}

	if (element) {
		element.click();
	}
}

function activeContrast() {
	const element = document.querySelector('body');
	if (element.classList.contains('contrast-govco')) {
		element.classList.remove('contrast-govco');
	} else {
		element.classList.add('contrast-govco');
	}
	activeButtonAccessibility(this);
}

let accesibilityBarCounterFontSize = 0;

function activeFontSize() {
	let addition = this.classList.contains('decrease-font-size') ? -1 : 1;
	const decreaseLimit =
		parseInt(this.getAttribute('data-decrease-limit')) || -5;
	const increaseLimit = parseInt(this.getAttribute('data-increase-limit')) || 5;

	accesibilityBarCounterFontSize += addition;

	if (
		accesibilityBarCounterFontSize >= decreaseLimit &&
		accesibilityBarCounterFontSize <= increaseLimit
	) {
		const elements = document.querySelectorAll('body *');
		for (const element of elements) {
			changeFontSize(element, addition);
		}
	} else {
		accesibilityBarCounterFontSize =
			addition > 0 ? increaseLimit : decreaseLimit;
	}

	activeButtonAccessibility(this);
}

function changeFontSize(element, increse) {
	let fontSize = getFontSize(element);
	fontSize = fontSize + increse + 'px';
	element.style.fontSize = fontSize;
}

function getFontSize(element) {
	const fontSize = window
		.getComputedStyle(element, null)
		.getPropertyValue('font-size');
	return parseFloat(fontSize);
}

function activeButtonAccessibility(element) {
	element.parentNode.querySelector('.active')?.classList.remove('active');
	element.classList.add('active');
}

// ============================== Desplegables ============================== //
function initDropDowns() {
	addEventHandler(
		document.body,
		'click keydown',
		'.desplegable-govco .btn-dropdown, .desplegable-govco .input-group',
		function (event) {
			initDropDownsList(event);
			initDropDownsCalendar(event);
		}
	);

	initDropDownsList();
	initDropDownsCalendar();
}

// Lista - Filtro de búsqueda
function initDropDownsList(event = null) {
	const containersDropDown = document.querySelectorAll(
		'.desplegable-govco:not(.calendar-govco):not(.actived-events-govco)'
	);
	for (const containerDropDown of containersDropDown) {
		containerDropDown.classList.add('actived-events-govco');
		validateInputHidden(containerDropDown);
		if (!containerDropDown.classList.contains('check-govco')) {
			assignValueDropDown(containerDropDown);
		}
		const iconDown = containerDropDown.querySelectorAll('.icons-dropdown');
		methodAssign('click', clickIconDown, iconDown);
		if (!containerDropDown.classList.contains('check-govco')) {
			const items = containerDropDown.querySelectorAll('.dropdown-item');
			methodAssign('click', enterOptionDropDown, items);
			methodAssign('keydown', eventKeydownItem, items);
		}

		if (containerDropDown.classList.contains('filter-govco')) {
			initDropDownsFilter(containerDropDown);
		} else if (containerDropDown.classList.contains('check-govco')) {
			initDropDownsCheck(containerDropDown);
		}
	}
	if (
		event != null &&
		containersDropDown.length > 0 &&
		(event.target.classList.contains('icons-dropdown') ||
			event.target.classList.contains('govco-icon'))
	) {
		event.target.click();
	}
}

function validateInputHidden(element) {
	const inputHidden = element.querySelector('input[type="hidden"]');
	if (!inputHidden) {
		createInputHidden(element);
	}
}

function createInputHidden(element) {
	let idAlert = '';
	const spanAlert = element.querySelector('.alert-desplegable-govco');
	if (spanAlert) {
		idAlert = spanAlert.getAttribute('id');
	}

	const btnDropdown = element.querySelector('.btn-dropdown');
	let inputHidden = document.createElement('input');
	inputHidden.setAttribute('type', 'hidden');
	inputHidden.setAttribute('aria-describedby', idAlert);
	inputHidden.setAttribute('aria-invalid', 'false');
	element.insertBefore(inputHidden, btnDropdown);
}

function assignValueDropDown(element) {
	let valueDropDown = '';
	const inputHidden = element.querySelector('input[type="hidden"]');

	if (inputHidden.value) {
		valueDropDown = inputHidden.value;
		const assignedValue = assignValueDropDownLi(element, valueDropDown);
		if (!assignedValue) inputHidden.value = '';
	}
}

function assignValueDropDownLi(element, valueDropDown) {
	const opcionSelected = element.querySelector(
		'.dropdown-item[data-value="' + valueDropDown + '"]'
	);

	if (opcionSelected) {
		opcionSelected.classList.add('active');
		const textValueDropDown = opcionSelected.innerHTML;
		assignValueBtnDropDown(element, textValueDropDown);
	} else {
		return false;
	}
	return true;
}

function assignValueBtnDropDown(element, textValueDropDown) {
	const btnDropdown = element.querySelector('button.btn-dropdown');
	const inputDropdown = element.querySelector('input.btn-dropdown');

	if (btnDropdown) {
		btnDropdown.innerHTML = textValueDropDown;
	}
	if (inputDropdown) {
		inputDropdown.value = textValueDropDown;
		element.querySelector('.icon-close-govco').classList.remove('d-none');
	}
}

function enterOptionDropDown() {
	const containersDropDown = this.closest('.desplegable-govco');
	const btnDropdown = containersDropDown.querySelector('button.btn-dropdown');
	const inputDropdown = containersDropDown.querySelector('input.btn-dropdown');
	const dropdownMenu = containersDropDown.querySelector(
		'.dropdown-options-govco'
	);
	const inputHidden = containersDropDown.querySelector('input[type="hidden"]');
	removeActiveOption(dropdownMenu);
	this.classList.add('active');
	if (btnDropdown) btnDropdown.innerHTML = this.innerHTML;
	if (inputDropdown) {
		inputDropdown.value = this.innerHTML;
		containersDropDown
			.querySelector('.icon-close-govco')
			.classList.remove('d-none');
	}
	inputHidden.value = getValueDropDown(dropdownMenu);
	if (inputHidden.value) inputHidden.setAttribute('aria-invalid', 'false');
}

function getValueDropDown(element) {
	let valueDropDown = '';
	const elementActive = element.querySelector('.dropdown-item.active');
	if (elementActive) {
		const dataValue = elementActive.getAttribute('data-value');
		valueDropDown = dataValue ? dataValue : '';
	}
	return valueDropDown;
}

function removeActiveOption(dropdownMenu) {
	const itemActive = dropdownMenu.querySelector('.dropdown-item.active');
	if (itemActive) {
		itemActive.classList.remove('active');
	}
}

function clickIconDown() {
	const containerDropDown = this.closest('.desplegable-govco');
	const btnDropdown = containerDropDown.querySelector('.btn-dropdown');

	if (btnDropdown.getAttribute('aria-expanded') == 'false') {
		setTimeout(() => {
			btnDropdown.click();
		}, 10);
	}
}

// Filtro de búsqueda
function initDropDownsFilter(containerDropDown) {
	const inputs = containerDropDown.querySelectorAll('input.btn-dropdown');
	methodAssign('keyup', filterList, inputs);
	methodAssign('keydown', eventKeydown, inputs);

	const buttons = containerDropDown.querySelectorAll('button.icon-close-govco');
	methodAssign('click', cleartext, buttons);
}

function filterList() {
	const containerDropDown = this.closest('.desplegable-govco');
	const items = containerDropDown.querySelectorAll(
		'.dropdown-options-govco .dropdown-item'
	);
	const text = this.value.toUpperCase();

	items.forEach((item) => {
		const itemText = item.textContent || item.innerText;
		if (itemText.toUpperCase().indexOf(text) > -1) {
			item.classList.remove('d-none');
		} else {
			item.classList.add('d-none');
		}
	});

	const clearButton = containerDropDown.querySelector('.icon-close-govco');
	if (this.value != '' && this.value != undefined && this.value != null) {
		clearButton.classList.remove('d-none');
	} else {
		clearButton.classList.add('d-none');
	}
}

function eventKeydown(e) {
	if (e.which == 13) {
		// Enter
		this.click();
	}
}

function cleartext() {
	const containerDropDown = this.closest(".desplegable-govco");
	const input = containerDropDown.querySelector("input.btn-dropdown");
	if (!input.disabled) {
	  const inputHidden = containerDropDown.querySelector('input[type="hidden"]');
	  const att = input.getAttribute('aria-expanded') == 'true';

	  input.value = "";
	  this.classList.add('d-none');

	  setTimeout(() => {
		if (att) input.click();
		else input.dblclick();
	  }, 10);

	  input.dispatchEvent(new Event("keyup"));
	  inputHidden.value = "";
	  removeActiveOption(containerDropDown);
	}
  }

// Casillas de verificación
function initDropDownsCheck(containerDropDown) {
	assignValueDropDownCheck(containerDropDown);
	const items = containerDropDown.querySelectorAll('.dropdown-item');
	methodAssign('click', clickOptionDropDownCheck, items);
	methodAssign('keydown', eventKeydownItemCheck, items);

	const inputs = containerDropDown.querySelectorAll('.dropdown-item input');
	methodAssign('change', enterInputDropDownCheck, inputs);
}

function assignValueDropDownCheck(element) {
	let valueDropDown = '';
	const inputHidden = element.querySelector('input[type="hidden"]');

	if (inputHidden.value) {
		valueDropDown = inputHidden.value;
		const assignedValue = assignValueDropDownInputCheck(element, valueDropDown);
		if (!assignedValue) inputHidden.value = '';
	}
}

function assignValueDropDownInputCheck(element, valueDropDown) {
	const values = valueDropDown.split(',');
	let textValueDropDown = [];
	for (const value of values) {
		const opcionSelected = element.querySelector(
			'.dropdown-item input[value="' + value + '"]'
		);

		if (opcionSelected) {
			opcionSelected.setAttribute('checked', '');
			const idOptionSelected = opcionSelected.getAttribute('id');
			const labelOpcionSelected = element.querySelector(
				'.dropdown-item label[for="' + idOptionSelected + '"]'
			);
			textValueDropDown.push(labelOpcionSelected.innerHTML);
		}

		if (opcionSelected.type == 'radio') {
			break;
		}
	}

	if (textValueDropDown) {
		assignValueBtnDropDown(element, textValueDropDown.join(', '));
	} else {
		return false;
	}
	return true;
}

function eventKeydownItemCheck(e) {
	if (e.which == 13) {
		// Enter
		this.click();
	}
}

function clickOptionDropDownCheck(e) {
	e.stopPropagation();
	enterOptionDropDownCheck(e.target);
}

function enterOptionDropDownCheck(e) {
	let element = e;
	if (e.tagName == 'LABEL') {
		const li = e.closest('li');
		element = li.querySelector('input');
	}

	if (e.tagName == 'LABEL' && element.getAttribute('type') == 'radio') {
		return false;
	}

	const input = e.tagName == 'LI' ? e.querySelector('input') : e;
	changeOptionDropDownCheck(input);
}

function enterInputDropDownCheck(e) {
	changeOptionDropDownCheck(e.target);
}

function changeOptionDropDownCheck(e) {
	if (e.getAttribute('type') == 'radio') {
		e.checked = true;
	} else {
		e.checked = e.checked ? false : true;
	}

	const containerDropDown = e.closest('.desplegable-govco.check-govco');
	const button = containerDropDown.querySelector('.btn-dropdown');
	const inputHidden = containerDropDown.querySelector('input[type="hidden"]');
	const inputsChecked = containerDropDown.querySelectorAll(
		'.dropdown-item input:checked'
	);

	let value = [];
	let id = [];
	for (const element of inputsChecked) {
		const label = element.nextElementSibling;
		value.push(label.innerHTML);
		id.push(element.value);
	}
	button.setAttribute('title', value.join(', '));
	button.innerHTML =
		value.length > 0 ? value.join(', ') : inputHidden.placeholder;
	inputHidden.value = id.join(',');
	inputHidden.setAttribute('aria-invalid', 'false');

	const ul = document.querySelector('.dropdown-options-govco');
	setTimeout(() => {
		ul.scrollTo(0, ul.scrollTop - 1);
		ul.scrollTo(0, ul.scrollTop + 1);
	}, 100);
}

// Calendario
function initDropDownsCalendar(event) {
	let containersDropDown = document.querySelectorAll(
		'.desplegable-govco.calendar-govco:not(.actived-events-govco)'
	);

	for (const containerDropDown of containersDropDown) {
		containerDropDown.classList.add('actived-events-govco');
		const dropdownContainer = containerDropDown.querySelector(
			'.container-dropdown'
		);
		createElementsDesplegable(dropdownContainer);
		const iconContainer = dropdownContainer.querySelector('.input-group');
		const inputNode = dropdownContainer.querySelector('input.btn-dropdown');
		const dialogNode = dropdownContainer.querySelector(
			'.dropdown-options-govco[role=dialog]'
		);
		methodAssignSelectCalendar(inputNode, dialogNode, iconContainer);
	}
	if (
		event != null &&
		containersDropDown.length > 0 &&
		(event.target.classList.contains('icons-dropdown') ||
			event.target.classList.contains('govco-icon'))
	) {
		event.target
			.closest('.desplegable-govco.calendar-govco')
			?.querySelector('input.btn-dropdown')
			.click();
	}
}

function createElementsDesplegable(containerDesplegable) {
	const container = document.createElement('div');
	container.className = 'dropdown-options-govco';
	container.setAttribute('role', 'dialog');
	container.setAttribute('aria-modal', 'true');
	container.setAttribute('aria-labelledby', 'id-dialog-label');
	containerDesplegable.appendChild(container);

	const header = document.createElement('div');
	header.className = 'header';
	container.appendChild(header);

	const previousDecade = document.createElement('button');
	previousDecade.setAttribute('type', 'button');
	previousDecade.className = 'prev-decade govco-icon govco-angle-left d-none';
	previousDecade.setAttribute('aria-label', 'previous decade');
	header.appendChild(previousDecade);

	const previousYear = document.createElement('button');
	previousYear.setAttribute('type', 'button');
	previousYear.className = 'prev-year govco-icon govco-angle-left d-none';
	previousYear.setAttribute('aria-label', 'previous year');
	header.appendChild(previousYear);

	const previousMonth = document.createElement('button');
	previousMonth.setAttribute('type', 'button');
	previousMonth.className = 'prev-month govco-icon govco-angle-left';
	previousMonth.setAttribute('aria-label', 'previous month');
	header.appendChild(previousMonth);

	const monthsYear = document.createElement('button');
	monthsYear.setAttribute('type', 'button');
	monthsYear.className = 'show-months-year';
	monthsYear.setAttribute('aria-label', 'months year');
	header.appendChild(monthsYear);

	const hMonthsYear = document.createElement('span');
	hMonthsYear.className = 'month-year';
	hMonthsYear.setAttribute('id', 'id-dialog-label');
	hMonthsYear.setAttribute('aria-live', 'polite');
	hMonthsYear.textContent = 'Month Year';
	monthsYear.appendChild(hMonthsYear);

	const nextMonth = document.createElement('button');
	nextMonth.setAttribute('type', 'button');
	nextMonth.className = 'next-month govco-icon govco-angle-right';
	nextMonth.setAttribute('aria-label', 'next month');
	header.appendChild(nextMonth);

	const nextYear = document.createElement('button');
	nextYear.setAttribute('type', 'button');
	nextYear.className = 'next-year govco-icon govco-angle-right d-none';
	nextYear.setAttribute('aria-label', 'next year');
	header.appendChild(nextYear);

	const nextDecade = document.createElement('button');
	nextDecade.setAttribute('type', 'button');
	nextDecade.className = 'next-decade govco-icon govco-angle-right d-none';
	nextDecade.setAttribute('aria-label', 'next decade');
	header.appendChild(nextDecade);

	const tableDay = document.createElement('table');
	tableDay.className = 'dates';
	tableDay.setAttribute('id', 'miCalendarioGrid');
	tableDay.setAttribute('role', 'grid');
	tableDay.setAttribute('aria-labelledby', 'id-dialog-label');
	container.appendChild(tableDay);

	const theadDay = document.createElement('thead');
	tableDay.appendChild(theadDay);

	const trDay = document.createElement('tr');
	theadDay.appendChild(trDay);

	let days = [
		'Lunes',
		'Martes',
		'Miércoles',
		'Jueves',
		'Viernes',
		'Sábado',
		'Domingo',
	];
	let thDay = '';
	for (const day of days) {
		thDay = document.createElement('th');
		thDay.setAttribute('scope', 'col');
		thDay.setAttribute('abbr', day);
		thDay.textContent = day[0] + day[1];
		trDay.appendChild(thDay);
	}

	const tbodyDay = document.createElement('tbody');
	tableDay.appendChild(tbodyDay);

	const tr2Day = document.createElement('tr');
	tbodyDay.appendChild(tr2Day);

	createDaysElementDesplegable(tr2Day, 26, 30, 'disabled');
	createDaysElementDesplegable(tr2Day, 1, 1, '');

	const tr3Day = document.createElement('tr');
	tbodyDay.appendChild(tr3Day);

	createDaysElementDesplegable(tr3Day, 2, 8, '');

	const tr4Day = document.createElement('tr');
	tbodyDay.appendChild(tr4Day);

	createDaysElementDesplegable(tr4Day, 9, 15, '');

	const tr5Day = document.createElement('tr');
	tbodyDay.appendChild(tr5Day);

	createDaysElementDesplegable(tr5Day, 16, 22, '');

	const tr6Day = document.createElement('tr');
	tbodyDay.appendChild(tr6Day);

	createDaysElementDesplegable(tr6Day, 23, 29, '');

	const tr7Day = document.createElement('tr');
	tbodyDay.appendChild(tr7Day);

	createDaysElementDesplegable(tr7Day, 30, 31, '');

	createDaysElementDesplegable(tr7Day, 1, 6, 'disabled');

	const tableMonth = document.createElement('table');
	tableMonth.className = 'months d-none';
	tableMonth.setAttribute('id', 'myMonthpickerGrid');
	tableMonth.setAttribute('role', 'grid presentation');
	tableMonth.setAttribute('aria-labelledby', 'id-dialog-label');
	tableMonth.setAttribute('aria-hidden', 'true');
	container.appendChild(tableMonth);

	const tbodyMonth = document.createElement('tbody');
	tableMonth.appendChild(tbodyMonth);

	const trMonth = document.createElement('tr');
	tbodyMonth.appendChild(trMonth);

	let months = ['Ene', 'Feb', 'Mar', 'Abr'];
	createMonthsElementDesplegable(months, trMonth, 1);

	const tr2Month = document.createElement('tr');
	tbodyMonth.appendChild(tr2Month);

	months = ['May', 'Jun', 'Jul', 'Ago'];
	createMonthsElementDesplegable(months, tr2Month, 5);

	const tr3Month = document.createElement('tr');
	tbodyMonth.appendChild(tr3Month);

	months = ['Sep', 'Oct', 'Nov', 'Dic'];
	createMonthsElementDesplegable(months, tr3Month, 9);

	const tableYear = document.createElement('table');
	tableYear.className = 'years d-none';
	tableYear.setAttribute('id', 'myYearpickerGrid');
	tableYear.setAttribute('role', 'grid presentation');
	tableYear.setAttribute('aria-labelledby', 'id-dialog-label');
	tableYear.setAttribute('aria-hidden', 'true');
	container.appendChild(tableYear);

	const tbodyYear = document.createElement('tbody');
	tableYear.appendChild(tbodyYear);

	let trYear = '';
	let tdYear = '';
	let buttontdYear = '';
	for (let index = 2020; index <= 2031; index++) {
		if (index % 4 == 0) {
			trYear = document.createElement('tr');
			tbodyYear.appendChild(trYear);
		}
		tdYear = document.createElement('td');
		tdYear.className = 'year-cell';
		trYear.appendChild(tdYear);

		buttontdYear = document.createElement('button');
		buttontdYear.setAttribute('type', 'button');
		buttontdYear.className = 'year-button';
		buttontdYear.setAttribute('tabindex', '-1');
		buttontdYear.setAttribute('data-date', index);
		buttontdYear.textContent = index;
		tdYear.appendChild(buttontdYear);
	}
}

function createMonthsElementDesplegable(months, trMonth, increment) {
	let tdMonth = '';
	let buttontdMonth = '';

	for (let index = 0; index < months.length; index++) {
		tdMonth = document.createElement('td');
		tdMonth.className = 'month-cell';
		trMonth.appendChild(tdMonth);

		buttontdMonth = document.createElement('button');
		buttontdMonth.setAttribute('type', 'button');
		buttontdMonth.className = 'month-button';
		buttontdMonth.setAttribute('tabindex', '-1');
		buttontdMonth.setAttribute('data-date', index + increment);
		buttontdMonth.textContent = months[index];
		tdMonth.appendChild(buttontdMonth);
	}
}

function createDaysElementDesplegable(trDay, ini, fin, disabled) {
	let tdDay = '';
	let buttontdDay = '';
	for (let index = ini; index <= fin; index++) {
		tdDay = document.createElement('td');
		tdDay.className = 'date-cell';
		trDay.appendChild(tdDay);

		buttontdDay = document.createElement('button');
		buttontdDay.setAttribute('type', 'button');
		buttontdDay.className = 'date-button';
		buttontdDay.setAttribute('tabindex', '-1');
		if (disabled) {
			buttontdDay.setAttribute('disabled', '');
		}
		buttontdDay.textContent = index;
		tdDay.appendChild(buttontdDay);
	}
}

function methodAssignSelectCalendar(inputNode, dialogNode, iconContainer) {
	const datePicker = new DatePicker(inputNode, dialogNode, iconContainer);
	datePicker.init();
}

let DatePickerDay = function (domNode, datepicker, index, row, column) {
	this.index = index;
	this.row = row;
	this.column = column;
	this.day = new Date();
	this.domNode = domNode;
	this.datepicker = datepicker;

	this.keyCode = Object.freeze({
		TAB: 9,
		ENTER: 13,
		ESC: 27,
		SPACE: 32,
		PAGEUP: 33,
		PAGEDOWN: 34,
		END: 35,
		HOME: 36,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
	});
};

DatePickerDay.prototype.init = function () {
	this.domNode.setAttribute('tabindex', '-1');
	this.domNode.addEventListener('mousedown', this.handleMouseDown.bind(this));
	this.domNode.addEventListener('keydown', this.handleKeyDown.bind(this));
	this.domNode.innerHTML = '-1';
};

DatePickerDay.prototype.isDisabled = function () {
	return this.domNode.classList.contains('disabled');
};

DatePickerDay.prototype.updateDay = function (disable, day) {
	this.activeDisabled(disable);

	this.day = new Date(day);
	this.domNode.innerHTML = this.day.getDate();
	this.domNode.setAttribute('tabindex', '-1');
	this.domNode.removeAttribute('aria-selected');
	let d = this.day.getDate().toString();
	if (this.day.getDate() < 9) {
		d = '0' + d;
	}

	let m = this.day.getMonth() + 1;
	if (this.day.getMonth() < 9) {
		m = '0' + m;
	}

	this.domNode.setAttribute(
		'data-date',
		this.day.getFullYear() + '-' + m + '-' + d
	);
};

DatePickerDay.prototype.activeDisabled = function (disable) {
	if (disable) {
		this.domNode.classList.add('disabled');
	} else {
		this.domNode.classList.remove('disabled');
	}
};

DatePickerDay.prototype.handleKeyDown = function (event) {
	let flag = false;

	switch (event.keyCode) {
		case this.keyCode.ESC:
			this.datepicker.hide();
			break;

		case this.keyCode.TAB:
			if (!event.shiftKey) {
				this.datepicker.hide();
			}
			break;

		case this.keyCode.ENTER:
		case this.keyCode.SPACE:
			this.datepicker.setTextboxDate();
			this.datepicker.hide();
			flag = true;
			break;

		case this.keyCode.RIGHT:
			this.datepicker.moveFocusToNextDay();
			flag = true;
			break;

		case this.keyCode.LEFT:
			this.datepicker.moveFocusToPreviousDay();
			flag = true;
			break;

		case this.keyCode.DOWN:
			this.datepicker.moveFocusToNextWeek();
			flag = true;
			break;

		case this.keyCode.UP:
			this.datepicker.moveFocusToPreviousWeek();
			flag = true;
			break;

		case this.keyCode.PAGEUP:
			if (event.shiftKey) {
				this.datepicker.moveToPreviousYear();
			} else {
				this.datepicker.moveToPreviousMonth();
			}
			flag = true;
			break;

		case this.keyCode.PAGEDOWN:
			if (event.shiftKey) {
				this.datepicker.moveToNextYear();
			} else {
				this.datepicker.moveToNextMonth();
			}
			flag = true;
			break;

		case this.keyCode.HOME:
			this.datepicker.moveFocusToFirstDayOfWeek();
			flag = true;
			break;

		case this.keyCode.END:
			this.datepicker.moveFocusToLastDayOfWeek();
			flag = true;
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePickerDay.prototype.handleMouseDown = function (event) {
	if (this.isDisabled()) {
		this.datepicker.moveFocusToDay(this.date);
	} else {
		this.datepicker.setTextboxDate(this.day);
		this.datepicker.hide();
	}

	event.stopPropagation();
	event.preventDefault();
};

let CalendarButtonInput = {};
let CalendarContainerButtonInput = {};

let DatePicker = function (inputNode, dialogNode, iconContainer) {
	this.dayLabels = [
		'Domingo',
		'Lunes',
		'Martes',
		'Miercoles',
		'Jueves',
		'Viernes',
		'Sabado',
	];
	this.monthLabels = [
		'Enero',
		'Febrero',
		'Marzo',
		'Abril',
		'Mayo',
		'Junio',
		'Julio',
		'Agosto',
		'Septiembre',
		'Octubre',
		'Noviembre',
		'Diciembre',
	];

	this.inputNode = inputNode;
	this.dialogNode = dialogNode;
	this.iconContainer = iconContainer;

	const calendarSelectionFormat = this.inputNode.getAttribute(
		'calendar-selection-format'
	);
	this.viewDay = calendarSelectionFormat?.includes('dd');
	this.viewMonth = calendarSelectionFormat?.includes('mm');
	this.viewYear = calendarSelectionFormat?.includes('aaaa');

	this.viewDay = !this.viewMonth && !this.viewYear ? true : this.viewDay;
	this.viewMonth = this.viewDay ? true : this.viewMonth;
	this.viewYear = this.viewDay ? true : this.viewYear;

	const placeholder = [];

	if (this.viewDay) placeholder.push('dd');
	if (this.viewMonth) placeholder.push('mm');
	if (this.viewYear) placeholder.push('aaaa');
	this.inputNode.setAttribute('placeholder', placeholder.join('/'));

	this.initialDate = this.getFormatDate(
		this.inputNode.getAttribute('min-date')
	);
	this.finalDate = this.getFormatDate(this.inputNode.getAttribute('max-date'));

	this.dateInput = new CalendarButtonInput(this.inputNode, this);
	this.containerDateInput = new CalendarContainerButtonInput(
		this.iconContainer,
		this,
		this.inputNode
	);

	this.MonthYearNode = this.dialogNode.querySelector('.month-year');
	this.MonthsYearNode = this.dialogNode.querySelector(
		'button.show-months-year'
	);

	this.MonthsNodes = this.dialogNode.querySelectorAll('.month-button');
	this.YearNodes = this.dialogNode.querySelectorAll('.year-button');

	this.prevYearNode = this.dialogNode.querySelector('.prev-year');
	this.prevMonthNode = this.dialogNode.querySelector('.prev-month');
	this.prevDecadeNode = this.dialogNode.querySelector('.prev-decade');
	this.nextMonthNode = this.dialogNode.querySelector('.next-month');
	this.nextYearNode = this.dialogNode.querySelector('.next-year');
	this.nextDecadeNode = this.dialogNode.querySelector('.next-decade');

	this.okButtonNode = this.dialogNode.querySelector('button[value="ok"]');
	this.cancelButtonNode = this.dialogNode.querySelector(
		'button[value="cancel"]'
	);

	this.tbodyNode = this.dialogNode.querySelector('table.dates tbody');

	this.dateTableNode = this.dialogNode.querySelector('table.dates');

	this.monthsTableNode = this.dialogNode.querySelector('table.months');
	this.buttonsCellsMonths = this.monthsTableNode.querySelectorAll('button');

	this.yearsTableNode = this.dialogNode.querySelector('table.years');
	this.buttonsCellsYears = this.yearsTableNode.querySelectorAll('button');

	this.lastRowNode = null;

	this.days = [];

	this.focusDay = new Date();
	this.yearSelect = this.focusDay.getFullYear();
	this.monthSelected = this.focusDay.getMonth();
	this.selectedDay = new Date();

	this.isMouseDownOnBackground = false;

	this.keyCode = Object.freeze({
		TAB: 9,
		ENTER: 13,
		ESC: 27,
		SPACE: 32,
		PAGEUP: 33,
		PAGEDOWN: 34,
		END: 35,
		HOME: 36,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
	});
};

DatePicker.prototype.init = function () {
	let that = this;
	this.dateInput.init();
	this.containerDateInput.init();
	this.MonthsYearNode.addEventListener(
		'click',
		this.handleMonthsYear.bind(this)
	);

	for (const monthButton of this.MonthsNodes) {
		monthButton.addEventListener('keydown', this.handleKeyDownMonth.bind(this));
	}

	for (const yearButton of this.YearNodes) {
		yearButton.addEventListener('keydown', this.handleKeyDownYear.bind(this));
	}

	this.prevMonthNode.addEventListener(
		'click',
		this.handlePreviousMonthButton.bind(this)
	);
	this.nextMonthNode.addEventListener(
		'click',
		this.handleNextMonthButton.bind(this)
	);

	this.prevMonthNode.addEventListener(
		'keydown',
		this.handlePreviousMonthButton.bind(this)
	);
	this.nextMonthNode.addEventListener(
		'keydown',
		this.handleNextMonthButton.bind(this)
	);

	this.prevYearNode.addEventListener(
		'click',
		this.handlePreviousYearButton.bind(this)
	);
	this.nextYearNode.addEventListener(
		'click',
		this.handleNextYearButton.bind(this)
	);

	this.prevYearNode.addEventListener(
		'keydown',
		this.handlePreviousYearButton.bind(this)
	);
	this.nextYearNode.addEventListener(
		'keydown',
		this.handleNextYearButton.bind(this)
	);

	this.prevDecadeNode.addEventListener(
		'click',
		this.handlePreviousDecadeButton.bind(this)
	);
	this.nextDecadeNode.addEventListener(
		'click',
		this.handleNextDecadeButton.bind(this)
	);

	this.prevDecadeNode.addEventListener(
		'keydown',
		this.handlePreviousDecadeButton.bind(this)
	);
	this.nextDecadeNode.addEventListener(
		'keydown',
		this.handleNextDecadeButton.bind(this)
	);

	this.buttonsCellsMonths.forEach(function (button) {
		button.addEventListener('click', that.handleMonthButton.bind(that));
	});

	this.buttonsCellsYears.forEach(function (button) {
		button.addEventListener('click', that.handleYearButton.bind(that));
	});

	document.body.addEventListener(
		'mousedown',
		this.handleBackgroundMouseDown.bind(this),
		true
	);
	document.body.addEventListener(
		'mouseup',
		this.handleBackgroundMouseUp.bind(this),
		true
	);

	// Create Grid of Dates
	this.tbodyNode.innerHTML = '';
	let index = 0;
	for (let i = 0; i < 6; i++) {
		const row = this.tbodyNode.insertRow(i);
		this.lastRowNode = row;
		row.classList.add('dateRow');
		for (let j = 0; j < 7; j++) {
			const cell = document.createElement('td');
			cell.classList.add('date-cell');
			const cellButton = document.createElement('button');
			cellButton.classList.add('date-button');
			cell.appendChild(cellButton);
			row.appendChild(cell);
			const dpDay = new DatePickerDay(cellButton, this, index, i, j);
			dpDay.init();
			this.days.push(dpDay);
			index++;
		}
	}

	this.monthsTableNode.classList.add('d-none');
	this.yearsTableNode.classList.add('d-none');

	this.updateGrid();
	this.setFocusDay(false);
};

DatePicker.prototype.updateGrid = function () {
	let i, flag;

	this.MonthYearNode.innerHTML =
		this.monthLabels[this.monthSelected] + ' ' + this.yearSelect;
	const firstDayOfMonth = new Date(this.yearSelect, this.monthSelected, 1);
	const daysInMonth = new Date(
		this.yearSelect,
		this.monthSelected + 1,
		0
	).getDate();
	const dayOfWeek =
		firstDayOfMonth.getDay() == 0 ? 6 : firstDayOfMonth.getDay() - 1;

	firstDayOfMonth.setDate(firstDayOfMonth.getDate() - dayOfWeek);

	const d = new Date(firstDayOfMonth);
	for (i = 0; i < this.days.length; i++) {
		flag = d.getMonth() != this.monthSelected;

		this.days[i].updateDay(flag, d);

		if (
			(this.initialDate && this.days[i].day < this.initialDate) ||
			(this.finalDate && this.days[i].day > this.finalDate)
		) {
			this.days[i].activeDisabled(true);
		}

		if (
			d.getFullYear() == this.selectedDay.getFullYear() &&
			d.getMonth() == this.selectedDay.getMonth() &&
			d.getDate() == this.selectedDay.getDate() &&
			!this.days[i].isDisabled
		) {
			this.days[i].domNode.setAttribute('aria-selected', 'true');
		}
		d.setDate(d.getDate() + 1);
	}

	if (dayOfWeek + daysInMonth < 36) {
		this.hideLastRow();
	} else {
		this.showLastRow();
	}

	this.markDateSelected();
};

DatePicker.prototype.markDateSelected = function () {
	this.uncheckDateSelected();
	const date = this.formatDate(this.selectedDay);
	document
		.querySelector('button[data-date="' + date + '"]')
		?.classList.add('selected');
};

DatePicker.prototype.uncheckDateSelected = function () {
	document.querySelector('button.selected')?.classList.remove('selected');
};

DatePicker.prototype.padTo2Digits = function (num) {
	return num.toString().padStart(2, '0');
};

DatePicker.prototype.formatDate = function (date) {
	if (this.viewDay) {
		return [
			date.getFullYear(),
			this.padTo2Digits(date.getMonth() + 1),
			this.padTo2Digits(date.getDate()),
		].join('-');
	} else if (this.viewMonth) {
		return date.getMonth() + 1;
	} else {
		return date.getFullYear();
	}
};

DatePicker.prototype.updateYearGrid = function (newYear) {
	const year = newYear || this.yearSelect;
	let initialYearFocus = this.initialDate ? this.initialDate.getFullYear() : 0;
	let finalYearFocus = this.finalDate ? this.finalDate.getFullYear() : 0;
	const yearEndCero = year - (year % 10);
	const modEnd = (yearEndCero % 100) % 4;
	let yearStart = modEnd == 0 ? yearEndCero : yearEndCero - 2;

	this.buttonsCellsYears.forEach(function (element, index) {
		element.innerHTML = yearStart + index;
		element.setAttribute('tabindex', '-1');
		element.setAttribute('data-date', yearStart + index);

		if (
			yearStart + index < initialYearFocus ||
			(yearStart + index > finalYearFocus && finalYearFocus != 0)
		) {
			element.classList.add('disabled');
		} else {
			element.classList.remove('disabled');
		}
	});
	this.validateFocusYear(year);
};

DatePicker.prototype.validateFocusYear = function (newYear) {
	newYear =
		this.initialDate || this.finalDate ? this.getYearFocus(newYear) : newYear;
	if (newYear) {
		this.yearSelect = newYear;
		this.focusDay = new Date(
			newYear,
			this.focusDay.getMonth(),
			this.focusDay.getDate()
		);
		const button = this.yearsTableNode.querySelector(
			"button[data-date='" + newYear + "']"
		);
		button.setAttribute('tabindex', '0');
	}
};

DatePicker.prototype.getYearFocus = function (yearSelect) {
	const fd = this.focusDay;
	const year = yearSelect || fd.getFullYear();
	const yearEndCero = year - (year % 10);
	const modEnd = (yearEndCero % 100) % 4;
	let yearStart = modEnd == 0 ? yearEndCero : yearEndCero - 2;
	let initialYearFocus = this.initialDate ? this.initialDate.getFullYear() : 0;
	let finalYearFocus = this.finalDate ? this.finalDate.getFullYear() : 0;

	if (
		year >= initialYearFocus &&
		((year <= finalYearFocus && finalYearFocus != 0) || finalYearFocus == 0)
	) {
		return year;
	} else if (
		yearStart + 11 >= finalYearFocus &&
		finalYearFocus != 0 &&
		yearStart <= initialYearFocus
	) {
		return finalYearFocus;
	} else if (
		yearStart <= initialYearFocus &&
		yearStart + 11 >= initialYearFocus
	) {
		return initialYearFocus;
	} else if (
		year >= yearStart &&
		year > finalYearFocus &&
		finalYearFocus <= yearStart + 11 &&
		year <= yearStart + 11 &&
		yearStart < finalYearFocus
	) {
		return finalYearFocus;
	}
};

DatePicker.prototype.updateGridYear = function (yearSelect) {
	const fd = this.focusDay;
	const year = yearSelect || fd.getFullYear();
	const yearEndCero = year - (year % 10);
	const modEnd = (yearEndCero % 100) % 4;
	let yearStart = modEnd == 0 ? yearEndCero : yearEndCero - 2;
	let yearEnd = yearStart + 11;

	this.MonthYearNode.innerHTML = yearStart + ' - ' + yearEnd;
};

DatePicker.prototype.updateGridTextMonth = function () {
	const fd = this.focusDay;
	this.MonthYearNode.innerHTML = fd.getFullYear();
};

DatePicker.prototype.handleMonthsYear = function () {
	if (!this.dateTableNode.classList.contains('d-none')) {
		this.showMonthsYear();
		this.updateGridTextMonth();
	} else if (!this.monthsTableNode.classList.contains('d-none')) {
		this.showYearsDecade();
		this.updateGridYear();
	}
};

DatePicker.prototype.showMonthsYear = function () {
	this.dateTableNode.classList.add('d-none');
	this.prevMonthNode.classList.add('d-none');
	this.nextMonthNode.classList.add('d-none');
	this.yearsTableNode.classList.add('d-none');
	this.prevDecadeNode.classList.add('d-none');
	this.nextDecadeNode.classList.add('d-none');
	this.monthsTableNode.classList.remove('d-none');

	if (this.viewMonth && !this.viewDay && !this.viewYear) {
		this.prevYearNode.classList.add('d-none');
		this.nextYearNode.classList.add('d-none');
		this.MonthsYearNode.classList.add('d-none');
	} else {
		this.prevYearNode.classList.remove('d-none');
		this.nextYearNode.classList.remove('d-none');
	}
	this.viewMonths();
};

DatePicker.prototype.showYearsDecade = function () {
	this.dateTableNode.classList.add('d-none');
	this.monthsTableNode.classList.add('d-none');
	this.prevMonthNode.classList.add('d-none');
	this.nextMonthNode.classList.add('d-none');
	this.prevYearNode.classList.add('d-none');
	this.nextYearNode.classList.add('d-none');
	this.yearsTableNode.classList.remove('d-none');
	this.prevDecadeNode.classList.remove('d-none');
	this.nextDecadeNode.classList.remove('d-none');
};

DatePicker.prototype.showDaysMonth = function () {
	this.monthsTableNode.classList.add('d-none');
	this.yearsTableNode.classList.add('d-none');
	this.prevDecadeNode.classList.add('d-none');
	this.nextDecadeNode.classList.add('d-none');
	this.prevYearNode.classList.add('d-none');
	this.nextYearNode.classList.add('d-none');
	this.dateTableNode.classList.remove('d-none');
	this.prevMonthNode.classList.remove('d-none');
	this.nextMonthNode.classList.remove('d-none');
};

DatePicker.prototype.hideLastRow = function () {
	this.lastRowNode.style.display = 'none';
};

DatePicker.prototype.showLastRow = function () {
	this.lastRowNode.style.display = 'table-row';
};

DatePicker.prototype.setFocusDay = function (flag) {
	if (typeof flag !== 'boolean') {
		flag = true;
	}

	const fd = new Date(this.focusDay);

	let exists = 0;
	let dateAux = '';
	let contAux = 0;
	function checkDay(d) {
		contAux++;
		d.domNode.setAttribute('tabindex', '-1');

		const dS = new Date(fd);
		dS.setHours(0, 0, 0, 0);
		const dInitial = this.initialDate ? this.initialDate : dS;
		const dFinal = this.finalDate ? this.finalDate : dS;

		dateAux = this.getDateAux(d, dateAux);
		if (
			d.day.getDate() == fd.getDate() &&
			d.day.getMonth() == fd.getMonth() &&
			d.day.getMonth() == this.monthSelected &&
			d.day.getFullYear() == fd.getFullYear() &&
			dS >= dInitial &&
			dS <= dFinal
		) {
			this.editFocusDay(d, flag);
			exists = 1;
		}
	}

	this.days.forEach(checkDay.bind(this));
	if (exists == 0 && dateAux != '') {
		dateAux.domNode.setAttribute('tabindex', '0');
	}
};

DatePicker.prototype.editFocusDay = function (d, flag) {
	d.domNode.setAttribute('tabindex', '0');
	//Control Meses
	const buttonMonth = this.monthsTableNode.querySelector(
		"button[data-date='" + (d.day.getMonth() + 1) + "']"
	);
	this.buttonsCellsMonths.forEach(function (e) {
		e.setAttribute('tabindex', '-1');
	});
	buttonMonth.setAttribute('tabindex', '0');
	//Control Años
	const buttonYear = this.yearsTableNode.querySelector(
		"button[data-date='" + d.day.getFullYear() + "']"
	);
	this.buttonsCellsYears.forEach(function (e) {
		e.setAttribute('tabindex', '-1');
	});

	if (buttonYear) {
		buttonYear.setAttribute('tabindex', '0');
	}

	if (flag) {
		d.domNode.focus();
	}
};

DatePicker.prototype.getDateAux = function (d, dateAux) {
	if (
		this.initialDate == '' &&
		this.finalDate == '' &&
		d.day.getDate() == 1 &&
		d.day.getMonth() == this.monthSelected
	) {
		return d;
	} else if (d.day.getMonth() == this.monthSelected && dateAux == '') {
		if (
			(d.day >= this.initialDate && d.day <= this.finalDate) ||
			(this.initialDate == '' && this.finalDate && d.day.getDate() == 1) ||
			(this.initialDate &&
				this.finalDate == '' &&
				d.day.getDate() == this.initialDate.getDate())
		) {
			return d;
		}
	}
	return dateAux;
};

DatePicker.prototype.setFocusMonth = function (flag) {
	if (typeof flag !== 'boolean') {
		flag = true;
	}
	const fd = this.focusDay;
	let buttonMonth = this.monthsTableNode.querySelector(
		"button[data-date='" + (fd.getMonth() + 1) + "']"
	);
	if (flag) {
		buttonMonth.focus();
	}
};

DatePicker.prototype.setFocusYear = function (flag) {
	if (typeof flag !== 'boolean') {
		flag = true;
	}
	const fd = this.focusDay;
	let buttonYear = this.yearsTableNode.querySelector(
		"button[data-date='" + fd.getFullYear() + "']"
	);
	if (flag) {
		buttonYear.focus();
	}
};

DatePicker.prototype.updateDay = function (day) {
	const d = this.focusDay;
	this.focusDay = day;
	if (
		d.getMonth() !== day.getMonth() ||
		d.getFullYear() !== day.getFullYear()
	) {
		this.updateGrid();
		this.setFocusDay();
	}
};

DatePicker.prototype.getDaysInLastMonth = function () {
	const fd = this.focusDay;
	const lastDayOfMonth = new Date(fd.getFullYear(), fd.getMonth(), 0);
	return lastDayOfMonth.getDate();
};

DatePicker.prototype.getDaysInMonth = function () {
	const fd = this.focusDay;
	const lastDayOfMonth = new Date(fd.getFullYear(), fd.getMonth() + 1, 0);
	return lastDayOfMonth.getDate();
};

DatePicker.prototype.show = function () {
	const desplegable = this.inputNode.closest('.container-dropdown');
	desplegable.classList.add('desplegable-arrow-active');
	this.dialogNode.classList.add('show');

	this.getDateInput();
	this.monthSelected = this.focusDay.getMonth();
	this.yearSelect = this.focusDay.getFullYear();
	this.showDaysMonth();
	this.updateYearGrid();
	this.updateGridYear();
	this.updateGrid();
	this.setFocusDay();
};

DatePicker.prototype.isOpen = function () {
	return window.getComputedStyle(this.dialogNode).display !== 'none';
};

DatePicker.prototype.hide = function () {
	const desplegable = this.inputNode.closest('.container-dropdown');
	desplegable.classList.remove('desplegable-arrow-active');
	this.dialogNode.classList.remove('show');

	this.hasFocusFlag = false;
	this.dateInput.setFocus();
};

DatePicker.prototype.handleBackgroundMouseDown = function (event) {
	if (
		!this.inputNode.contains(event.target) &&
		!this.dialogNode.contains(event.target) &&
		!this.iconContainer.contains(event.target) &&
		!this.inputNode.classList.contains('no-hide')
	) {
		this.isMouseDownOnBackground = true;

		if (this.isOpen()) {
			this.hide();
			event.stopPropagation();
			event.preventDefault();
		}
	}
};

DatePicker.prototype.handleBackgroundMouseUp = function () {
	this.isMouseDownOnBackground = false;
};

DatePicker.prototype.showMonthsYearNode = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.setTextboxDate();
					this.hide();
					flag = true;
					break;

				case this.keyCode.TAB:
					if (!event.shiftKey) {
						this.prevYearNode.focus();
						flag = true;
					}
					break;

				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				default:
					break;
			}
			break;

		case 'click':
			this.setTextboxDate();
			this.hide();
			flag = true;
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handleNextDecadeButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToNextDecade();
					this.setFocusDay(false);
					flag = true;
					break;
			}

			break;

		case 'click':
			this.moveToNextDecade();
			this.setFocusDay(false);
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handlePreviousDecadeButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToPreviousDecade();
					this.setFocusDay(false);
					flag = true;
					break;

				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				default:
					break;
			}

			break;

		case 'click':
			this.moveToPreviousDecade();
			this.setFocusDay(false);
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handleNextYearButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToNextYear();
					this.setFocusDay(false);
					flag = true;
					break;
			}

			break;

		case 'click':
			this.moveToNextYear();
			this.setFocusDay(false);
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handlePreviousYearButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToPreviousYear();
					this.setFocusDay(false);
					flag = true;
					break;

				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				default:
					break;
			}

			break;

		case 'click':
			this.moveToPreviousYear();
			this.setFocusDay(false);
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handleNextMonthButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToNextMonth();
					this.setFocusDay(false);
					flag = true;
					break;
			}

			break;

		case 'click':
			this.moveToNextMonth();
			this.setFocusDay(false);
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handlePreviousMonthButton = function (event) {
	let flag = false;

	switch (event.type) {
		case 'keydown':
			switch (event.keyCode) {
				case this.keyCode.ESC:
					this.hide();
					flag = true;
					break;

				case this.keyCode.ENTER:
				case this.keyCode.SPACE:
					this.moveToPreviousMonth();
					this.setFocusDay(false);
					flag = true;
					break;
			}

			break;

		case 'click':
			this.moveToPreviousMonth();
			this.setFocusDay(false);
			flag = true;
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.handleMonthButton = function (event) {
	if (!this.isDisabled(event.target)) {
		const buttonMonth = event.target;
		const month = buttonMonth.getAttribute('data-date');
		this.showDaysMonth();
		this.focusDay.setMonth(month - 1);
		this.focusDay.setDate(1);
		this.monthSelected = month - 1;
		this.buttonsCellsMonths.forEach(function (e) {
			e.setAttribute('tabindex', '-1');
		});
		buttonMonth.setAttribute('tabindex', '0');
		if (this.viewDay) {
			this.updateGrid();
		} else {
			this.setTextboxDate();
			this.hide();
		}
		this.setFocusDay(false);
	}
};

DatePicker.prototype.handleYearButton = function (event) {
	let buttonYear = event.target;
	if (!this.isDisabled(buttonYear)) {
		const year = buttonYear.getAttribute('data-date');
		this.yearSelect = parseInt(year);
		this.focusDay.setFullYear(year);

		if (this.viewMonth) {
			this.showMonthsYear();
			this.MonthYearNode.innerHTML = year;
			this.updateYearGrid();
		} else {
			this.hide();
			this.setTextboxDate();
		}
	}
};

DatePicker.prototype.moveToNextDecade = function () {
	this.yearSelect = this.yearSelect + 10;
	this.updateYearGrid(this.yearSelect);
	this.updateGridYear(this.yearSelect);
};

DatePicker.prototype.moveToPreviousDecade = function () {
	this.yearSelect = this.yearSelect - 10;
	this.updateYearGrid(this.yearSelect);
	this.updateGridYear(this.yearSelect);
};

DatePicker.prototype.moveToNextYear = function () {
	const fd = this.focusDay;
	this.MonthYearNode.innerHTML = fd.getFullYear() + 1;
	this.yearSelect = fd.getFullYear() + 1;
	this.viewMonths();
};

DatePicker.prototype.moveToPreviousYear = function () {
	const fd = this.focusDay;
	this.MonthYearNode.innerHTML = fd.getFullYear() - 1;
	this.yearSelect = fd.getFullYear() - 1;
	this.viewMonths();
};

DatePicker.prototype.viewMonths = function () {
	let initialMonthFocus = this.initialDate
		? this.initialDate.getMonth() + 1
		: 0;
	let finalMonthFocus = this.finalDate ? this.finalDate.getMonth() + 1 : 12;
	let initialYearFocus = this.initialDate ? this.initialDate.getFullYear() : 0;
	let finalYearFocus = this.finalDate ? this.finalDate.getFullYear() : 0;
	this.focusDay.setFullYear(this.yearSelect);
	for (const monthButton of this.MonthsNodes) {
		const monthCell = monthButton.getAttribute('data-date');

		if (
			this.yearSelect < initialYearFocus ||
			(this.yearSelect > finalYearFocus && finalYearFocus != 0) ||
			(this.yearSelect == initialYearFocus && monthCell < initialMonthFocus) ||
			(this.yearSelect == finalYearFocus && monthCell > finalMonthFocus)
		) {
			monthButton.classList.add('disabled');
			monthButton.setAttribute('tabindex', '-1');
		} else if (this.focusDay.getMonth() + 1 == monthCell) {
			monthButton.setAttribute('tabindex', '0');
			monthButton.classList.remove('disabled');
		} else {
			monthButton.classList.remove('disabled');
		}
	}
};

DatePicker.prototype.moveToNextMonth = function () {
	if (this.monthSelected + 1 > 11) {
		this.monthSelected = 0;
		this.yearSelect = this.yearSelect + 1;
	} else {
		this.monthSelected = this.monthSelected + 1;
	}
	this.updateGrid();
};

DatePicker.prototype.moveToPreviousMonth = function () {
	if (this.monthSelected - 1 < 0) {
		this.monthSelected = 11;
		this.yearSelect = this.yearSelect - 1;
	} else {
		this.monthSelected = this.monthSelected - 1;
	}
	this.updateGrid();
};

DatePicker.prototype.moveFocusToDay = function (day) {
	if (day) {
		const d = this.focusDay;
		this.focusDay = day;
		this.monthSelected = this.focusDay.getMonth();
		this.yearSelect = this.focusDay.getFullYear();

		if (
			d.getMonth() != this.focusDay.getMonth() ||
			d.getYear() != this.focusDay.getYear()
		) {
			this.updateGrid();
		}
		this.setFocusDay(true);
	}
};

DatePicker.prototype.moveFocusToNextDay = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() + 1);
	d = this.validateDay(this.focusDay, d);
	this.moveFocusToDay(d);
};

DatePicker.prototype.validateDay = function (date, dateNew) {
	const date1 = date;
	const date2 = dateNew;
	date1.setHours(0, 0, 0, 0);
	date2.setHours(0, 0, 0, 0);

	if (
		(date2 > date1 && this.finalDate && this.finalDate < date2) ||
		(date2 < date1 && this.initialDate && this.initialDate > date2)
	) {
		return date;
	} else {
		return dateNew;
	}
};

DatePicker.prototype.moveFocusToNextWeek = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() + 7);
	d = this.validateDay(this.focusDay, d);
	this.moveFocusToDay(d);
};

DatePicker.prototype.moveFocusToPreviousDay = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() - 1);
	d = this.validateDay(this.focusDay, d);
	this.moveFocusToDay(d);
};

DatePicker.prototype.moveFocusToPreviousWeek = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() - 7);
	d = this.validateDay(this.focusDay, d);
	this.moveFocusToDay(d);
};

DatePicker.prototype.moveFocusToFirstDayOfWeek = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() - d.getDay());
	d = this.validateDay(this.focusDay, d);
	this.moveFocusToDay(d);
};

DatePicker.prototype.moveFocusToLastDayOfWeek = function () {
	let d = new Date(this.focusDay);
	d.setDate(d.getDate() + (6 - d.getDay()));
	this.moveFocusToDay(d);
};

DatePicker.prototype.setTextboxDate = function (day) {
	if (day) {
		this.dateInput.setDate(day);
	} else {
		this.dateInput.setDate(this.focusDay);
	}
};

DatePicker.prototype.getDateInput = function () {
	let parts = this.dateInput.getDate().split('/');

	if (
		this.viewDay &&
		parts.length === 3 &&
		Number.isInteger(parseInt(parts[0])) &&
		Number.isInteger(parseInt(parts[1])) &&
		Number.isInteger(parseInt(parts[2]))
	) {
		this.focusDay = new Date(
			parseInt(parts[2]),
			parseInt(parts[1]) - 1,
			parseInt(parts[0])
		);
		this.selectedDay = new Date(this.focusDay);
	} else if (
		this.viewDay == false &&
		parts.length === 2 &&
		Number.isInteger(parseInt(parts[0])) &&
		Number.isInteger(parseInt(parts[1]))
	) {
		this.focusDay = new Date(parseInt(parts[1]), parseInt(parts[0]) - 1, 1);
		this.selectedDay = new Date(this.focusDay);
	} else if (this.viewYear && Number.isInteger(parseInt(parts[0]))) {
		this.focusDay = new Date(parseInt(parts[0]), 0, 1);
		this.selectedDay = new Date(this.focusDay);
	} else if (this.viewMonth && Number.isInteger(parseInt(parts[0]))) {
		this.focusDay = new Date(1900, parseInt(parts[0]) - 1, 1);
		this.selectedDay = new Date(this.focusDay);
	} else {
		// If not a valid date (DD/MM/YY) initialize with todays date
		this.focusDay = new Date();
		this.selectedDay = new Date();
	}

	let date1 = new Date(this.focusDay);
	if (
		(date1 < this.initialDate && this.initialDate) ||
		(date1 > this.finalDate && this.finalDate)
	) {
		this.focusDay =
			date1 > this.finalDate && this.finalDate
				? this.finalDate
				: this.initialDate;
		this.selectedDay = new Date(this.focusDay);
		this.inputNode.value = '';
	} else if (this.dateInput.getDate()) {
		this.dateInput.setDate(date1);
	}

	const fd = this.focusDay;
	const year = fd.getFullYear();
	this.yearSelect = year;
	this.monthSelected = fd.getMonth();
};

DatePicker.prototype.moveFocusToNextMonth = function (num) {
	const d = new Date(
		this.focusDay.getFullYear(),
		this.focusDay.getMonth() + num,
		this.focusDay.getDate()
	);
	this.moveFocusToMonth(d);
};

DatePicker.prototype.moveFocusToPreviousMonth = function (num) {
	const d = new Date(
		this.focusDay.getFullYear(),
		this.focusDay.getMonth() - num,
		this.focusDay.getDate()
	);
	this.moveFocusToMonth(d);
};

DatePicker.prototype.moveFocusToMonth = function (day) {
	const d = this.focusDay;

	if (d.getMonth() != day.getMonth() || d.getYear() != day.getYear()) {
		this.updateGridMonth(day);
	}
	this.setFocusDay(true);
};

DatePicker.prototype.updateGridMonth = function (day) {
	const fd = day;
	const monthSelected = fd.getMonth() + 1;
	const yearSelected = fd.getFullYear();
	const buttonMonth = this.monthsTableNode.querySelector(
		"button[data-date='" + monthSelected + "']"
	);
	const refreshMonths = this.focusDay.getFullYear() != yearSelected;
	let elementActive = false;

	if (
		!this.isDisabled(buttonMonth) ||
		this.focusDay.getFullYear() != yearSelected
	) {
		this.yearSelect = yearSelected;
		this.focusDay = day;
		elementActive = true;
		if (refreshMonths) {
			this.viewMonths();

			if (this.viewYear && yearSelected == this.selectedDay.getFullYear()) {
				this.markDateSelected();
			} else if (this.viewYear) {
				this.uncheckDateSelected();
			}
		}
	}

	this.buttonsCellsMonths.forEach(function (e) {
		const month = e.getAttribute('data-date');
		if (elementActive) {
			e.setAttribute('tabindex', monthSelected == month ? '0' : '-1');
			if (monthSelected == month) e.focus();
		}
	});
	this.updateGridTextMonth();
};

DatePicker.prototype.isDisabled = function (e) {
	return e.classList.contains('disabled');
};

DatePicker.prototype.selectedMonth = function () {
	for (const monthButton of this.MonthsNodes) {
		if (monthButton.getAttribute('tabindex') == '0') {
			const month = monthButton.getAttribute('data-date');
			this.monthSelected = month - 1;
			this.focusDay.setMonth(month - 1);
			this.focusDay.setDate(1);
		}
	}
};

DatePicker.prototype.handleKeyDownMonth = function (event) {
	let flag = false;
	let self = this;

	switch (event.keyCode) {
		case this.keyCode.ENTER:
		case this.keyCode.SPACE:
			if (this.viewDay) {
				this.showDaysMonth();
				this.selectedMonth();
				this.updateGrid();
				this.setFocusDay(true);
			} else {
				this.setTextboxDate();
				this.hide();
			}
			flag = true;
			break;

		case this.keyCode.TAB:
			if (!event.shiftKey) {
				self.hide();
			}
			break;

		case this.keyCode.ESC:
			self.hide();
			flag = true;
			break;

		case this.keyCode.RIGHT:
			this.moveFocusToNextMonth(1);
			flag = true;
			break;

		case this.keyCode.LEFT:
			this.moveFocusToPreviousMonth(1);
			flag = true;
			break;

		case this.keyCode.DOWN:
			this.moveFocusToNextMonth(4);
			flag = true;
			break;

		case this.keyCode.UP:
			this.moveFocusToPreviousMonth(4);
			flag = true;
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.moveFocusToNextYear = function (num) {
	const newYear = this.yearSelect + num;
	this.moveFocusToYear(newYear);
};

DatePicker.prototype.moveFocusToPreviousYear = function (num) {
	const newYear = this.yearSelect - num;
	this.moveFocusToYear(newYear);
};

DatePicker.prototype.moveFocusToYear = function (newYear) {
	if (this.yearSelect != newYear) {
		this.updateGridYearSelected(newYear);
	}
};

DatePicker.prototype.updateGridYearSelected = function (newYear) {
	let initialYearFocus = this.initialDate ? this.initialDate.getFullYear() : 0;
	let finalYearFocus = this.finalDate ? this.finalDate.getFullYear() : 0;

	if (
		initialYearFocus <= newYear &&
		((finalYearFocus >= newYear && finalYearFocus != 0) || finalYearFocus == 0)
	) {
		let yearStart = this.buttonsCellsYears[0].getAttribute('data-date');
		let yearEnd =
			this.buttonsCellsYears[this.buttonsCellsYears.length - 1].getAttribute(
				'data-date'
			);
		this.yearSelect = newYear;

		if (
			parseInt(yearEnd) < parseInt(newYear) ||
			parseInt(yearStart) > parseInt(newYear)
		) {
			this.updateYearGrid();
			this.updateGridYear();
			this.markDateSelected();
		}

		this.buttonsCellsYears.forEach(function (e) {
			const year = e.getAttribute('data-date');
			e.setAttribute(
				'tabindex',
				parseInt(newYear) == parseInt(year) ? '0' : '-1'
			);

			if (parseInt(newYear) == parseInt(year)) {
				e.focus();
			}
		});
	}
};

DatePicker.prototype.handleKeyDownYear = function (event) {
	let flag = false;

	switch (event.keyCode) {
		case this.keyCode.ENTER:
		case this.keyCode.SPACE:
			if (this.viewMonth) {
				this.showMonthsYear();
				this.updateGridTextMonth();
				this.setFocusMonth(true);
				this.uncheckDateSelected();
			} else {
				this.handleYearButton(event);
			}
			flag = true;
			break;

		case this.keyCode.TAB:
			if (!event.shiftKey) {
				this.hide();
			}
			break;

		case this.keyCode.ESC:
			this.hide();
			flag = true;
			break;

		case this.keyCode.RIGHT:
			this.moveFocusToNextYear(1);
			flag = true;
			break;

		case this.keyCode.LEFT:
			this.moveFocusToPreviousYear(1);
			flag = true;
			break;

		case this.keyCode.DOWN:
			this.moveFocusToNextYear(4);
			flag = true;
			break;

		case this.keyCode.UP:
			this.moveFocusToPreviousYear(4);
			flag = true;
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

DatePicker.prototype.getFormatDate = function (date) {
	let dateNew = '';

	if (date) {
		let parts = date.split('-');

		if (
			parts.length === 3 &&
			Number.isInteger(parseInt(parts[0])) &&
			Number.isInteger(parseInt(parts[1])) &&
			Number.isInteger(parseInt(parts[2]))
		) {
			dateNew = new Date(
				parseInt(parts[0]),
				parseInt(parts[1]) - 1,
				parseInt(parts[2])
			);
		}
	}
	return dateNew;
};

DatePicker = DatePicker || {};

CalendarContainerButtonInput = function (iconContainer, datepicker, inputNode) {
	this.datepicker = datepicker;
	this.iconContainer = iconContainer;
	this.inputNode = inputNode;
};

CalendarContainerButtonInput.prototype.init = function () {
	this.iconContainer.addEventListener('click', this.handleClick.bind(this));
	this.inputNode.addEventListener('click', this.handleClick.bind(this));
};

CalendarContainerButtonInput.prototype.handleClick = function (event) {
	this.monthSelected = '';
	this.yearSelect = '';
	if (!this.datepicker.isOpen()) {
		this.datepicker.show();
		if (this.datepicker.viewDay) {
			this.datepicker.setFocusDay();
		} else if (this.datepicker.viewMonth) {
			this.datepicker.showMonthsYear();
			this.datepicker.updateGridTextMonth();
			this.datepicker.setFocusMonth(false);
		} else {
			this.datepicker.showYearsDecade();
			this.datepicker.updateGridYear();
			this.datepicker.setFocusYear(false);
		}
	} else {
		this.datepicker.hide();
	}

	this.datepicker.inputNode.focus();

	event.stopPropagation();
	event.preventDefault();
};

CalendarButtonInput = function (inputNode, datepicker) {
	this.inputNode = inputNode;
	this.imageNode = false;

	this.datepicker = datepicker;

	this.defaultLabel = 'Choose Date';

	this.keyCode = Object.freeze({
		ENTER: 13,
		SPACE: 32,
		TAB: 9,
	});
};

CalendarButtonInput.prototype.init = function () {
	this.inputNode.addEventListener('keydown', this.handleKeyDown.bind(this));
};

CalendarButtonInput.prototype.handleKeyDown = function (event) {
	let flag = false;

	switch (event.keyCode) {
		case this.keyCode.SPACE:
		case this.keyCode.ENTER:
			this.datepicker.show();
			if (this.datepicker.viewDay) {
				this.datepicker.setFocusDay();
			} else if (this.datepicker.viewMonth) {
				this.datepicker.showMonthsYear();
				this.datepicker.updateGridTextMonth();
				this.datepicker.setFocusMonth(true);
			} else {
				this.datepicker.showYearsDecade();
				this.datepicker.updateGridYear();
				this.datepicker.setFocusYear(true);
			}
			flag = true;
			break;
		case this.keyCode.TAB:
			if (event.shiftKey) {
				this.datepicker.hide();
			}
			break;

		default:
			break;
	}

	if (flag) {
		event.stopPropagation();
		event.preventDefault();
	}
};

CalendarButtonInput.prototype.setFocus = function () {
	this.inputNode.focus();
};

CalendarButtonInput.prototype.setDate = function (day) {
	let value = '';
	if (
		this.datepicker.viewMonth &&
		!this.datepicker.viewDay &&
		!this.datepicker.viewYear
	) {
		value = this.datepicker.monthLabels[day.getMonth()];
	} else {
		if (this.datepicker.viewDay) {
			value = formatNumber(day.getDate()) + '/';
		}
		if (this.datepicker.viewMonth) {
			value += formatNumber(day.getMonth() + 1);
		}
		if (this.datepicker.viewYear) {
			value += (this.datepicker.viewMonth ? '/' : '') + day.getFullYear();
		}
	}

	this.inputNode.value = value;
};

function formatNumber(number) {
	return number <= 9 ? '0' + number : number;
}

function formatStringMonth(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

CalendarButtonInput.prototype.getDate = function () {
	let value = this.inputNode.value;

	if (Number.isInteger(parseInt(value))) {
		return value;
	}

	if (
		value &&
		this.datepicker.viewMonth &&
		!this.datepicker.viewDay &&
		!this.datepicker.viewYear
	) {
		const indexMonth = this.datepicker.monthLabels.indexOf(
			formatStringMonth(value)
		);

		if (indexMonth > -1) {
			value = formatNumber((indexMonth + 1).toString());
		} else {
			this.inputNode.value = '';
		}
	}
	return value;
};

/* ===================================== Carga de Archivos ===================================== */
var attachmentList = {};
var selectedFiles = {};
var configFileInputs = {};
var fileUploadMessageTypes = {
	extensionNotAllowed: 'Formato de archivo no permitido.',
	sizeNotAllowed: 'El archivo excede el tamaño máximo permitido.',
	extensionsNotAllowed: 'Uno de los archivos tiene un formato no admitido.',
	sizesNotAllowed: 'Uno de los archivos excede el tamaño máximo permitido.',
	noFile: 'Seleccione un documento para adjuntar.',
	maximumQuantityExceeded: 'Supera la cantidad de archivos permitida.',
};

function initFileUpload() {
	addEventHandler(
		document.body,
		'click keydown',
		'.carga-archivo-govco',
		function (event) {
			assignEventsFileUpload();
		}
	);

	assignEventsFileUpload();
}

function assignEventsFileUpload() {
	const containersFileUpload = document.querySelectorAll(
		'.carga-archivo-govco:not(.actived-events-govco)'
	);
	for (const containerFileUpload of containersFileUpload) {
		containerFileUpload.classList.add('actived-events-govco');

		const inputsFile = containerFileUpload.querySelectorAll(
			'.input-carga-archivo-govco'
		);
		methodAssignFileInput('change', selectingFiles, inputsFile);

		const buttonsFile = containerFileUpload.querySelectorAll(
			'.button-loader-carga-archivo-govco'
		);
		methodAssign('click', clickButtonFile, buttonsFile);
	}
}

//Por defaul maximo 5 archivos sin validaciones
function methodAssignFileInput(e, f, a) {
	for (let i of a) {
		i.addEventListener(e, f, false);
		attachmentList[i.id] = [];
		selectedFiles[i.id] = [];
		configFileInputs[i.id] = {
			validExtensions: [],
			validSize: 0,
			maximumQuantity: 5,
		};
	}
}

function selectingFiles() {
	const idInput = this.id;
	const parent = this.parentNode;
	const parentCarga = parent.parentNode;
	const button = parentCarga.querySelector(
		'.button-loader-carga-archivo-govco'
	);
	let fileName = '';
	const maximumQuantity = configFileInputs[idInput]['maximumQuantity'];
	selectedFiles[idInput] = [];
	errorInputFile(this, false, '');

	if (attachmentList[idInput].length + this.files.length > maximumQuantity) {
		errorInputFile(this, true, fileUploadMessageTypes.maximumQuantityExceeded);
		if (attachmentList[idInput].length >= maximumQuantity) {
			this.disabled = true;
			this.classList.remove('active');
		}
	} else if (this.files.length > 0) {
		let validations = validateFiles(this.files, idInput);

		if (validations.invalidExtensions === 0 && validations.invalidSize === 0) {
			if (selectedFiles[idInput] && selectedFiles[idInput].length > 1) {
				fileName = selectedFiles[idInput].length + ' archivos seleccionados';
			} else {
				fileName = selectedFiles[idInput][0].name;
			}
			assignName(parent, fileName);
			enableDisableFileUploadButton(button, false);
		} else {
			selectedFiles[idInput] = [];
			const textError = validationErrortext(
				validations.invalidExtensions,
				validations.invalidSize
			);
			errorInputFile(this, true, textError);
		}
	} else {
		errorInputFile(this, true, fileUploadMessageTypes.noFile);
		cleanInputfile(this, parent);
		enableDisableFileUploadButton(button, true);
	}
}

function validationErrortext(extensions, size) {
	let textoError = '';
	if (extensions > 0) {
		if (extensions > 1) {
			textoError = fileUploadMessageTypes.extensionNotAllowed;
		} else {
			textoError = fileUploadMessageTypes.extensionsNotAllowed;
		}
	}

	if (size > 0) {
		if (size > 1) {
			textoError += ' ' + fileUploadMessageTypes.sizeNotAllowed;
		} else {
			textoError += ' ' + fileUploadMessageTypes.sizesNotAllowed;
		}
	}

	return textoError;
}

function validateFiles(files, idInput) {
	let invalidExtensions = 0;
	let invalidSize = 0;
	let listValidExtensions = configFileInputs[idInput]['validExtensions'];
	let validSize = configFileInputs[idInput]['validSize'];

	if (listValidExtensions.length > 0 || validSize > 0) {
		[...files].forEach(function (element) {
			const extensionFile = element.name.split('.').pop().toLowerCase();
			if (
				listValidExtensions &&
				Array.isArray(listValidExtensions) &&
				listValidExtensions.includes(extensionFile)
			) {
				if (validSize >= element.size) {
					selectedFiles[idInput].push(element);
				} else {
					invalidSize++;
				}
			} else {
				invalidExtensions++;
			}
		});
	} else {
		selectedFiles[idInput].push(...files);
	}

	return {
		invalidExtensions: invalidExtensions,
		invalidSize: invalidSize,
	};
}

function setValidationParameters(
	idElement,
	extensions = [],
	size = 0,
	quantity = 1
) {
	const validExtensions = extensions.map((e) => e.toString().toLowerCase());
	const validSize = !isNaN(size) ? parseInt(size) : 0;
	const maximumQuantity = !isNaN(quantity) ? parseInt(quantity) : 0;

	configFileInputs[idElement] = {
		validExtensions: validExtensions,
		validSize: validSize,
		maximumQuantity: maximumQuantity,
	};
}

function assignName(container, fileName) {
	const containerNameFile = container.querySelector(
		'.file-name-carga-archivo-govco'
	);
	containerNameFile.innerHTML = fileName
		? fileName
		: 'Sin archivo seleccionado';
}

function enableDisableFileUploadButton(element, value) {
	element.classList.toggle('inactive', value);
}

async function clickButtonFile() {
	const parentButton = this.parentNode;
	const parent = parentButton.parentNode;
	const inputFile = parent.querySelector('.input-carga-archivo-govco');
	const idInput = inputFile.id;
	const containerLoader = parent.querySelector('.load-carga-archivo-govco');
	activateContainerLoader(containerLoader, true);
	enableDisableFileUploadButton(this, true);

	if (inputFile.value) {
		const containerParent = parent.nextElementSibling;
		const container = containerParent.querySelector(
			'.attached-files-carga-archivo-govco'
		);

		const filesResponse = await validateFunction(
			inputFile,
			containerLoader,
			parent,
			'add',
			selectedFiles[idInput]
		);
		if (filesResponse.length > 0) {
			createAttachedFiles(container, filesResponse, idInput);

			containerParent.style.display =
				attachmentList[idInput].length > 0 ? 'block' : 'none';

			if (
				attachmentList[idInput].length >=
				configFileInputs[idInput]['maximumQuantity']
			) {
				inputFile.disabled = true;
				inputFile.classList.remove('active');
			}
		}
		cleanInputfile(inputFile, parent);
	} else {
		errorInputFile(inputFile, true, fileUploadMessageTypes.noFile);
		activateContainerLoader(containerLoader, false);
	}
}

async function validateFunction(
	inputFile,
	containerLoader,
	parent,
	action,
	listFiles
) {
	const nameDataAction = action == 'add' ? 'data-action' : 'data-action-delete';
	const nameMethod = inputFile.getAttribute(nameDataAction);
	let method;
	let answer = {};

	if (!nameMethod) {
		console.error(nameDataAction + ' method is not defined');
	}

	try {
		//method = new Function('return ' + nameMethod)();
		method = JSON.parse(nameMethod); //cambio por sonarqube
	} catch (error) {
		console.error(nameDataAction + ' method is not defined');
	}

	if (method) {
		try {
			answer = await method(listFiles);
			activateContainerLoader(containerLoader, false);
			if (action == 'delete') return true;
		} catch (error) {
			errorInputFile(inputFile, true, error);
			activateContainerLoader(containerLoader, false);
			cleanInputfile(inputFile, parent);
			if (action == 'delete') return false;
		}
	} else {
		answer = listFiles;
		activateContainerLoader(containerLoader, false);
		if (action == 'delete') return true;
	}
	return answer;
}

function errorInputFile(input, active, message) {
	const parentInput = input.parentNode;
	const parentAllInput = parentInput.parentNode;
	const containerParent = parentAllInput.nextElementSibling;
	const containerAlert = containerParent.querySelector(
		'.alert-carga-archivo-govco'
	);
	const idInput = input.id;
	input.setAttribute('data-error', active ? 'true' : 'false');
	activateContainer(containerAlert, active);
	containerAlert.innerHTML = message;

	if (attachmentList[idInput].length <= 0) {
		containerParent.style.display = active ? 'block' : 'none';
	}
}

function activateContainer(container, active) {
	if (active) {
		container.classList.remove('visually-hidden');
	} else {
		container.classList.add('visually-hidden');
	}
}

function activateContainerLoader(container, active) {
	if (active) {
		container.style.visibility = 'visible';
	} else {
		setTimeout(() => {
			container.style.visibility = 'hidden';
		}, 3000);
	}
}

function cleanInputfile(inputFile, container) {
	inputFile.value = '';
	assignName(container, '');
}

function createAttachedFiles(container, files, idInput) {
	files.forEach(function (value) {
		const size = formatterSizeUnit(value.size);
		createElement(container, value.name, size);
		attachmentList[idInput].push(value);
	});

	return true;
}

function createElement(container, name, type) {
	const newDivAttached = document.createElement('div');
	newDivAttached.classList.add('attached-file-carga-archivo-govco');
	newDivAttached.setAttribute('tabindex', '0');

	const newDivContainerIcon = document.createElement('div');
	newDivContainerIcon.classList.add('icon-text-carga-archivo-govco');

	const newDivIconFile = document.createElement('div');
	newDivIconFile.classList.add(
		'file-alt-carga-archivo-govco',
		'govco-icon',
		'govco-file-alt'
	);

	const newDiv = document.createElement('div');
	newDiv.classList.add('container-text-name-carga-archivo-govco');
	const span1 = document.createElement('span');
	span1.classList.add('text-name-carga-archivo-govco');
	const textSpan1 = document.createTextNode(name);
	span1.appendChild(textSpan1);
	const span2 = document.createElement('span');
	const textSpan2 = document.createTextNode(type);
	span2.appendChild(textSpan2);

	const newButtonIconTrash = document.createElement('button');
	newButtonIconTrash.classList.add(
		'trash-alt-1-carga-archivo-govco',
		'govco-icon',
		'govco-trash'
	);

	newDivContainerIcon.appendChild(newDivIconFile);
	newDiv.appendChild(span1);
	newDiv.appendChild(span2);
	newDivContainerIcon.appendChild(newDiv);
	newDivAttached.appendChild(newDivContainerIcon);
	newDivAttached.appendChild(newButtonIconTrash);
	container.appendChild(newDivAttached);

	newButtonIconTrash.addEventListener('click', removeAttachment, false);
}

function formatterSizeUnit(size) {
	if (size) {
		var result = parseInt(size);
		if (result < 1024) {
			return result + 'bytes';
		} else if (result < 1024 * 1024) {
			return parseInt(result / 1024) + 'KB';
		} else if (result < 1024 * 1024 * 1024) {
			return parseInt(result / (1024 * 1024)) + 'MB';
		} else {
			return parseInt(result / (1024 * 1024 * 1024)) + 'GB';
		}
	}
}

async function removeAttachment() {
	const container = this.parentNode;
	const containerAttachments = container.parentNode;
	const containerDetail = containerAttachments.parentNode;
	const containerAll = containerDetail.parentNode;
	const inputFile = containerAll.querySelector('.input-carga-archivo-govco');
	const idInput = inputFile.id;
	const containerLoader = containerAll.querySelector(
		'.load-carga-archivo-govco'
	);
	const containerName = container.querySelector(
		'.text-name-carga-archivo-govco'
	);
	const name = containerName.innerHTML;
	const element = attachmentList[idInput].find((file) => file.name === name);
	const index = attachmentList[idInput].indexOf(element);

	activateContainerLoader(containerLoader, true);

	if (index >= 0) {
		const responseRemove = await validateFunction(
			inputFile,
			containerLoader,
			containerAll,
			'delete',
			element
		);

		if (responseRemove == true) {
			let parent = container.parentNode;
			attachmentList[idInput].splice(index, 1);
			parent.removeChild(container);
			if (
				attachmentList[idInput].length <
				configFileInputs[idInput]['maximumQuantity']
			) {
				inputFile.disabled = false;
				inputFile.classList.add('active');
			}
			containerDetail.style.display =
				attachmentList[idInput].length > 0 ? 'block' : 'none';
		}
	} else {
		activateContainerLoader(containerLoader, false);
	}
}

/* ============================== Alerta Modal ============================== */

function openModal() {
	let modalItems = document.querySelectorAll('.container-modal-govco');
	modalItems.forEach(function (modalItem) {
		modalItem.style.display = 'block';
	});
}

function closeModal(nombre_modal) {
	document.getElementById(nombre_modal).style.display = 'none';
}

/* ============================== Entradas de texto ============================== */
function textFields() {
  addEventHandler(document.body, 'click keydown', '.entradas-de-texto-govco', function(event) {
    counterTextFields();
    passwordTextFields();
    mailTextFields();
    phoneTextFields();
  });

  counterTextFields();
  passwordTextFields();
  mailTextFields();
  phoneTextFields();
}

// Con contador
function counterTextFields() {
  const inputs = document.querySelectorAll('.entradas-de-texto-govco input[typeData="accountant"]:not(.actived-events-govco)');
  methodAssign("keyup", activeInputContador, inputs);

  for (const input of inputs) {
    input.parentNode.classList.add('actived-events-govco');
  }
}

function activeInputContador(element) {
  const maxLength = element.srcElement.maxLength;
  const parentInputContador = this.parentNode;
  const span = parentInputContador.querySelector(".counter-text");
  span.innerHTML = this.value.length + "/" + maxLength;
}

// De contraseña
function passwordTextFields() {
  const inputs = document.querySelectorAll('.entradas-de-texto-govco input[typeData="password"]:not(.actived-events-govco)');
  methodAssign("keyup", activeInputContrasenia, inputs);

  for (const input of inputs) {
    input.parentNode.classList.add('actived-events-govco');
    const buttons = input.parentNode.querySelectorAll('input[typeData="password"] ~ button');
    methodAssign("click", activeIconInputPassword, buttons);
  }
}

function activeIconInputPassword(element) {
  const parentPassword = this.parentNode;
  const inputPassword = parentPassword.querySelector('.entradas-de-texto-govco input');
  const hidePassword = parentPassword.querySelector('button:not(.view-password)');
  const visiblePassword = parentPassword.querySelector('button.view-password');

  if (inputPassword.getAttribute('disabled') === null) {
    if (inputPassword.type == 'password') {
      inputPassword.type = 'text';
      visiblePassword.classList.remove('d-none');
      hidePassword.classList.add('d-none');
    } else {
      inputPassword.type = 'password';
      hidePassword.classList.remove('d-none');
      visiblePassword.classList.add('d-none');
    }
  }
}

function activeInputContrasenia(element) {
  const expresionRegularP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\-_\/\.,|{}<>\[\]\(\)=?\+Â¿Â¡])(?=.{8,})/;
  const textExito = "Contraseña correcta";
  const textError = "Contraseña incorrecta, debe contener mánimo ocho (8) caracteres, un número, una letra minúscula, una letra mayúscula, un carácter especial.";

  if (expresionRegularP.test(this.value) && this.classList.contains("success") === false) {
    this.classList.remove('error');
    this.classList.add('success');
    crearMensaje(this, textExito, 'success', 'password-note');
  } else if (expresionRegularP.test(this.value) === false && this.classList.contains("error") === false) {
    this.classList.remove('success');
    this.classList.add('error');
    crearMensaje(this, textError, 'error', 'password-note');
  }
}

// correo electrónico
function mailTextFields() {
  const inputs = document.querySelectorAll('.entradas-de-texto-govco input[typeData="mail"]:not(.actived-events-govco)');
  methodAssign("keyup", activeInputCorreo, inputs);

  for (const input of inputs) {
    input.parentNode.classList.add('actived-events-govco');
  }
}

function activeInputCorreo(element) {
  const expresionRegularE = /^([\da-z_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
  const textExito = "Correo electrónico válido";
  const textError = "Correo electrónico no válido";

  if (expresionRegularE.test(this.value) && this.classList.contains("success") === false) {
    this.classList.remove('error');
    this.classList.add('success');
    crearMensaje(this, textExito, 'success', '');
  } else if (expresionRegularE.test(this.value) === false && this.classList.contains("error") === false) {
    this.classList.remove('success');
    this.classList.add('error');
    crearMensaje(this, textError, 'error', '');
  }
}

// teléfono
function phoneTextFields() {
  const inputs = document.querySelectorAll('.entradas-de-texto-govco input[typeData="phone"]:not(.actived-events-govco)');
  methodAssign("keyup", activeInputTelefono, inputs);

  for (const input of inputs) {
    input.parentNode.classList.add('actived-events-govco');
  }
}

function activeInputTelefono(element) {
  const expresionRegularE = /^[+]?\(?(\d{2})\)?[-]?(\d{3})[-]?(\d{5,7})$/;
  const textExito = "Número de teléfono válido";
  const textError = "Número de teléfono no válido";

  if (expresionRegularE.test(this.value) && this.classList.contains("success") === false) {
    this.classList.remove('error');
    this.classList.add('success');
    crearMensaje(this, textExito, 'success', '');
  } else if (expresionRegularE.test(this.value) === false && this.classList.contains("error") === false) {
    this.classList.remove('success');
    this.classList.add('error');
    crearMensaje(this, textError, 'error', '');
  }
}

// Validaciones
function crearMensaje(e, text, type, describedby) {
  const dataMensajes = {
    'success': {
      'id': 'campoSuccess-id',
      'aria-invalid': 'false',
      'class': 'success-text-govco',
      'role': 'status',
      'aria-live': 'polite',
    },
    'error': {
      'id': 'campoWarning-id',
      'aria-invalid': 'true',
      'class': 'error-text-govco',
      'role': 'alert',
      'aria-live': 'assertive',
    }
  };

  const parentInput = e.closest('.entradas-de-texto-govco');
  const spanOld = parentInput.querySelector('.information-text');
  if (spanOld) { parentInput.removeChild(spanOld); }
  const newSpan = document.createElement('span');
  const span = parentInput.appendChild(newSpan);

  e.setAttribute('aria-describedby', describedby + ' ' + dataMensajes[type]['id']);
  e.setAttribute('aria-invalid', dataMensajes[type]['aria-invalid']);

  span.textContent = text;
  span.classList.add(dataMensajes[type]['class'], 'information-text');
  span.id = dataMensajes[type]['id'];
  span.setAttribute('role', dataMensajes[type]['role']);
  span.setAttribute('aria-live', dataMensajes[type]['aria-live']);
}

/* ============================== Tablas ============================== */
function initTables() {
	//responsiveTables();
	addEventsTables();

	addEventHandler(
	  document.body,
	  'click keydown',
	  '.tabla-govco .sort, .tabla-govco th input[type="checkbox"], .tabla-govco td input[type="checkbox"]',
	  function(event) {
		addEventsTables(event);
	  }
	);
  }

  function addEventsTables(event = null) {
	const containersTable = document.querySelectorAll('.tabla-govco:not(.actived-events-govco)');
	for (const containerTable of containersTable) {
	  containerTable.classList.add('actived-events-govco');

	  const sortTH = containerTable.querySelectorAll('.sort');
	  methodAssign("click", activeSortTable, sortTH);

	  const checkTH = containerTable.querySelectorAll('th input[type="checkbox"]');
	  methodAssign("click", activateAllRows, checkTH);
	  methodAssign("keydown", eventKeydownItem, checkTH);

	  const checkTD = containerTable.querySelectorAll('td input[type="checkbox"]');
	  methodAssign("click", activateRows, checkTD);
	  methodAssign("keydown", eventKeydownItem, checkTD);
	}
	if (event != null && containersTable.length > 0) {
	  event.target.click();
	}
  }

  function activeSortTable(event) {
	this.setAttribute('aria-sort', this.getAttribute('aria-sort') == 'asc' ? 'desc' : 'asc');
  }

  function activateAllRows() {
	const table = this.closest('table');
	const trs = table.querySelectorAll('tbody tr');
	for (let tr of trs) {
	  const check = tr.querySelector('td input[type="checkbox"]');
	  if (check) {
		if (this.checked) {
		  tr.classList.add('active');
		  check.checked = true;
		} else {
		  tr.classList.remove('active');
		  check.checked = false;
		}
	  }
	}
  }

  /* function activateRows() {
	const tr = this.closest('tr');
	const responsiveTable = this.closest('.responsive-tabla-govco');

	if (responsiveTable) {
	  const trs = tr.closest('table').querySelectorAll('tr');
	  for (const tr of trs) {
		activateRow(this, tr);
	  }
	} else {
	  activateRow(this, tr);
	}
  }

  function activateRow(e, tr) {
	if (e.checked) {
	  tr.classList.add('active');
	} else {
	  tr.classList.remove('active');
	}
  }

  function responsiveTables() {
	const containersTable = document.querySelectorAll('.tabla-govco');
	for (let containerTable of containersTable) {
	  if (containerTable.offsetWidth <= 360 && containerTable.offsetWidth > 0) {
		if (!containerTable.classList.contains('responsive-tabla-govco') && !containerTable.classList.contains('d-none')) {
		  createResponsiveTable(containerTable);
		}
	  } else if(containerTable.offsetWidth > 0) {
		const parent = containerTable.parentNode;
		const containerTableDesktop = parent.querySelector('.tabla-govco.d-none');
		containerTableDesktop?.classList.remove('d-none');
		containerTableDesktop?.removeAttribute('aria-hidden');

		if (containerTable.classList.contains('responsive-tabla-govco')) {
		  containerTable.parentNode.removeChild(containerTable);
		}
	  }
	}
  }

  function createResponsiveTable(containerTableDesktop) {
	const tableDesktop = containerTableDesktop.querySelector('table');
	const trsDesktop = tableDesktop.querySelectorAll('tbody tr');

	const containerTableResponsive = document.createElement('div');
	createAtributesResponsiveTable(containerTableResponsive, containerTableDesktop);
	containerTableResponsive.classList.add('responsive-tabla-govco');
	containerTableDesktop.parentNode.insertBefore(containerTableResponsive, containerTableDesktop);

	containerTableDesktop.classList.add('d-none');
	containerTableDesktop.setAttribute('aria-hidden', 'true');

	for (const trDesktop of trsDesktop) {
	  if (trDesktop.classList.contains('internal-table-container')) {
		getContentResponsiveInternalTable(trDesktop, containerTableResponsive);
	  } else if (!trDesktop.closest('table.internal-table')) {
		const table = document.createElement('table');
		createAtributesResponsiveTable(table, tableDesktop);
		containerTableResponsive.appendChild(table);

		if (trDesktop.classList.contains('d-none')) {
		  table.classList.add('d-none');
		} else {
		  createBodyResponsiveTable(tableDesktop, table, trDesktop);
		}
	  }
	}

	createFooterResponsiveTable(containerTableDesktop, containerTableResponsive);
  }

  function createAtributesResponsiveTable(element, desktopElement) {
	const attrs = desktopElement.attributes;
	if (attrs) {
	  for (const attr of attrs) {
		if (attr.name != 'aria-hidden') {
		  element.setAttribute(attr.name, attr.value);
		}
	  }
	}
  }

  function createBodyResponsiveTable(tableDesktop, table, trDesktop) {
	const bodyDesktop = tableDesktop.querySelectorAll('tbody');

	const tbody = document.createElement('tbody');
	createAtributesResponsiveTable(tbody, bodyDesktop);
	table.appendChild(tbody);

	getBodyContentResponsiveTable(tableDesktop, trDesktop, tbody);
  }

  function getBodyContentResponsiveTable(tableDesktop, trDesktop, tbody) {
	const thsDesktop = tableDesktop.querySelectorAll('thead tr th');
	const tdsDesktop = trDesktop.querySelectorAll('td');

	for (let j = 0; j < thsDesktop.length; j++) {
	  const thDesktop = thsDesktop[j];
	  const tdDesktop = tdsDesktop[j];
	  if (!thDesktop.closest('table.internal-table') && !thDesktop.classList.contains('no-responsive')) {
		let btnCollapse = getItemButtonCollapse(tdsDesktop, trDesktop, j);

		if (!thDesktop.querySelector('.checkbox-seleccion-govco') && !tdDesktop.querySelector('.checkbox-seleccion-govco')) {
		  let checkbox = getItemCheckbox(tdsDesktop, j);
		  createTRBodyResponsiveTable(trDesktop, thDesktop, tdDesktop, tbody, checkbox, btnCollapse);
		}
	  }
	}
  } */

  function getItemButtonCollapse(tdsDesktop, trDesktop, index) {
	let btnCollapse = "";
	if (trDesktop.querySelector('.btn-collapse') && index == 1) {
	  btnCollapse = tdsDesktop[tdsDesktop.length-1].querySelector('.btn-collapse').cloneNode(true);
	}
	return btnCollapse;
  }

  function getItemCheckbox(tdsDesktop, index) {
	let checkbox = "";
	if (index == 1 && tdsDesktop[0].querySelector('.checkbox-seleccion-govco')) {
	  checkbox = tdsDesktop[0].querySelector('.checkbox-seleccion-govco').cloneNode(true);
	}
	return checkbox;
  }

  function createTRBodyResponsiveTable(trDesktop, thDesktop, tdDesktop, tbody, checkbox, btnCollapse) {
	const tr = document.createElement('tr');
	createAtributesResponsiveTable(tr, trDesktop);
	tbody.appendChild(tr);

	createTHBodyResponsiveTable(thDesktop, tdDesktop, tr, checkbox, btnCollapse)
  }

  function createTHBodyResponsiveTable(thDesktop, tdDesktop, tr, checkbox, btnCollapse) {
	const th = document.createElement('th');
	createAtributesResponsiveTable(th, thDesktop);
	th.textContent = thDesktop.textContent;
	th.classList.remove('text-center');
	tr.appendChild(th);

	createTDBodyResponsiveTable(tdDesktop, tr, checkbox, btnCollapse)
  }

  function createTDBodyResponsiveTable(tdDesktop, tr, checkbox, btnCollapse) {
	const td = document.createElement('td');
	createAtributesResponsiveTable(td, tdDesktop);

	const div = document.createElement('div');
	div.innerHTML =  tdDesktop.innerHTML;
	td.appendChild(div);

	if (checkbox && !tdDesktop.closest('.internal-table')) {
	  div.appendChild(checkbox.cloneNode(true));
	  const inputCheck = td.querySelector('input[type="checkbox"]');
	  inputCheck.addEventListener('click', activateRows, true);
	  inputCheck.addEventListener('keydown', eventKeydownItem, true);
	}

	if (btnCollapse) {
	  btnCollapse.classList.add('btn-collapse-responsive');
	  td.appendChild(btnCollapse.cloneNode(true));
	}

	tr.appendChild(td);
  }

  function createFooterResponsiveTable(containerTable, containerTableResponsive) {
	const tableDesktop = containerTable.querySelector('table');
	const tfootDesktop = tableDesktop.querySelector('tfoot');
	if (!tfootDesktop) {
	  return;
	}
	const trDesktop = tfootDesktop.querySelector('tr');
	const table = document.createElement('table');
	containerTableResponsive.appendChild(table);

	const tfoot = document.createElement('tfoot');
	createAtributesResponsiveTable(tfoot, tfootDesktop);
	table.appendChild(tfoot);

	getBodyContentResponsiveTable(tableDesktop, trDesktop, tfoot);
  }

  function getContentResponsiveInternalTable(trDesktop, containerTableResponsive) {
	const divDesktop = trDesktop.querySelector('div.internal-table-second-container');
	const containerInternalTable = document.createElement('div');
	createAtributesResponsiveTable(containerInternalTable, divDesktop);
	containerTableResponsive.appendChild(containerInternalTable);

	createResponsiveCaptionInternalTable(containerInternalTable, divDesktop);
	createResponsiveInternalTable(containerInternalTable, divDesktop);
  }

  function createResponsiveCaptionInternalTable(containerInternalTable, containerTable) {
	const caption = containerTable.querySelector('caption');

	const div = document.createElement('div');
	createAtributesResponsiveTable(div, caption);
	div.innerHTML = caption.innerHTML;
	containerInternalTable.appendChild(div);
  }

  function createResponsiveInternalTable(containerInternalTable, containerTable) {
	const tableDesktop = containerTable.querySelector('table');
	const tbody = tableDesktop.querySelector('tbody');
	const trsDesktop = tbody.querySelectorAll('tr');

	for (let i = 0; i < trsDesktop.length; i++) {
	  const trDesktop = trsDesktop[i];
	  const table = document.createElement('table');
	  createAtributesResponsiveTable(table, tableDesktop);
	  containerInternalTable.appendChild(table);

	  if (i < (trsDesktop.length-1)) {
		const hr = document.createElement('hr');
		containerInternalTable.appendChild(hr);
	  }

	  createBodyResponsiveInternalTable(tableDesktop, table, trDesktop);
	}
  }

  function createBodyResponsiveInternalTable(tableDesktop, table, trDesktop) {
	const bodyDesktop = tableDesktop.querySelectorAll('tbody');

	const tbody = document.createElement('tbody');
	createAtributesResponsiveTable(tbody, bodyDesktop);
	table.appendChild(tbody);

	getBodyContentResponsiveInternalTable(tableDesktop, trDesktop, tbody);
  }

  function getBodyContentResponsiveInternalTable(tableDesktop, trDesktop, tbody) {
	const thsDesktop = tableDesktop.querySelectorAll('thead tr th');
	const tdsDesktop = trDesktop.querySelectorAll('td');

	for (let j = 0; j < thsDesktop.length; j++) {
	  const thDesktop = thsDesktop[j];
	  const tdDesktop = tdsDesktop[j];
	  if (!thDesktop.classList.contains('no-responsive')){

		let btnCollapse = "";
		if (trDesktop.querySelector('.btn-collapse') && j == 1) {
		  btnCollapse = tdsDesktop[tdsDesktop.length-1].querySelector('.btn-collapse').cloneNode(true);
		}

		let checkbox = "";
		if (tdDesktop.querySelector('.checkbox-seleccion-govco')) {
		  checkbox = tdDesktop.querySelector('.checkbox-seleccion-govco').cloneNode(true);

		  const tr = document.createElement('tr');
		  tbody.appendChild(tr);

		  const th = document.createElement('th');
		  tr.appendChild(th);

		  th.appendChild(checkbox);

		  const checkTH = th.querySelector('input[type="checkbox"]');
		  checkTH.addEventListener("click", activateRows, true);
		  checkTH.removeEventListener("click", activateAllRows);
		  checkTH.addEventListener('keydown', eventKeydownItem);

		  const td = document.createElement('td');
		  tr.appendChild(td);
		} else {
		  createTRBodyResponsiveTable(trDesktop, thDesktop, tdDesktop, tbody, checkbox, btnCollapse);
		}
	  }
	}
  }
/* ================================= Validaciones Buscador ======================================== */
  function inicializarBuscador() {
	addEventHandler(
	  document.body,
	  "click keydown",
	  ".govco-search-predictive .govco-search-basic",
	  function (event) {
		InitSearchDefault(event);
	  }
	);
	InitSearchDefault();
	initSearchPredictive();
	InitSearchDefaultResponsive();
  }

  // ============================= BUSCADOR BASICO =======================================

  function InitSearchDefault(event = null) {
	// focus
	document.querySelector(".input-search-basic-govco").addEventListener("keyup", (event) => {
	  document.querySelector(".govco-search-basic .line-basic-govco").style.display = "block";
	  document.querySelector(".btn-search-basic-govco").style.display = "block";
	  document.querySelector(".btn-clean-basic-govco").style.display = "block";

	  let inputText = document.querySelector(".input-search-basic-govco").value;

	  if(inputText === ""){
		console.log("inputText", inputText);
		document.querySelector(".govco-search-basic .line-basic-govco").style.display = "none";
		document.querySelector(".govco-search-basic .btn-clean-basic-govco").style.display = "none";
		document.querySelector(".govco-search-basic .input-search-basic-govco").value = "";
		document.querySelector(".govco-search-basic .input-search-basic-govco").focus();
		document.querySelector(".govco-search-basic .container-govco").classList.add("active");
	  }

	  if(event.keyCode === 9){
		console.log("focus tab", event);
		document.querySelector(".govco-search-basic .input-search-basic-govco").focus();
		document.querySelector(".govco-search-basic .container-govco").classList.add("active")
	  }
	});

	document.querySelector(".btn-clean-basic-govco").addEventListener("keyup", (event) => {
	  if(event.keyCode === 9){
		document.querySelector(".govco-search-basic .container-govco").focus();
		document.querySelector(".govco-search-basic .container-govco").classList.add("active");
	  }
	})

	document.querySelector(".btn-search-basic-govco").addEventListener("keyup", (event) => {
	  if(event.keyCode === 9){
		document.querySelector(".govco-search-basic .container-govco").focus();
		document.querySelector(".govco-search-basic .container-govco").classList.add("active");
	  }
	})

	document.querySelector(".input-search-basic-govco").addEventListener("click", () => {
	  document.querySelector(".govco-search-basic .container-govco").focus();
	  document.querySelector(".govco-search-basic .container-govco").classList.add("active");
	});

	// click para quitar el focus
	document.querySelector(".input-search-basic-govco").addEventListener("blur", () => {
	  document.querySelector(".govco-search-basic .container-govco").classList.remove("active");
	});

	document.querySelector(".btn-clean-basic-govco").addEventListener("click", () => {
	  document.querySelector(".govco-search-basic .line-basic-govco").style.display = "none";
	  document.querySelector(".govco-search-basic .btn-clean-basic-govco").style.display = "none";
	  document.querySelector(".govco-search-basic .input-search-basic-govco").value = "";
	  document.querySelector(".govco-search-basic .input-search-basic-govco").focus();
	  document.querySelector(".govco-search-basic .container-govco").classList.add("active");
	});
  }

  function InitSearchDefaultResponsive(event = null) {
  const inputSearch = document.querySelector(".input-search-basic-govco.search-res");
  const container = document.querySelector(".govco-search-basic.search-res .container-govco");
  const line = document.querySelector(".govco-search-basic.search-res .line-basic-govco");
  const cleanBtn = document.querySelector(".btn-clean-basic-govco.search-res");
  const searchBtn = document.querySelector(".btn-search-basic-govco.search-res");
  const input = document.querySelector(".govco-search-basic.search-res .input-search-basic-govco");

  if (inputSearch && container) {
    inputSearch.addEventListener("click", () => {
      container.focus();
      container.classList.add("active");
    });

    inputSearch.addEventListener("blur", () => {
      container.classList.remove("active");
    });

    inputSearch.addEventListener("keydown", () => {
      if (line) line.style.display = "block";
      if (searchBtn) searchBtn.style.display = "block";
      if (cleanBtn) cleanBtn.style.display = "flex";
      if (searchBtn) searchBtn.style.width = "2.63rem";
    });
  }

  if (cleanBtn && line && searchBtn && input && container) {
    cleanBtn.addEventListener("click", () => {
      line.style.display = "none";
      cleanBtn.style.display = "none";
      input.value = "";
      input.focus();
      container.classList.add("active");
      searchBtn.style.width = "2.35rem";
    });
  }
}


  //=================================================================================

  // ============================BUSCADOR PREDICTIVO===================================
  // PREDICTIVO ACTIVE

  function initSearchPredictive() {
	var container = document.querySelector(".govco-search-predictive");
	if (container !== null) {

	document.querySelector(".btn-search-predictive-govco").addEventListener("keyup", (event) => {
	  if(event.keyCode === 9){
		document.querySelector(".govco-search-predictive .container-govco").focus();
		document.querySelector(".govco-search-predictive .container-govco").classList.add("active");
	  }
	})

	document.querySelector(".btn-clean-predictive-govco").addEventListener("keyup", (event) => {
	  if(event.keyCode === 9){
		document.querySelector(".govco-search-predictive .container-govco").focus();
		document.querySelector(".govco-search-predictive .container-govco").classList.add("active");
	  }
	})

	autocomplete(document.querySelector(".input-search-predictive-govco"));
	  // initDropDownsList();
	  // agregar focus
	  document
		.querySelector(".govco-search-predictive .input-search-predictive-govco")
		.addEventListener("click", () => {
		  document
			.querySelector(".govco-search-predictive .input-search-predictive-govco")
			.focus();
		  document
			.querySelector(".govco-search-predictive .container-govco")
			.classList.add("active");
		});

	  // click para quitar el focus
	  document
		.querySelector(".input-search-predictive-govco")
		.addEventListener("blur", () => {
		  document.querySelector(".govco-search-predictive .container-govco")
			.classList.remove("active");
		});
	  // limpiar el campo
	  document
		.querySelector(".btn-clean-predictive-govco")
		.addEventListener("click", () => {
		  document.querySelector(".line-predictive-govco").style.display = "none";
		  document.querySelector(".btn-clean-predictive-govco").style.display = "none";
		  document.querySelector(".input-search-predictive-govco").value = "";
		  document.querySelector(".container-options-search-govco").style.display = "none";
		  document.querySelector(".govco-search-predictive .input-search-predictive-govco").focus();
		  document.querySelector(".govco-search-predictive .container-govco").classList.add("active");
		});

	  document.querySelector(".input-search-predictive-govco").addEventListener("keyup", (event) => {
		  document.querySelector(".line-predictive-govco").style.display = "block";
		  document.querySelector(".btn-clean-predictive-govco").style.display ="block";
		  document.querySelector( ".govco-search-predictive .container-options-search-govco").style.display = "block";

		  if(event.keyCode === 9){
			console.log("focus tab predictive", event);
			document.querySelector(".govco-search-predictive .input-search-predictive-govco").focus();
			document.querySelector(".govco-search-predictive .container-govco").classList.add("active")
		  }

		  let cont = 0;
		  //reconocimiento del texto al escribir
		  const items = document.querySelectorAll(".options-search-govco .items");
		  const text = document.querySelector(".input-search-predictive-govco").value.toUpperCase();
		  // filtrar por items
		  items.forEach(item => {
			const itemText = item.textContent || item.innerText;
			if (itemText.trim().toUpperCase().indexOf(text) > -1) {
			  item.classList.remove('d-none');
			  cont = cont - 1;
			} else {
			  item.classList.add('d-none');
			  cont = cont + 1;
			}
		  });

		  if(cont === items.length || text.length === 0){
			document.querySelector(".line-predictive-govco").style.display = "none";
			document.querySelector(".btn-clean-predictive-govco").style.display = "none";
			document.querySelector( ".govco-search-predictive .container-options-search-govco").style.display = "none";
		  }

		  if(text.length > 0){
			document.querySelector(".line-predictive-govco").style.display = "block";
			document.querySelector(".btn-clean-predictive-govco").style.display = "block";
		  }
		});

	  function autocomplete(inp) {
		var currentFocus = -1;
		inp.addEventListener("keydown", function (e) {
		  var x = document.querySelector(".list-items");
		  if (x) x = x.getElementsByTagName("li");
		  if (e.keyCode == 40) {
			//down
			currentFocus++;
			addActive(x);
		  } else if (e.keyCode == 38) {
			//up
			currentFocus--;
			addActive(x);
		  } else if (e.keyCode == 13) {
			e.preventDefault();
			if (currentFocus > -1) {
			  if (x) {
				x[currentFocus].click();
				document.querySelector(".container-options-search-govco").style.display= "none";
				methodAssign("keydown", obtenerDatoLi, x);
			  }
			}
		  }
		});

		// obtener el evento al dar click
		let list_items = document.querySelectorAll(".list-items");
		methodAssign("click", obtenerDatoLi, list_items);

		function obtenerDatoLi(event){
		  let value = event.target.innerText;
		  document.querySelector(".input-search-predictive-govco").value= value;
		  document.querySelector(".container-options-search-govco").style.display= "none";
		}

		function addActive(x) {
		  if (!x) return false;
		  removeActive(x);
		  if (currentFocus >= x.length) currentFocus = 0;
		  if (currentFocus < 0) currentFocus = x.length - 1;
		  x[currentFocus].children[0].blur();
		  x[currentFocus].children[0].classList.add("active");
		}

		function removeActive(x) {
		  for (var i = 0; i < x.length; i++) {
			x[i].children[0].classList.remove("active");
			document.querySelector(".input-search-predictive-govco").click();
		  }
		}
	  }
	}
  }

/* ================================= Fin Validaciones Buscador ======================================== */

/* ============================== Galeria de aplicaciones ============================== */

let itemsDropdownCandy = document.querySelectorAll('.dropdown-item-govco');

itemsDropdownCandy.forEach((element) => {
	if (element.classList.contains('disabled')) {
		element.setAttribute('tabIndex', -1);
	} else {
		element.removeAttribute('tabIndex');
	}
});

function activeItemCandy(itemSelected) {
	const itemsCollection = document.querySelectorAll('.dropdown-item-govco');
	itemsCollection.forEach((element) => {
		element.classList.remove('active-select');
	});
	document.getElementById(itemSelected).classList.add('active-select');
}

/* ============================== Carrusel ============================== */


let configurationCarousel = {};

function initCarrusel() {
	const carousels = document.querySelectorAll('.carrusel-govco');
	for (const carousel of carousels) {
		configurationCarousel[carousel.id] = new bootstrap.Carousel(carousel, {
			pause: false
		});

		var controlsCarrusel = carousel.querySelectorAll('.control-start-pause .controls');
		methodAssign("click", startStopCarousel, controlsCarrusel);

		carousel.addEventListener('slid.bs.carousel', function () {
			this.querySelectorAll('.carousel-item:not(.active) a').forEach(x => x.tabIndex = -1);
			this.querySelectorAll('.carousel-item.active a').forEach(x => x.tabIndex = 0);
		});
	}
}

function windowSizeCarrusel() {
	let containerInputsFile = document.querySelectorAll('.carrusel-govco');
	for (let e of containerInputsFile) {
		if (e.offsetWidth < 652) {
			e.classList.add('responsive-carrusel-govco');
		} else {
			e.classList.remove('responsive-carrusel-govco');
		}
	}
}

function methodAssign(e, f, a) {
	for (let i of a) {
		i.addEventListener(e, f, false);
	}
}

function startStopCarousel() {
	const container = this.parentNode.parentNode;
	this.classList.remove("active");

	if (this.classList.contains("start")) {
		this.nextElementSibling.classList.add("active");
		configurationCarousel[container.id].cycle();
	} else {
		this.previousElementSibling.classList.add("active");
		configurationCarousel[container.id].pause();
	}
}

/* ================================= Menú de navegación ======================================== */
function initMenu() {
	resizeMenu();
	addEventsMenu();

	addEventHandler(
	  document.body,
	  'click keydown',
	  '.menu-govco',
	  function(event) {
		addEventsMenu(event);
	  }
	);
  }

  function addEventsMenu(event = null) {
	const menus = document.querySelectorAll('.menu-govco:not(.actived-events-govco)');
	for (const menu of menus) {
	  menu.classList.add('actived-events-govco');

	  /////// Prevent closing from click inside dropdown
	  const buttons = menu.querySelectorAll('.ext-menu-govco .dropdown-menu button.nav-link');
	  methodAssign("click", stopEventItemMenu, buttons);
	  methodAssign("click", closeItemsMenu, buttons);

	  const items = menu.querySelectorAll('.nav-item a');
	  methodAssign("click", eventClickItemMenu, items);
	}
  }

  function stopEventItemMenu(e) {
	e.stopPropagation();
  }

  function eventClickItemMenu() {
	const parentNavbar = this.closest('.menu-govco');
	parentNavbar.querySelectorAll('.active').forEach(function(element) {
	  element.classList.remove('active');
	});
  }

  function resizeMenu() {
	const menus = document.querySelectorAll('.menu-govco');
	for (const menu of menus) {
	  if (window.innerWidth <= 992) {
		const items = menu.querySelectorAll('li.nav-item:not(.ext-menu-govco)');
		const extMenu = menu.querySelector('li.ext-menu-govco');
		removeItemsMenuDesktop(items, extMenu);
	  } else {
		const desktopItems = menu.querySelectorAll('li.item-desktop-govco');
		const desktopMenu = menu.querySelector('.navbar-nav');
		removeItemsMenuResponsive(desktopItems, desktopMenu);

	  }
	}
  }

  function removeItemsMenuDesktop(items, extMenu) {
	if (!extMenu) {
	  console.log('Debe agregar un nuevo item al menú con la clase "ext-menu-govco"');
	  return false;
	}

	const container = extMenu.querySelector('.dropdown-menu');
	for (let index = items.length-1; index > 3; index--) {
	  const item = items[index];

	  if (item.closest('.ext-menu-govco') == null) {
		item.classList.add('item-desktop-govco');
		container.insertBefore(item, container.firstChild);

		const button = item.querySelector('button.nav-link');
		button?.addEventListener("click", stopEventItemMenu, false);
		button?.addEventListener("click", closeItemsMenu, false);
	  }
	}
  }

  function closeItemsMenu() {
	const th = this;
	this.closest('.ext-menu-govco')?.querySelectorAll('button[aria-expanded="true"]:not(.btn-menu-govco)')
	.forEach(function(element) {
	  if (th != element) {
		element.classList.remove('show');
		element.setAttribute('aria-expanded', false);
		element.nextElementSibling.classList.remove('show');
	  }
	});
  }

  function removeItemsMenuResponsive(desktopItems, desktopMenu) {
	for (const item of desktopItems) {
	  item.classList.remove('item-desktop-govco');
	  item.querySelector('button.nav-link')?.removeEventListener("click", stopEventItemMenu);
	  desktopMenu.insertBefore(item, desktopMenu.lastChild.previousSibling);
	}
  }
/* ================================= Fin Menú de navegación ======================================== */


/* =================================== linea de avance ============================================*/
function initAdvanceLine() {
  //initDropDown();

  // LÃ­nea de avance de interacciÃ³n horizontal
  const headerHorizontalAdvanceLine = document.querySelectorAll(
    ".ih-linea-avance-govco .header-linea-avance-govco",
  );
  const indicatorHorizontalAdvanceLine = document.querySelectorAll(
    ".ih-linea-avance-govco .indicator-linea-avance-govco",
  );
  methodAssign(
    "click",
    clickHorizontalAdvanceLine,
    indicatorHorizontalAdvanceLine,
  );
  assignInitialClassMovilHAdvanceLine(headerHorizontalAdvanceLine);

  // LÃ­nea de avance de interacciÃ³n vertical
  const verticalAdvanceLine = document.querySelectorAll(
    ".iv-linea-avance-govco .indicator-linea-avance-govco",
  );
  methodAssign("click", clickVerticalAdvanceLine, verticalAdvanceLine);
}

function getActiveItemAdvanceLine(headers) {
  let x = 0;
  headers.forEach((element, index) => {
    if (element.classList.contains("active-linea-avance-govco")) {
      x = index;
    }
  });
  return x;
}

function updateProgressAdvanceLine(headers, indexActive, elementParent, wh) {
  // porcentajes establecidos
  const porcent = [15, 50, 80, 100];
  const elementActive = headers[indexActive];
  const elementIndicator = elementActive.querySelector(
    ".indicator-linea-avance-govco",
  );
  const attributePorcentage = elementIndicator.getAttribute("percentage");
  const percentage = attributePorcentage
    ? attributePorcentage
    : porcent[indexActive];
  const elementProgress = elementParent.querySelector(".progress-bar");
  elementProgress.style[wh] = percentage + "%";
  elementProgress.setAttribute("aria-valuenow", percentage);
}

function nextItemAdvanceLineIHorizonalBack(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const headers = elementParent.querySelectorAll(".header-linea-avance-govco");
  const bodys = elementParent.querySelectorAll(".body-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(headers);
  headers[indexActive].classList.remove("active-linea-avance-govco");
  headers[indexActive].classList.add("checked-linea-avance-govco");
  headers[indexActive - 1].classList.add("active-linea-avance-govco");
  headers[indexActive - 1].classList.remove("checked-linea-avance-govco");
  bodys[indexActive].classList.remove("active-linea-avance-govco");
  bodys[indexActive - 1].classList.add("active-linea-avance-govco");

  updateProgressAdvanceLine(headers, indexActive - 1, elementParent, "width");
  assignClassMovilHAdvanceLine(headers, indexActive);
}

// LÃ­nea de avance horizontal
function nextItemAdvanceLineHorizontal(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const headers = elementParent.querySelectorAll(".header-linea-avance-govco");
  const bodys = elementParent.querySelectorAll(".body-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(headers);
  headers[indexActive].classList.remove("active-linea-avance-govco");
  headers[indexActive].classList.add("inactive-linea-avance-govco");
  headers[indexActive + 1].classList.add("active-linea-avance-govco");
  bodys[indexActive].classList.remove("active-linea-avance-govco");
  bodys[indexActive + 1].classList.add("active-linea-avance-govco");

  updateProgressAdvanceLine(headers, indexActive + 1, elementParent, "width");
}

// LÃ­nea de avance vertical
function nextItemAdvanceLineVertical(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const items = elementParent.querySelectorAll(".item-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(items);
  items[indexActive]
    .closest(".item-linea-avance-govco")
    .classList.remove("active-linea-avance-govco");
  items[indexActive]
    .closest(".item-linea-avance-govco")
    .classList.add("inactive-linea-avance-govco");
  items[indexActive + 1]
    .closest(".item-linea-avance-govco")
    .classList.add("active-linea-avance-govco");

  updateProgressAdvanceLine(items, indexActive + 1, elementParent, "height");
}

// LÃ­nea de avance de interacciÃ³n horizontal
function nextItemAdvanceLineIHorizonal(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const headers = elementParent.querySelectorAll(".header-linea-avance-govco");
  const bodys = elementParent.querySelectorAll(".body-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(headers);
  headers[indexActive].classList.remove("active-linea-avance-govco");
  headers[indexActive].classList.add("checked-linea-avance-govco");
  headers[indexActive + 1].classList.add("active-linea-avance-govco");
  headers[indexActive + 1].classList.remove("checked-linea-avance-govco");
  bodys[indexActive].classList.remove("active-linea-avance-govco");
  bodys[indexActive + 1].classList.add("active-linea-avance-govco");

  updateProgressAdvanceLine(headers, indexActive + 1, elementParent, "width");
  assignClassMovilHAdvanceLine(headers, indexActive);
}

function nextItemAdvanceLineIHorizonalBack(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const headers = elementParent.querySelectorAll(".header-linea-avance-govco");
  const bodys = elementParent.querySelectorAll(".body-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(headers);
  headers[indexActive].classList.remove("active-linea-avance-govco");
  headers[indexActive].classList.add("checked-linea-avance-govco");
  headers[indexActive - 1].classList.add("active-linea-avance-govco");
  headers[indexActive - 1].classList.remove("checked-linea-avance-govco");
  bodys[indexActive].classList.remove("active-linea-avance-govco");
  bodys[indexActive - 1].classList.add("active-linea-avance-govco");

  updateProgressAdvanceLine(headers, indexActive - 1, elementParent, "width");
  assignClassMovilHAdvanceLine(headers, indexActive);
}

function clickHorizontalAdvanceLine(e) {
  const element = e.target;
  const elementParent = element.parentNode;
  if (elementParent.classList.contains("checked-linea-avance-govco")) {
    const idBody = element.getAttribute("data-la-target");
    const container = e.target.closest(".ih-linea-avance-govco");
    const headers = container.querySelectorAll(".header-linea-avance-govco");
    const headerActive = container.querySelector(
      ".header-linea-avance-govco.active-linea-avance-govco",
    );
    const bodyActive = container.querySelector(
      ".body-linea-avance-govco.active-linea-avance-govco",
    );
    const indexActiveOld = getActiveItemAdvanceLine(headers);
    headerActive.classList.remove("active-linea-avance-govco");
    headerActive.classList.add("checked-linea-avance-govco");
    bodyActive.classList.remove("active-linea-avance-govco");

    elementParent.classList.remove("checked-linea-avance-govco");
    elementParent.classList.add("active-linea-avance-govco");
    container.querySelector(idBody).classList.add("active-linea-avance-govco");

    const indexActive = getActiveItemAdvanceLine(headers);
    updateProgressAdvanceLine(headers, indexActive, container, "width");
    assignClickMovilHAdvanceLine(headers, indexActive, indexActiveOld);
  }
}

function assignInitialClassMovilHAdvanceLine(elements) {
  elements[0]?.classList?.add("movil-linea-avance-govco");
  elements[1]?.classList?.add("movil-linea-avance-govco");
  elements[2]?.classList?.add("movil-linea-avance-govco");
}

function assignClassMovilHAdvanceLine(headers, indexActive) {
  if (indexActive > 0 && indexActive + 2 < headers.length) {
    cleanClassMovilHAdvanceLine(headers);
    headers[indexActive].classList.add("movil-linea-avance-govco");
    headers[indexActive + 1].classList.add("movil-linea-avance-govco");
    headers[indexActive + 2].classList.add("movil-linea-avance-govco");
  }
}

function assignClickMovilHAdvanceLine(headers, indexActive, indexActiveOld) {
  if (indexActive > 0 && indexActive + 1 < headers.length) {
    cleanClassMovilHAdvanceLine(headers);
    console.log(indexActive, indexActiveOld);
    headers[indexActive].classList.add("movil-linea-avance-govco");
    headers[indexActiveOld].classList.add("movil-linea-avance-govco");
    const indexNew =
      indexActiveOld > indexActive ? indexActive - 1 : indexActive + 1;
    headers[indexNew].classList.add("movil-linea-avance-govco");
  }
}

function cleanClassMovilHAdvanceLine(headers) {
  headers.forEach((element) =>
    element.classList.remove("movil-linea-avance-govco"),
  );
}

// LÃ­nea de avance de interacciÃ³n vertical
function nextItemAdvanceLineIVertical(e) {
  const bodyActive = e.target.closest(".body-linea-avance-govco");
  const idParent = bodyActive.getAttribute("data-la-parent");
  const elementParent = document.querySelector(idParent);
  const items = elementParent.querySelectorAll(".item-linea-avance-govco");

  const indexActive = getActiveItemAdvanceLine(items);
  items[indexActive]
    .closest(".item-linea-avance-govco")
    .classList.remove("active-linea-avance-govco");
  items[indexActive]
    .closest(".item-linea-avance-govco")
    .classList.add("checked-linea-avance-govco");
  items[indexActive + 1]
    .closest(".item-linea-avance-govco")
    .classList.add("active-linea-avance-govco");
  items[indexActive + 1]
    .closest(".item-linea-avance-govco")
    .classList.remove("checked-linea-avance-govco");

  updateProgressAdvanceLine(items, indexActive + 1, elementParent, "height");
}

function clickVerticalAdvanceLine(e) {
  const element = e.target;
  const elementParent = element.closest(".item-linea-avance-govco");
  if (elementParent.classList.contains("checked-linea-avance-govco")) {
    const container = e.target.closest(".iv-linea-avance-govco");
    const items = container.querySelectorAll(".item-linea-avance-govco");
    const itemActive = container.querySelector(
      ".item-linea-avance-govco.active-linea-avance-govco",
    );

    itemActive.classList.remove("active-linea-avance-govco");
    itemActive.classList.add("checked-linea-avance-govco");

    elementParent.classList.remove("checked-linea-avance-govco");
    elementParent.classList.add("active-linea-avance-govco");

    const indexActive = getActiveItemAdvanceLine(items);
    updateProgressAdvanceLine(items, indexActive, container, "height");
  }
}
/* ================================= fin linea de avance ==========================================*/